 /*************************************************************************
 *
 * AMIRA CONFIDENTIAL
 * __________________
 *
 *  [2018] - [2019] Amira Learning Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Amira Learning Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Amira Learning Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Amira Learning Incorporated.
 */

import React from 'react';
import {withRouter} from 'react-router';
import Reader from './Reader';
import StoryPicker from './StoryPicker/StoryPicker';
import GradePicker from './StoryPicker/GradePicker';
import GoModal from './GoModal';
import './InactivityModal.scss';
import TutorFTUE from './TutorFTUE';
import {StudentStatus, studentStatusTypes} from './StudentStatus';
import {ErrorModal, getErrorModalTypes} from './ErrorModal';
import WaitModal from './WaitModal';
import {buildSessionAudio,endUniversalSocketSession,startEDMSession,endEDMSession,isSendingComplete,isAdhocSendingComplete,sendingProgress,getUnconstrainedTranscript,getAudioDuration,setNetworkMonitoringService as setSpeechStreamNetworkMonitoring,isLocalAsrPlacementRouteActive,warmLocalAsrForStory,isLocalAsrRuntimeReady,prepareLocalAsrPhraseGraph} from "../../services/SpeechStream";
import { isLocalAsrWarmupSpent } from "../../services/asr/localAsrWarmup";
import { getStoriesByGrade, getStudentMetrics, getUserData, saveAssessmentTiming, calculatePhraseSplits, setSessionActivityId, getStory, endUserSession, setUserData, findFilenames, getUtterance, shouldUseNewSpanishPlacementManagerForCurrentSession} from "../../services/API";
import { statusType } from "../../services/displayStatus";
import { cleanAndSplit, scoreTranscript, calculateSkipMetrics, setSkipWindow, getSkipWindow } from "../../services/NLP";
import { isPhoneme, wordArrayContainsPhonemes } from "../../services/amirabet";
import { convertPhraseIpaToKaldi } from "../../services/PhonemeMapping";
import { calculateFrameTime } from "../../services/frameTime";
import {getIntervention, preflightIntervention, moveOnWithoutSpeaking, resetComprehensionQuizCount, logComprehensionQuizMetrics} from '../../services/interventionManager';
import { getStoryIntervention, getPageIntervention, getKeepReading, getTryAgain, onPhraseInterventionSelected, resetInterventionHistory } from "../../services/interventionSelection.js";
import studentRecordService, { APP_TYPE } from '../../services/StudentRecordService';
import { engagementClock } from '../../services/engagementClock';
import { buildAudioNetworkSignals, mergePhraseSignals } from '../../services/audioNetworkSignals';
import { getStudentReadingLevel, readingLevels, setStudentLevelByGrade, setStudentGradeLevel, getStudentGradeLevel, isStrugglingReader, getWCPMGradePR} from '../../services/readerCharacteristics';
import { acceptTap } from './ReaderUtils';
import {
  initCursorSession,
  setStoryContext,
  isCursorFreeBehavior,
  isTapToReadBehavior,
  getCursorBehavior,
  getBadSignalDecision,
  getBadSignalNotEvaluatedReason,
  refreshCursorSessionForActivity,
  persistBadSignalPlacement,
  shouldUseLocalAsr,
  shouldUseLocalAsrForNextPhrase,
  getLocalAsrWarmupRouteDecision,
  LOCAL_ASR_ROUTE,
  shouldShowCursorBehaviorFTUE,
  clearShouldShowCursorBehaviorFTUE,
  getCursorBehaviorFTUEVariant,
  hasCursorBehaviorFTUECompleted,
  isCursorFreeGradeBandExempt,
  CURSOR_BEHAVIOR,
} from '../../services/CursorOrchestrator';
import { isBadSignalCursorEnabled, isBadSignalLogOnly, buildForcedAudioMetrics } from '../../services/cursor/signalThresholds';
import { recordActivitySignalsForNextActivity } from '../../services/cursor/priorActivitySignals';
import { createStoryLmGraphDownloader } from '../../services/asr/vosk/storyLmGraphDownloader';
import { hasStoryGraph, getStoryPhraseCount, isStoryGraphStorePrimedFor } from '../../services/asr/vosk/voskBiasedGraph';
import { withBudget } from '../../services/asr/withBudget';
import { nextPhraseGraphPrepTarget } from './ReaderManagerLmGraphPrep';
import { recordLocalAsrLifecycle, recordLocalAsrFailure } from '../../services/asr/localAsrLifecycle';
import { clearPlacementClock, setPlacementClock } from '../../services/placementClock';
import {
  downLevelWordsCorrectCriteriaMet,
  ranDownLevelCriteriaMet,
  upLevelCriteriaMet,
  downLevelAccuracyCriteriaMet
} from '../../services/relevelService';
import * as Sentry from '@sentry/browser';
import {clearUtteranceLogs, getUtteranceLogs, logSessionInfo, logSystemData, logInterventionEvent, logStoryMetric, getFormattedUTCDate} from "../../services/logger";
import Loading from "../Global/Loading.js";
import {Button, buttonTypes} from '../Global/Button';
import ProgressBubbles from "../Global/ProgressBubbles.js";
import Timeout from 'await-timeout';
import {
  calculateAccuracyFromScoredTranscript,
  speakChooseStoryMessage,
  calculateMostRecentScores,
  formatStoryErrorsForScoring,
  calculateAccuracy
} from './ReaderLibrary';
import RepeatAfterMe from '../RepeatAfterMe';
import {
  selectPhraseIntervention,
  resetAIFeaturesForNewStory,
  getPauseTime,
  selectWordIntervention,
  resetWordInterventionTracker,
  trackWordIntervention,
  trackWordInterventionPhraseBoundary,
  getIsInReadWithMeMode,
  setCurrentPhrase,
  setDisabledInterventionTypes,
  addInterventionCountForPhrase,
} from '../../services/aiService';
import {
  wordShouldIntervene,
  isStopWord,
  alreadyIntervened,
  wordDidIntervene,
  getLastPhraseOnPageResponse,
  getReadWithMePrompt,
  speakInterventionLeadIn,
  getTooFastPhrases
} from '../../services/interventionSelection';
import {
  getMaskedInterventionTypes,
  DEFAULT_ARM_THRESHOLD,
} from '../../services/interventionMasking';
import {
  interventionType,
  scopeType,
} from '../../constants/interventionSelectionConstants';
import Quiz from '../Quiz/Quiz';
import {READING_MODES, activityStatus, assignmentTypes, contentTags, phraseTypes, earlyReaderContentTagsNoEdm, aosTaskTypes, StudentInboxAssignmentTypes, userTypes, recommendationModes, hasStructuredInstructionsForItemType, ENCODED_RESPONSE_ITEM_TYPES, NO_RESPONSE} from '../../constants/constants';
import { processPotentialAudioIssues } from './audioIssueDetection';
import yay_image from "../../images/yay.png";
import end_assessment_image from "../../images/end_assessment.svg";
import {getActivityStack,addToActivityStack,removeLastActivityFromStack, getActivityObjectStack} from "../App.js";
import AssessmentOrchestrationService, { isMockAOSNow, resetMockAosTestletCursor } from '../../services/AssessmentOrchestrationService';
import AssessmentOrchestrationServiceUtils from '../../services/AssessmentOrchestrationServiceUtils';

import silence from "../../images/silence.mp3";

import {COPY_STRINGS} from '../../constants/translatedCopy';

import {isMicAllowed} from '../../services/environment';
import {abortListen} from '../../services/Listen';
import moment from 'moment';
import { getEarlyReaderMode, isEarlyReaderMode } from 'Services/EarlyReaderService';
import { EarlyReaderStatus } from '../Student/EarlyReader/EarlyReaderStatus';
import {clearEarlyReader, flagNewEarlyReader,clearEarlyReaderSequenceStart} from "Services/EarlyReaderService";
import {formatLocale_UpperCaseUnderscore, formatLocale_LowerCaseHyphen, isSpanishStory} from "Services/locale";
import StruggleMonitor from '../../services/struggle';
import get from 'lodash.get';
import getActivityIntroText from "Services/activityIntroduction";
import { isEarlyReaderStory } from '../../services/EarlyReaderService';
import { updateBatchAssignments } from '../../services/assignment/updateBatchAssignments';
import { skipActivityInManifest, updateManifestItems } from '../../services/assignment/updateManifest';
import { getAssignmentByIdForStudent } from '../../services/assignment/getAssignment/getAssignment';
import ReaderManagerEvents from './ReaderManagerEvents/ReaderManagerEvents';
import cx from 'classnames';
import device from '../../services/device/device';
import { SEGMENT_EVENTS, sendMessageToSqs } from '../../services/segmentService';
import { connect } from 'react-redux';
import { clearEndingSequence, logReaderManagerEvents, updateContextStates } from './ReaderManagerEvents/ReaderManagerSlice';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import NetworkMonitoringService, { NetworkStatus } from '../../services/NetworkMonitoringService';
import { updateErssStatus } from '../../services/erssService';
import { getAccessKeyByStudentId } from "../../services/iesAccessKeyService";
import { logSentryException, parseSkipTranslationTags, withTimeout } from '../../services/util';
import { getPhonemePlacementEnabled } from './Speech/Speech';
import { FEATURE_FLAGS, FORCE_BAD_SIGNAL_AUDIO } from '../../constants/featureFlags.js';
import { LOW_VOLUME_CHECK_THRESHOLD } from '../../constants/audioDetectorThresholds';
import { handleAssessmentTimerExpiry } from './assessmentTimerExpiry.js';
import { withCurrentStoryWordMetadata } from '../../context/CurrentStoryMetadataContext';
import { RetryNetworkReconnectModal } from './RetryNetworkReconnectModal.js';
import { CriticalNetworkModal } from './CriticalNetworkModal.js';
import { GetBrandedTutorName } from '../../services/BrandingService';
import { getScreeningWindow } from '../../services/screeningWindowService.js';
import {PredictionQuestion, allSyllableAudioAvailable} from "amira-intervention-library";
import Interaction from "Components/Interaction/Interaction";
import ReaderManagerEventConstants from './ReaderManagerEvents/ReaderManagerEventConstants.js';
import { isItemTutorUpAndDown, shouldEnablePhonemePlacement, shouldDeferLowEffortAdvance } from './ReaderManagerUtil.js';
import StudentInformationService from '../../services/StudentInformationService';
import { setUseGenerativeVoiceGlobal } from '../../services/generativeVoiceService.js';
import { getCopyByGradeband } from '../../services/ThemingService.js';
import { EXTEND_ASSESSMENT_TIME_TAG } from '../../constants/constants.js';
import { getRandomDistractorImages } from '../../services/WordMetadataService.js';
import { shouldHandleNetworkStatusChange, shouldRunNetworkRecoveryActions, resolvePausedNormalAction, PausedNormalAction } from './ReaderManagerNetworkStatus';
import { getStoryContentLocale, getStoryContentLocaleOrNull } from '../../services/playMarkupSequence';
import { isSpanishAsrCheckStoryId } from '../../constants/asrCheckStories';

const PromisePool = require('@supercharge/promise-pool');
const unidecode = require('unidecode');

const minPhraseTimes = { //the minimum amount of time to display a phrase. TODO: This should be moved to config and perhaps pulled from the story data itself
  dyslexiaWord: 4000,
  nwf: 5500,
  earlyReaderWord: 2000,
  nonsenseWordRepetition: 7000,
  default: 3000
};

/** Minimum string-similarity threshold for Spanish pilot fuzzy matching (NLP: stripDiacritics). */
const SPANISH_FUZZY_MATCH_THRESHOLD = 0.55;

// GT-400: which path forced the skip past the first-word guard (see shouldForceFirstWordSkip).
export const FORCED_FIRST_WORD_SKIP_SOURCE = Object.freeze({
  PAUSE: 'pause',
  LONG_PAUSE: 'longPause',
});

// Testlet type -> item type -> min phrase time
const aosMinPhraseDefaultTimes = {
  ran: { RAN: 15000 },
  letterName: { sound: 3000 },
  letterSound: { sound: 3000 },
  beginningLetterSound: { sound: 3000 },
  upAndDown: { upAndDown: 6000 },
  wif: { word: 4000 },
  nwf: { word: 6000 },
  wordPartDeletion: { wordPartDeletion: 4000 },
  changeOnePart: { changeOnePart: 4000 },
  assessment: { assessment: null },
  blending: { blendingSelection: null },
  spelling: { textInput: null },
  retell: { retell: null },
  shortAnswer: { freeAnswer: null },
  formative: { freeAnswer: null },
  readingComprehension: { readingComprehension: null },
  quiz: { quiz: null },
}
const struggleMonitor = new StruggleMonitor();
const TYPE_OF_PHRASE_TO_IGNORE_MIN_TIME_ELAPSED = [
  "blendingSelection",
  "retell",
  "freeAnswer"
];

function audioNetworkSignalsFingerprint(payload) {
  if (!payload) return '';
  return JSON.stringify({
    badCount: payload.badCount,
    monitoringActive: payload.monitoringActive,
    isLowVolume: payload.isLowVolume,
    flatlineMaxRunSec: payload.flatlineMaxRunSec,
    phrases: payload.phrases,
  });
}

function graphQLErrorMessage(error) {
  if (typeof error?.message === 'string' && error.message) {
    return error.message;
  }
  if (error?.errors) {
    return JSON.stringify(error.errors);
  }
  try {
    return JSON.stringify(error);
  } catch (_err) {
    return String(error);
  }
}

let timings = [{time:0, position:0}];
let inProgressTimingSlices = [];
let wav2vecPhonemes = [{time: 0}];
let overallPosition = 0;
let recordingStart = 0;
let lastRecordingStop = 0;
let timeBetweenPages = 0;
let totalTimeSpentIntervening = 0;
let phraseTimeSpentIntervening = 0;
let interventionHoldoffs = 0;
const maxInterventionHoldoffs = 5;
let isWordInterventionInProcess = false;

//Timing
let errordelay = 0;
let lastDelay = 0.0;
let averageDelay = 0;
let phraseDelays = [];
let predictionConfidences = [];
let edmTimeout=null;
let pauseTimerStack=[];
let phraseStartTime = 0;
let stopTime = 0;
let interventionTime = 0;

let handledErrors = false;
let previousOverallPhraseIndex = -1;
let overallPhraseIndex = 0;

// TT-1283: how long the end-of-phrase preparation waits for a missing next-phrase LM
// graph to re-download before routing that phrase to server Kaldi. Kept small: the wait
// overlaps end-of-phrase scoring/intervention selection (timers paused, no Next button),
// and server ASR is the immediate escape hatch, so a weak network never stalls the child.
const LM_GRAPH_REPRIME_BUDGET_MS = 3000;

let badNetworkNeedsCriticalResponse = false;
let badNetworkInterval;
let badNetworkPauseReadingTimeout;
let badNetworkRetryPauseTimeout;
let badNetworkCriticalTimeout;
let badNetworkPauseListeningTimeout; // The delayed re-startListening inside pauseFromBadNetwork; tracked so recovery can cancel it
let phrasesWithAutoProgressedWords = {};

const relevelTimer = new Timeout();
const assessmentTimer = new Timeout();

//TODO: Move to a placement manager service.
let expectedWord = '';
let struggleType = struggleMonitor.Attempt.SUCCEED;
const defaultLastProgress = {transcriptLength: 0};

const LOW_VOLUME_CALLS_TIMEOUT = 10000;
const HIGH_VOLUME_CALLS_TIMEOUT = 16000;

// How long launchAsrCheckStory will wait on its measurement-only story fetch before giving
// up and launching unmeasured. Not a correctness bound — the fetch is best-effort and its
// failure path already exists — but the only leg of that hold without a deadline of its
// own, since StudentRecordService.getStory retries with backoff. Deliberately not
// calibrated against that retry chain: the attempts have no per-request timeout, so on a
// slow network this realistically covers about one of them. It is a cap on how long the
// student stares at the spinner for an optimization, not a fetch budget.
const ASR_CHECK_STORY_FETCH_BUDGET_MS = 4000;

const STRICT_LOW_VOLUME_CHECK_ACTIVITY_TYPES = [
  "letterSound",
  "letterName",
  "nwf",
  "wif",
  "wordPartDeletion",
  "nonsenseWordRepetition",
  "changeOnePart",
  "beginningLetterSound",
  "letterNamingAndSounds",
];

const STRICT_LOW_VOLUME_CHECK_THRESHOLD = 1; // 100% rms flag
// LOW_VOLUME_CHECK_THRESHOLD is imported from constants/audioDetectorThresholds: TT-991's stored
// path re-applies the same share, and the two readings must not differ.
const BAD_CLIPPED_SEGMENTS_ACTIVITY_THRESHOLD = 3; // isClipped fires at this many bad clip windows

class ReaderManager extends React.Component {
  constructor (props){
    super(props);

    // Track whether component is mounted to prevent operations after unmount
    this._isMounted = true;

    // Timeout Refs
    this.phraseTimeoutRef = React.createRef();
    this.minTimeTimerRef = React.createRef(); // holds a reference to the timer that will be used to ensure that the minimum amount of time for a phrase to display has elapsed
    this.nextButtonTimerRef = React.createRef(); // holds a reference to the "Next" button timer for cursor-free students
    this.tapToReadNextButtonTimerRef = React.createRef(); // holds a reference to the 3-second timer for tap-to-read Next button
    this.inactivityTimeoutRef = React.createRef(); // holds a reference to the inactivity timeout timer for "Are you still here?" modal
    this.delayedPageEndTimeoutRef = React.createRef(); // holds a reference to the delayed page end timer (1.5s after end-of-page)
    this.nextButtonReminderTimerRef = React.createRef(); // holds a reference to the 20s Next button reminder timer

    this.pauseLength = this.props.config.interventionTimeout;  // pause length in MS.
    this.giveUpLength = this.props.config.giveUpLength;    //this.interventionPauseLength = 6000;  // the amount of time to wait between saying 'mmhmm' and triggering a word intervention if no progress has been made

    this.disableInterventionsForPhrase = false;
    // GT-400: opt-in, set only by phrase items (Change One Part, SingleWord) that disable
    // interventions and have no other exit when the first word of a story is never recognized.
    this.allowFirstWordSkipOnPause = false;
    
    // Track the last phrase index that started the onPhraseEnd process
    // to prevent stale callbacks from previous phrases (instance variable to avoid state race conditions)
    this.lastEndedPhrase = -1;
    
    // Track when we're waiting for inactivity modal dismissal to trigger re-read
    this.waitingForInactivityModalDismissal = false;
    
    // Store phrase index when inactivity modal is triggered (for consistent logging)
    this.inactivityModalPhraseIndex = null;
    
    // Store callback to execute after FTUE completes
    this.ftueCallback = null;
    
    // Store the FTUE type to show ('cursor-free' or 'tap-to-read')
    this.tutorFTUEMode = null;

    // TT-1344: UTC day folder (YYYY-MM-DD) pinned once when the current activity's
    // activity_created milestone is written, so every later milestone for the same activity
    // lands in the same day folder even if the session crosses midnight UTC. Null until the
    // first milestone of an activity is logged.
    this.storyMetricsDateFolder = null;
    
    // Track if the current phrase ended via the Next button (for cursor-free students)
    // Used to determine if EDM all-TRUE scenario should trigger a retry
    this.phraseEndedViaNextButton = false;
    
    // Track the last interim transcript to ensure we only trigger UNK fallback when transcript is growing
    this.lastInterimTranscript = '';
    
    // Track the last word index where UNK fallback intervention occurred to prevent skip backs
    this.lastUNKFallbackIndex = -1;

    // TT-1283: story-relative phrase indices that must decode on server Kaldi because they
    // have no usable biased LM graph (see _prepareNextPhraseBiasedGraph). The marks are
    // TAGGED with the story they belong to (_serverPlacementStoryId): reads ignore a mark
    // whose storyId does not match the active story, and a write for a new story resets the
    // set. So marks are self-scoping — they are NOT cleared on story change (doing so would
    // wipe the phrase-0 decision written behind the loader before the story reaches props),
    // and — for the same read-after-write reason — they must NOT be cleared per phrase: the
    // decision written at the end of phrase N is read when phrase N+1 arms, so a nextPhrase
    // clear would wipe it (page changes preserve them too; see handlePageChange).
    this._serverPlacementPhrases = new Set();
    this._serverPlacementStoryId = null;

    //Utterance constants for pre load
    this.selfAssignedIntro = COPY_STRINGS.amira_intro(GetBrandedTutorName()) + "<break time=\"1.8s\"/> ";
    this.devIntro = "<speak>" + COPY_STRINGS.abbreviated_instructions + "</speak>";

    let sessionData = getUserData();
    this.state = {
      currentPhraseIndex: 0,              // the array index of the phrase currently being read
      currentWordIndex: 0,                // the index of the current word within the current phrase
      errors: [[[]]],                     // an array of the results so far. indexed as follows: errors[page][phrase][word]
      simpleErrors: [[[true]]],           // NOTE populate this with one value to start in case the kid gives no responses at all, so that the graphql call doesnt break
      errorCount: [],                     // The count of errors in each phrase
      interventionWordIndex: -1,          // index of a word to highlight for intervention
      phraseTimes: [[]],                  // amount of time it took the reader to read each phrase
      lastProgress: defaultLastProgress,                   // an object containing the most recent length of the transcript,
                                          // and the time at which the most recent word was recorded. Used to detect pauses
      activityId: sessionData.id,  // activityID populated by 'createActivity' call. This is a placeholder
      modal: null,
      endOfPhrase: false,
      waitingForFinalTranscript: false,
      recommendedStories: null,
      mounted: false,
      pauseLength: this.props.config.mediumReaderPauseTime,  // pause length in MS.
      giveUpLength: this.props.config.giveUpLength,
      matchThreshold: 0.5,
      repeateAfterMeInterventionInProcess: false, //Indicates that the clap aka repeat after me intervention is active
      startReadingTimer: null,
      noAudioTimer: null,
      callbackAfterIntervention: null,
      interveningAtEndOfPage: false,
      wpm: 0,
      wcpm: 0,
      accuracy: 0,
      studentStatusPhrases: [],
      matchTimeout: null,
      testTimeExpired: false,
      recordingID: 0,
      showNextButton: false,  // Controls visibility of "Next" button for cursor-free students
      lastWordInterventionIndex: -1,
      prevSkipMetrics: {skipLength: 0, matchLength: 0},
      error: false,
      isFinal: false,
      stylingErrors: [[[]]],
      textResponse: [[[""]]],           // NOTE populate this with one value to start in case the kid gives no responses at all, so that the graphql call doesnt break
      phraseComplete: false, //whether or not the reader has reached the end of the phrase. This is needed because if min time has not elapsed when the reader reaches the end of the phrase, we will wait for minTime to elapse before proceeding
      minTimeElapsed: false, //whether or not the minimum amount of time for the phrase to display has elapsed. TODO: clean up in timer refactor
      pageNavRestrictedTimeout: null,
      pageNavEnabled: false,
      pageNavLastClick: null,
      pageNavTriggered: false,
      frustrationLevelChecked: false,
      storyStarted: false,
      storyLoaded: false,
      storyInProgress: false,
      storyEnded: false,
      phraseEnded: false,
      detections: null,
      paused: false,
      didSaySomething: false,
      phraseTimeManagementDisabled: false,
      displayContainer: true,
      isFirstAssessmentItemOfType: true,
      isLoading: false,
      doNotRelevel: false,
      /** After verbal introductions finish, getRepeatInstructions uses item instructions not intro copy */
      afterIntroVerbalRepeat: false,
      // Per-story LM graph download progress (0..1) shown in the loading overlay
      // while the vosk biased-HCLG files prime; null when no download is running.
      lmGraphProgress: null,
      // Tutor FTUE state
      showingTutorFTUE: false,
    };

    this.openStoryPicker = this.openStoryPicker.bind(this);
    this.readAloudWithCallback = this.readAloudWithCallback.bind(this);
    this.openWordInterventionModal = this.openWordInterventionModal.bind(this);
    this.getCurrentWord = this.getCurrentWord.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setIsLoading = this.setIsLoading.bind(this);
    this.onPauseDetected = this.onPauseDetected.bind(this);
    this.onLongPauseDetected = this.onLongPauseDetected.bind(this);
    this.onBlankAudioDetected = this.onBlankAudioDetected.bind(this);
    this.onNoStories = this.onNoStories.bind(this);
    this.startListening = this.startListening.bind(this);
    this.setStory = this.setStory.bind(this);
    this.selectStory = this.selectStory.bind(this);
    this.selectGrade = this.selectGrade.bind(this);
    this.openGradePicker = this.openGradePicker.bind(this);
    this.setPlacement = this.setPlacement.bind(this);
    this.setMatchThreshold = this.setMatchThreshold.bind(this);
    this.setPauseLength = this.setPauseLength.bind(this);
    this.setGiveUpLength = this.setGiveUpLength.bind(this);
    this.cleanUpAfterIntervention = this.cleanUpAfterIntervention.bind(this);
    this.readAloudIntent = this.readAloudIntent.bind(this);
    this.returnHome = this.returnHome.bind(this);
    this.displayStudentStatus = this.displayStudentStatus.bind(this);
    this.displayEarlyReaderStatus = this.displayEarlyReaderStatus.bind(this);
    this.onSubmitQuiz = this.onSubmitQuiz.bind(this);
    this.continueReading = this.continueReading.bind(this);
    this.onError = this.onError.bind(this);
    this.handleEndOfAssessment = this.handleEndOfAssessment.bind(this);
    this.handleAbortedAssessment = this.handleAbortedAssessment.bind(this);
    this.updateFrameTime = this.updateFrameTime.bind(this);
    this.onDetectionEnd = this.onDetectionEnd.bind(this);
    this.updateScoring = this.updateScoring.bind(this);
    this.onErrorsAreValid = this.onErrorsAreValid.bind(this);
    this.onErrorsAreValidSafe = this.onErrorsAreValidSafe.bind(this);
    this.restartAssignment = this.restartAssignment.bind(this);
    this.phraseStartCallback = this.phraseStartCallback.bind(this);
    this.nonAudioPhraseStartCallback = this.nonAudioPhraseStartCallback.bind(this);
    this.pausePhrase = this.pausePhrase.bind(this);
    this.resumePhrase = this.resumePhrase.bind(this);
    this.launchNextAssignment = this.launchNextAssignment.bind(this);
    this.onPhraseTimeout = this.onPhraseTimeout.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.resetPhraseTimeout = this.resetPhraseTimeout.bind(this);
    this.startPhraseTimeout = this.startPhraseTimeout.bind(this);
    this.clearPhraseTimeout = this.clearPhraseTimeout.bind(this);
    this.skipWord = this.skipWord.bind(this);
    this.abortIntervention = this.abortIntervention.bind(this);
    this.onInterventionEnd = this.onInterventionEnd.bind(this);
    this.finalizeTutor = this.finalizeTutor.bind(this);
    this.finalizeAssessment = this.finalizeAssessment.bind(this);
    this.checkPageNavEnabled = this.checkPageNavEnabled.bind(this);
    this.onNextPageClick = this.onNextPageClick.bind(this);
    this.calculateWordsCorrect = this.calculateWordsCorrect.bind(this)
    this.getRepeatIntro = this.getRepeatIntro.bind(this);
    this.isEarlyReader = this.isEarlyReader.bind(this);
    this.handleDefaultPauseDetected = this.handleDefaultPauseDetected.bind(this);
    this.doneHandlingPause = this.doneHandlingPause.bind(this);
    this.startMinTimeTimer = this.startMinTimeTimer.bind(this);
    this.clearMinTimeTimer = this.clearMinTimeTimer.bind(this);
    this.calculateNextButtonTimeout = this.calculateNextButtonTimeout.bind(this);
    this.startNextButtonTimer = this.startNextButtonTimer.bind(this);
    this.clearNextButtonTimer = this.clearNextButtonTimer.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.calculateInactivityTimeout = this.calculateInactivityTimeout.bind(this);
    this.startInactivityTimer = this.startInactivityTimer.bind(this);
    this.clearInactivityTimer = this.clearInactivityTimer.bind(this);
    this.showInactivityModal = this.showInactivityModal.bind(this);
    this.enableInactivityModalButton = this.enableInactivityModalButton.bind(this);
    this.dismissInactivityModal = this.dismissInactivityModal.bind(this);
    this.playEndOfPhraseSequence = this.playEndOfPhraseSequence.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.advanceOneWord = this.advanceOneWord.bind(this);
    this.onWordTapped = this.onWordTapped.bind(this);
    this.setDisableInterventionsForPhrase = this.setDisableInterventionsForPhrase.bind(this);
    this.setAllowFirstWordSkipOnPause = this.setAllowFirstWordSkipOnPause.bind(this);
    this.calculateScoresAndLaunchWordIntervention = this.calculateScoresAndLaunchWordIntervention.bind(this);
    this.onStoryEnd = this.onStoryEnd.bind(this);
    this.onTestletEnd = this.onTestletEnd.bind(this);
    this.getCurrentERSSInterventionTypes = this.getCurrentERSSInterventionTypes.bind(this);
    this.onStoryFetchFailure = this.onStoryFetchFailure.bind(this);
    this.onRecFetchFailure = this.onRecFetchFailure.bind(this);
    this.onPutActivityFailure = this.onPutActivityFailure.bind(this);
    this.handleNetworkStatusChange = this.handleNetworkStatusChange.bind(this);
    this.resumeFromBadNetworkAutoProgress = this.resumeFromBadNetworkAutoProgress.bind(this);
    this.pauseFromBadNetwork = this.pauseFromBadNetwork.bind(this);
    this.resumeFromBadNetworkPause = this.resumeFromBadNetworkPause.bind(this);
    this.handleRetryBadNetworkPauseState = this.handleRetryBadNetworkPauseState.bind(this);
    this.handleBadNetworkCriticalState = this.handleBadNetworkCriticalState.bind(this);
    this.pausePhrase = this.pausePhrase.bind(this);
    this.resumePhrase = this.resumePhrase.bind(this);
    this.getInterventionSelectionV2Params = this.getInterventionSelectionV2Params.bind(this);
    this.getUserDataParams = this.getUserDataParams.bind(this);
    this.phraseRespectsMinTimeElapsed = this.phraseRespectsMinTimeElapsed.bind(this);
    this.getCurrentPhraseMetaData = this.getCurrentPhraseMetaData.bind(this);
    this.shouldUpLevel = false;
    this.shouldDownLevel = false;
    this.builtRecordingMeta = null;
    // Guard flag to prevent multiple calls to onBlankAudioDetected during rapid componentDidUpdate cycles.
    // This prevents the LocalRecordingView from being unmounted/remounted repeatedly during async initialization.
    this._blankAudioTriggered = false;
    this.handlePhraseSplits = this.handlePhraseSplits.bind(this);
    this.initializeAssessmentStory = this.initializeAssessmentStory.bind(this);
    this.updateAssessmentStory = this.updateAssessmentStory.bind(this);
    this.clearAssessmentStoryTimeouts = this.clearAssessmentStoryTimeouts.bind(this);
    this.getExpectedArrayResponse = this.getExpectedArrayResponse.bind(this);
    this.reLevel = this.reLevel.bind(this);
    this.isERSSStory = this.isERSSStory.bind(this);
    this.getRecommendedStoriesAndOpenPicker = this.getRecommendedStoriesAndOpenPicker.bind(this);
    this.shouldWaitForAsrConnection = this.shouldWaitForAsrConnection.bind(this);
    this.shouldShowInterPhraseLoader = this.shouldShowInterPhraseLoader.bind(this);
    this.isStandardPhrase = this.isStandardPhrase.bind(this);
    this.onTutorFTUEComplete = this.onTutorFTUEComplete.bind(this);
    this.clearTapToReadInterventionFlag = this.clearTapToReadInterventionFlag.bind(this);
    this.startTapToReadInterventionTimeout = this.startTapToReadInterventionTimeout.bind(this);
    this.setTapToReadInterventionFlag = this.setTapToReadInterventionFlag.bind(this);
    // Per-story vosk LM graph downloads (dedup, progress ownership, store lifecycle)
    this.lmGraphDownloader = createStoryLmGraphDownloader();
    
    // Tap-to-read: Instance-level flag to block taps during word-level interventions
    // Prevents race condition where tap and intervention both advance the cursor
    this.tapToReadInterventionInProgress = false;
    this.tapToReadInterventionTimeoutRef = null;
  }

  /**
   * Time on the axis every `timings` entry is stamped on: milliseconds into the story's
   * recorded audio, less intervention time, page-turn gaps, and trimmed silence. This is
   * the axis calculatePhraseSplits slices the recording against, which is why it is
   * neither wall clock nor phrase-relative.
   *
   * Assumes recording is underway, as both `timings` call sites do. The registration in
   * componentDidMount wraps this in the availability check the ASR layer needs.
   * @param {{timingOffset: number}} [silentSegments]
   * @returns {number}
   */
  getPlacementTime(silentSegments = this.props.speech.silentSegments()){
    return Date.now() - totalTimeSpentIntervening - recordingStart - timeBetweenPages - silentSegments.timingOffset;
  }

  componentDidMount(){
    // Compute session-level cursor behavior eligibility and FTUE state once per mount.
    // This determines whether the student gets standard cursor, cursor-free, or tap-to-read mode.
    // Legacy rules only: the TT-991 bad-signal branch decides per tutor activity, in selectStory,
    // and has no activity to decide for yet. Run here it would latch the session before the first
    // story and log that story as a recall with nothing classified.
    initCursorSession({ badSignal: false });
    this.lastTapAdvanceAt = 0;

    // Publish the `timings` axis so the local ASR layer can stamp its raw engine
    // snapshots on it — neither the ASR handler nor SpeechStream can see any of the
    // values it is built from. Guarded rather than raw: before recording starts or
    // while Speech is tearing down there is no meaningful placement time, and a late
    // snapshot must fall back to its own axis instead of reporting a bogus offset.
    this.placementClockToken = setPlacementClock(() => {
      const silentSegments = this.props.speech?.silentSegments?.();
      return recordingStart && silentSegments ? this.getPlacementTime(silentSegments) : null;
    });

    // Sync story context from props in case we mounted with a story already loaded --
    // componentDidUpdate only fires on later changes, not the initial render
    setStoryContext({ isERSS: this.isERSSStory(this.props.story) });

    // Catch-all LM graph prime for stories that arrive via props instead of
    // selectStory (fire-and-forget; the per-story guard dedups against selectStory's
    // awaited prime, and late graphs upgrade mid-story).
    // Skipped on the ASR-check path, where launchAsrCheckStory below owns an awaited
    // prime-and-warm: two chains for two different stories would race, and whichever
    // reached startWarmup first would spend the once-per-session latch on the wrong
    // story. Defensive rather than a live fix — props.story is null here on that path.
    if (!this.isAsrCheckPath) {
      this.primeAndWarmStoryFromProps(this.props.story);
    }

    // Expose onPhraseTimeout method to parent components via ref
    // Set here instead of constructor to ensure all methods are fully initialized
    if (this.props.readerManagerRef) {
      this.props.readerManagerRef.current = {
        onPhraseTimeout: this.onPhraseTimeout
      };
    }

    // expose the read aloud function so that other components can trigger an intervention
    this.props.setInterventions({
      readAloud: this.readAloudWithCallback,
      openWordInterventionModal: this.openWordInterventionModal,
      getCurrentWord: this.getCurrentWord,
    });

    this.loadPotentialUtterances();
    this.setPhraseGrammar(0);

    if(this.props.speech && this.props.speech.resetTranscript){
      this.props.speech.resetTranscript();
    }

    //Make sure we channel the transcript to ReaderManager when it's first mounted
    if(!this.props.isReaderActive){
      this.props.unMuteReader();
    }

    // if we are in forced assessment mode, go straight into the assigned story. Otherwise, open the grade picker
    if(/*this.props.forcedAssessment*/false){ //TODO: this is currently bypassed because we don't have grades from SIS. when we do, use this code
      this.selectStory(this.props.forcedAssessment.storyID);
      // todo this is now redundant with the check inside of `openGradePicker`
    } else if(this.isAsrCheckPath){
      // The body is fully try/caught, but the catch itself calls setIsLoading,
      // logSentryException and onStoryFetchFailure — a throw from any of those would be an
      // unhandled rejection with no trace, which is the failure mode this method exists to
      // remove one level up.
      this.launchAsrCheckStory()
        .catch((error) => recordLocalAsrFailure('placement.asrCheckLaunchThrew', {
          storyId: this.props.asrStoryID,
          error: error?.message,
        }));
    } else {
      this.openGradePicker();
    }

    this.setState({
      mounted: true,
    });

    // Network monitoring
    this.networkMonitoringService = new NetworkMonitoringService(this.handleNetworkStatusChange);
    this.resetAudioNetworkSignalsForActivity();
    setSpeechStreamNetworkMonitoring(this.networkMonitoringService);

    if (getUserData().showBadNetworkResponse) {
      // Prefetch bad network pause state speech
      const { locale, bilingualLocale, bilingualMode } = getUserData();
      const inLocale = bilingualMode ? bilingualLocale : locale;
      const includeSpeechMarks = false;
      getUtterance(getCopyByGradeband(COPY_STRINGS, 'paused_from_bad_network_speech'), includeSpeechMarks, inLocale, 10000, true);
      getUtterance(getCopyByGradeband(COPY_STRINGS, 'retry_pause_network_speech'), includeSpeechMarks, inLocale, 10000, true);
      getUtterance(COPY_STRINGS.resume_from_bad_network_speech, includeSpeechMarks, inLocale, 10000, true);
      getUtterance(getCopyByGradeband(COPY_STRINGS, 'critical_network_speech'), includeSpeechMarks, inLocale, 10000, true);
    }
  }

  componentWillUnmount(){
    // Mark component as unmounted to prevent further operations
    this._isMounted = false;

    // Drop the clock before the props it reads go away, so a late ASR snapshot
    // falls back to its own axis instead of reading a torn-down Speech. Passing the
    // token keeps this from clearing a newer reader's registration when a remount is
    // committed ahead of this unmount.
    clearPlacementClock(this.placementClockToken);

    // Drop the story's downloaded LM graphs (in-memory only, never persisted)
    this.lmGraphDownloader.reset();

    // Reset lastEndedPhrase on unmount for cleanup
    this.lastEndedPhrase = -1;
    this.lastInterimTranscript = '';
    this.lastUNKFallbackIndex = -1;
    this._serverPlacementPhrases?.clear();
    this._serverPlacementStoryId = null;
    
    // Clear inactivity modal state
    this.waitingForInactivityModalDismissal = false;
    this.inactivityModalPhraseIndex = null;
    
    // Clear timers
    this.clearDelayedPageEndTimer();
    this.clearNextButtonReminderTimer();
    
    // Tap-to-read: Clear intervention flag and timeout
    this.clearTapToReadInterventionFlag();
    
    console.log('ReaderManager componentWillUnmount - calling abortSpeech');
    this.props.speech.abortSpeech();

    //clear all our timeouts
    this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
    this.state.noAudioTimer && window.clearTimeout(this.state.noAudioTimer);
    this.state.matchTimeout && window.clearTimeout(this.state.matchTimeout);
    edmTimeout && window.clearTimeout(edmTimeout);
    assessmentTimer.clear();
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
    this.state.pageNavRestrictedTimeout && clearTimeout(this.state.pageNavRestrictedTimeout);
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);
    this.nextButtonTimerRef.current && window.clearTimeout(this.nextButtonTimerRef.current);
    this.tapToReadNextButtonTimerRef.current && window.clearTimeout(this.tapToReadNextButtonTimerRef.current);
    this.nextButtonReminderTimerRef.current && window.clearTimeout(this.nextButtonReminderTimerRef.current);
    this.inactivityTimeoutRef.current && window.clearTimeout(this.inactivityTimeoutRef.current);

    if (badNetworkInterval) {
      window.clearInterval(badNetworkInterval);
      badNetworkInterval = undefined;
    }

    if (badNetworkPauseReadingTimeout) {
      window.clearTimeout(badNetworkPauseReadingTimeout);
      badNetworkPauseReadingTimeout = undefined;
    }

    if (badNetworkRetryPauseTimeout) {
      window.clearTimeout(badNetworkRetryPauseTimeout);
      badNetworkRetryPauseTimeout = undefined;
    }

    if (badNetworkCriticalTimeout) {
      window.clearTimeout(badNetworkCriticalTimeout);
      badNetworkCriticalTimeout = undefined;
    }

    if (badNetworkPauseListeningTimeout) {
      window.clearTimeout(badNetworkPauseListeningTimeout);
      badNetworkPauseListeningTimeout = undefined;
    }

    //reset all of our local variables which are not stored in state
    // TODO: figure out how to handle this. Perhaps consolodate them into an object and initialize them in the constructor rather than at the top of the file
    this.clearTimingSessionVariables();
    this.clearInterventionTimer();
    this.stopRelevelTimer();
    recordingStart = 0;
    overallPhraseIndex = 0;

    //Timing
    errordelay = 0;
    lastDelay = 0.0;
    averageDelay = 0;
    phraseDelays = [];
    edmTimeout=null;

    if(this.props.history.action === "POP"){
      logSessionInfo("backButtonPushed", { pathname: this.props.location?.pathname, activityId: this.state.activityId, currentPhraseIndex: this.state.currentPhraseIndex });
      const {pathname} = this.props.location;
      // This line of code will take the user back to the story recommendations instead of the home screen. The reason we don't do it for Early Reader
      //   is that it will simply force the student to restart the activity instead of going back to options, which is confusing for the student.
      if(pathname === "/student/tutor" && this.state.activityId && getUserData().locale === 'en-us' && !this.isEarlyReader()){
        this.props.history.replace('/student/home', {popStateOrigin: '/student/tutor'});
      }
      else if(pathname === "/student/assessment"){
        //endUserSession(); //Bug fix: Leave this in until we can figure out the right way to handle.
      }
    }

    setSpeechStreamNetworkMonitoring(null);
    if (this.networkMonitoringService) {
      this.networkMonitoringService.cleanUp();
    }
  }

  componentDidUpdate(prevProps, prevState){
    // If component has been unmounted, stop all ReaderManager operations
    if (!this._isMounted) {
      return;
    }

    // Keep the orchestrator's story context in sync with story changes that
    // happen outside the openStoryFromID flow (e.g. the asrStoryID path)
    if (prevProps.story !== this.props.story) {
      setStoryContext({ isERSS: this.isERSSStory(this.props.story) });
      // Catch-all LM graph prime for stories that arrive via props: the assessment-direct
      // path never goes through selectStory, so prime here when the story lands in props.
      // Fire-and-forget; deduped per story.
      //
      // On the ASR-check path the graphs are still wanted (they improve the check's own
      // decode) but the WARM must not run from here. launchAsrCheckStory holds warmup
      // behind the spinner, and when it decides not to measure — locale-ineligible, an
      // already-latched SERVER route, a timed-out measurement fetch, or a runtime that was
      // not ready yet, which is live here because the ASR check is the earliest reading
      // moment in the session — it leaves the latch unspent on purpose. Warming from this
      // catch-all in those cases would start an UNHELD run that phrase 0 then cancels: the
      // pre-TT-1217 shape, and worse here than on a normal story, because it competes with
      // the phrase whose accuracy is scored against MINIMUM_ACCURACY_TO_PASS and decides
      // whether the student may proceed at all. Leaving the latch unspent instead means the
      // first real story's selectStory warm measures it properly, behind a loader.
      if (this.isAsrCheckPath) {
        this.downloadStoryLmGraphs(this.props.story)
          .catch((error) => recordLocalAsrFailure('graphs.asrCheckPrimeThrew', {
            storyId: this.props.story?.storyId,
            error: error?.message,
          }));
      } else {
        this.primeAndWarmStoryFromProps(this.props.story);
      }
    }

    this.props.updateWordMetadata(overallPhraseIndex, this.state.currentWordIndex);

    if(this.state.repeateAfterMeInterventionInProcess){
      return;
    }

    // If waitingForAsrConnection changes from true to false, stop loading
    if(prevProps.speech && this.props.speech && 
       prevProps.speech.waitingForAsrConnection && 
       !this.props.speech.waitingForAsrConnection) {
      this.setIsLoading(false);
    }

    // if phoneme placement is enabled for this story type and we just advanced to the next word
    //   of the phrase, check whether we should switch between phoneme mode and blended word mode
    if(this.props.speech.getPhonemePlacementEnabled() && (this.state.currentWordIndex != prevState.currentWordIndex)){
      if(this.shouldListenForPhonemes()){
        this.props.speech.togglePhonemeListeningOn(); //this will do nothing if we're already listening for phonemes
      }
      if(!this.shouldListenForPhonemes()){
        this.props.speech.togglePhonemeListeningOff(); //this will do nothing if we're already using standard placement
      }
    }

    if(this.props.speech.blankRecording && (this.props.speech.blankRecording !== prevProps.speech.blankRecording)) {
      // Skip blank recording check for ASR stories - let StudentASRChecks handle it
      if (!this.props.asrStoryID) {
        logSessionInfo("muted",this.props.speech.silentSegments());
        this.onBlankAudioDetected(statusType.MUTED);
      }
    }

    //If we got new phonemes from wav2vec, fire the struggle monitor.
    let forceTranscriptCheck = false;
    if(JSON.stringify(this.props.abPhonemes) !== JSON.stringify(prevProps.abPhonemes) && this.props.speech.isListening){
      forceTranscriptCheck = true;
      this.evaluateStruggle(this.props.abPhonemes.phon);
    }

    //Handle intervention timer when listening
    if(this.props.speech.isListening != prevProps.speech.isListening){
      // Only respond if we are not in pausedFromBadNetwork state
      if (!this.state.pausedFromBadNetwork) {
        this.handleInterventionTimer();
        if (this.networkMonitoringService) {
          const isListening = this.props.speech.isListening;
          if (!isListening) {
            this.networkMonitoringService.setAudioMonitoringActive(false);
          } else if (!isWordInterventionInProcess) {
            // Only turn on audio monitoring if we're not in the middle of a word intervention
            this.networkMonitoringService.setAudioMonitoringActive(true);
          }
        }
      }

    }

    // Track when transcript is received for ASR checks
    if(this.props.transcript?.interim?.length > 0 || this.props.transcript?.final?.length > 0){
      this.props.updateContextStates({receivedTranscript: true});
      
      // Check if transcript is valid (not just a single <UNK>)
      // Check interim and final independently
      const interimTranscript = (this.props.transcript?.interim || '').trim();
      const finalTranscript = (this.props.transcript?.final || '').trim();
      const isSingleUNK = (str) => str === '<UNK>';
      
      // Valid if either transcript exists and is NOT a single <UNK>
      const interimIsValid = interimTranscript.length > 0 && !isSingleUNK(interimTranscript);
      const finalIsValid = finalTranscript.length > 0 && !isSingleUNK(finalTranscript);
      
      if (interimIsValid || finalIsValid) {
        this.props.updateContextStates({receivedValidTranscript: true});
      }
    }

    //TODO: figure out how to deal with this mess of conditionals
    if((this.props.transcript && this.props.transcript !== prevProps.transcript) || this.state.testTimeExpired || (this.props.numPhonemes > prevProps.numPhonemes) || forceTranscriptCheck){    
      //Only check transcription if we're actively listening. Avoids some race conditions during transitions
      if((((this.props.speech && this.props.speech.isListening)) &&
          (!this.props.modal) && this.props.isReaderActive && !((this.props.transcript.interim == null) && (this.props.transcript.final == null))) ||
          (this.props.numPhonemes > prevProps.numPhonemes) ||
          forceTranscriptCheck){

        if(!this.state.endOfPhrase){
          if(((this.props.numPhonemes > prevProps.numPhonemes) || struggleType === struggleMonitor.Attempt.LOW_EFFECT)&&
            (interventionHoldoffs < maxInterventionHoldoffs) && (this.props.story && this.props.story.type == assignmentTypes.TUTOR)){
            interventionHoldoffs++;
            this.delayInterventionTime();
          }

          if (!isTapToReadBehavior()) { this.checkTranscription(); }
        }
      }
    }

    //if we just loaded speech for the first time, do the initialization
    if(this.props.speech && !prevProps.speech){
      this.props.speech.resetTranscript();
    }

    // if the story has changed, set up a timer to prompt to start reading
    if(this.props.story !== prevProps.story){
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_CHANGE, story: this.props.story.title, });
      this.handleStoryChange();
    }

    // if the page has changed, reset everything
    if(this.props.pageIndex !== prevProps.pageIndex){
      this.handlePageChange();
    }

    if (
      this.state.afterIntroVerbalRepeat &&
      (this.state.currentPhraseIndex !== prevState.currentPhraseIndex ||
        this.props.pageIndex !== prevProps.pageIndex ||
        this.props.story !== prevProps.story)
    ) {
      this.setState({ afterIntroVerbalRepeat: false });
    }

    if(this.state.earlyReaderMode && this.state.earlyReaderMode.readWithMe && this.state.currentPhraseIndex !== prevState.currentPhraseIndex){
      this.repeatAfterMeMode();
    }

    // if the stories have loaded, start preloading audio for the story picker
    if(this.state.recommendedStories !== prevState.recommendedStories){
      this.loadPotentialUtterances();
    }
  }

  getRepeatIntro() {
    return "<speak>" + COPY_STRINGS.relevel_instructions + "</speak>";
  }

  isEarlyReader() {
    if(this.props.story) {
      if(isEarlyReaderStory(this.props.story)) {
        return true;
      }
    }
    return false;
  }

  handlePageChange(){
    // NB: _serverPlacementPhrases is deliberately NOT cleared here (TT-1283). It is keyed by
    // story-wide overallPhraseIndex, which does not reset across pages within a story, so a
    // page change must preserve the per-phrase server-placement marks. Cross-story staleness
    // is handled by the _serverPlacementStoryId tag (reads ignore a mismatched storyId) plus
    // the write-time reset — not by clearing here.
    this.setState({
      currentPhraseIndex: 0,
      phraseEnded: false,
      pageNavTriggered: false,
      pageNavRestrictedTimeout: this.setPageNavRestrictedTimeout(),
      pageNavEnabled: false
    }, () => this.props.config.isReadAloud && this.readAloudIntent());
    this.loadPotentialUtterances(); // if we have new phrases, load their read aloud audio
    this.setPhraseGrammar(0);
  }

  handleStoryChange(){
    // reset word intervention history tracking (for intervention selection within the aiService)
    resetWordInterventionTracker();
    
    // Reset lastEndedPhrase when changing stories
    this.lastEndedPhrase = -1;
    this.lastInterimTranscript = '';
    this.lastUNKFallbackIndex = -1;
    // NB: _serverPlacementPhrases is intentionally NOT cleared here (TT-1283). This runs
    // when the story lands in props — AFTER the awaited launch prep wrote phrase 0's mark
    // behind the loader — so clearing here would wipe that decision before phrase 0 reads
    // it. The _serverPlacementStoryId tag makes a previous story's marks inert instead.

    if(this.props.story.nonAudio && this.props.speech){
      this.props.speech.stopListening();
    }
    this.setPhraseGrammar(0);

    if(this.props.story){
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START });
      this.onStoryStart();
      resetAIFeaturesForNewStory(this.props.story, this.state.activityId);
      const { ARM, locale, sorConfig } = getUserData();
      const armThreshold =
        sorConfig?.instructSyllableInterventionArmThreshold ?? DEFAULT_ARM_THRESHOLD;
      setDisabledInterventionTypes([
        ...new Set([
          ...this.getCurrentERSSInterventionTypes(),
          ...getMaskedInterventionTypes({ locale, ARM, armThreshold }),
        ]),
      ]);
    }
  }

  handleInterventionTimer(){
    if(!this.props.speech.isListening){
      this.clearInterventionTimer();
    }

    if(this.state.noAudioTimer){
      window.clearTimeout(this.state.noAudioTimer);
    }
    let audioTimer = null;

    //Set the intervention timer only if we should
    if(this.props.speech.isListening && !this.state.endOfPhrase && !this.props.modal && this.props.isReaderActive){
      this.startInterventionTimer(null);

      //also set a "long pause" timer to detect a defective session.
      audioTimer = window.setTimeout(this.getPauseCheck(null, this.onLongPauseDetected, "compdidupdate").bind(this), 61000);
    }
    this.setState({
      noAudioTimer: audioTimer,
    });
  }

  clearInterventionTimer(){
    this.setState({paused: false});
    interventionTime = 0;
    if(pauseTimerStack.length){
      pauseTimerStack.map((timer)=>{window.clearTimeout(timer)});
    }
    pauseTimerStack=[];
  }

  startInterventionTimer(lastProgress, override=null){
    this.clearInterventionTimer();
    let delayTime = override ? override : this.state.pauseLength;
    interventionTime = Date.now() + delayTime;
    let newTimer = window.setTimeout(this.getPauseCheck(lastProgress, this.onPauseDetected,"startTimer").bind(this), delayTime);
    pauseTimerStack.push(newTimer);
  }

  delayInterventionTime(){
    if(interventionTime){
      let remainingTime = interventionTime - Date.now();
      let newTime = remainingTime + 1000;
      
      // Ensure newTime is never negative or too small
      // If the timer has already expired or will expire very soon, use a minimum delay
      if (newTime < 1000) {
        newTime = 1000; // Minimum 1 second delay
      }
      
      this.startInterventionTimer(null,newTime);
    }
  }

  clearMinTimeTimer(){
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);
    this.setState({
      minTimeElapsed: false,
    });
  }

  /**
   * Calculates timeout for "Next" button based on student WCPM and phrase word count.
   * Formula: (wordCount / WCPM) * 60 seconds times a delay factor of 1.25
   * Ensures timeout is at least 5 seconds.
   * When WCPM is unavailable or <= 0, falls back to a conservative 20 WCPM assumption
   * (a slow reader) so the formula produces a generous timeout rather than dividing
   * by zero, which would produce Infinity and cause setTimeout to fire immediately (TT-1247).
   * @returns {number} timeout in milliseconds
   */
  calculateNextButtonTimeout(){
    const userData = getUserData();
    const FALLBACK_WCPM = 20;
    const studentWcpm = (userData.WCPM && userData.WCPM > 0) ? userData.WCPM : FALLBACK_WCPM;
    
    // Get word count for current phrase
    const currentPhrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    const wordCount = cleanAndSplit(currentPhrase).length;
    
    // Calculate expected read time based on WCPM
    // Formula: (wordCount / WCPM) * 60 seconds + 5 second buffer
    const expectedSeconds = (wordCount / studentWcpm) * 60;
    const delayFactor = 1.25;
    const totalSeconds = expectedSeconds * delayFactor;
    
    // Ensure timeout respects minimum phrase display time (5 seconds)
    // This prevents the button from appearing before onPhraseEnd can actually proceed
    const minTimeInSeconds = 5;
    const finalSeconds = Math.max(totalSeconds, minTimeInSeconds);
    
    return finalSeconds * 1000; // Convert to milliseconds
  }

  /**
   * Starts the "Next" button timer for cursor-free students.
   * Button appears after expected time to read phrase (based on WCPM).
   */
  startNextButtonTimer(){
    // Only for cursor-free behavior (eligible student, non-ERSS story) in tutor mode.
    // Tap-to-read has its own end-of-phrase button (syncTapToReadNextButton), so skip this
    // cursor-free WCPM timer when tap mode is active (tap wins; never both).
    if (isTapToReadBehavior() || !isCursorFreeBehavior()) {
      return;
    }
    
    // Clear any existing timer
    this.clearNextButtonTimer();
    
    const timeout = this.calculateNextButtonTimeout();
    
    this.nextButtonTimerRef.current = window.setTimeout(() => {
      // Only show button if phrase hasn't been completed yet
      if (!this.state.endOfPhrase) {
        this.setState({ showNextButton: true }, () => {
          logSessionInfo(`next_button_shown_cursor-free_phrase_${overallPhraseIndex}`, {
            phraseIndex: this.state.currentPhraseIndex,
            overallPhraseIndex: overallPhraseIndex
          });

          // Start the 20-second reminder timer after Next button is shown
          this.startNextButtonReminderTimer();
          
          // Start the inactivity timer after Next button is shown
          this.startInactivityTimer();
        });
      }
    }, timeout);
  }

  /**
   * TT-1007: single source of truth for the tap-to-read end-of-phrase Next button.
   * When student reaches the last word, start a 3-second timer before showing the button.
   * This gives the student time to see the last-word highlight before the Next button appears,
   * matching cursor-free behavior parity. The button must be visible exactly when the student
   * has advanced to (or past) the last word AND the 3-second delay has elapsed — so recomputing
   * here both SHOWS it when they reach the end and CLEARS a stale one when they have not.
   * Called at phrase start, pause/resume, and retry so those transitions can never strand the
   * button (visible with no way to have earned it, or hidden with no tappable word left to bring
   * it back). `wordIndex` is passed explicitly by callers that reset the cursor in the same tick
   * (phrase start / retry) so this doesn't depend on setState having flushed yet.
   */
  syncTapToReadNextButton(wordIndex = this.state.currentWordIndex){
    if (!isTapToReadBehavior()) {
      return;
    }
    
    // Clear any existing tap-to-read next button timer
    if (this.tapToReadNextButtonTimerRef.current) {
      window.clearTimeout(this.tapToReadNextButtonTimerRef.current);
      this.tapToReadNextButtonTimerRef.current = null;
    }
    
    const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    const hasReachedLastWord = cleanPhrase.length > 0 && wordIndex >= cleanPhrase.length - 1;
    
    if (hasReachedLastWord) {
      // Student reached last word: start 3-second timer before showing Next button
      this.tapToReadNextButtonTimerRef.current = window.setTimeout(() => {
        // Only show button if phrase hasn't been completed yet
        if (!this.state.endOfPhrase && !this.state.showNextButton) {
          this.setState({ showNextButton: true }, () => {
            logSessionInfo(`next_button_shown_tap-to-read_phrase_${overallPhraseIndex}`, {
              phraseIndex: this.state.currentPhraseIndex,
              overallPhraseIndex: overallPhraseIndex
            });
            
            // Start the 10-second reminder timer after Next button is shown
            this.startNextButtonReminderTimer(10000);
            
            // Start the inactivity timer after Next button is shown
            this.startInactivityTimer(30000);
          });
        }
      }, 3000); // 3 seconds
    } else {
      // Student not at last word yet: hide button if it's showing
      this.clearInactivityTimer();
      this.clearNextButtonReminderTimer();
      
      if (this.state.showNextButton) {
        this.setState({ showNextButton: false });
      }
    }
  }

  /**
   * Clears the "Next" button timer and hides the button.
   */
  clearNextButtonTimer(){
    if (this.nextButtonTimerRef.current) {
      window.clearTimeout(this.nextButtonTimerRef.current);
      this.nextButtonTimerRef.current = null;
    }

    // Clear the tap-to-read next button timer
    if (this.tapToReadNextButtonTimerRef.current) {
      window.clearTimeout(this.tapToReadNextButtonTimerRef.current);
      this.tapToReadNextButtonTimerRef.current = null;
    }
    
    // Clear the inactivity timer
    this.clearInactivityTimer();
    
    // Clear the Next button reminder timer
    this.clearNextButtonReminderTimer();
    
    // Only update state if button is actually showing (avoid unnecessary renders)
    if (this.state.showNextButton) {
      this.setState({ showNextButton: false });
    }
  }

  /**
   * Starts the reminder timer after Next button is shown.
   * Speaks a reminder if student doesn't click the button within the timeout period.
   * @param {number} [customTimeout] - Optional custom timeout in milliseconds. Defaults to 20000ms (20 seconds).
   */
  startNextButtonReminderTimer(customTimeout = undefined){
    // Clear any existing reminder timer
    this.clearNextButtonReminderTimer();
    
    this.nextButtonReminderTimerRef.current = window.setTimeout(() => {
      // Only speak reminder if Next button is still showing
      if (this.state.showNextButton && !this.state.endOfPhrase) {
        const mode = isTapToReadBehavior() ? 'tap-to-read' : 'cursor-free';
        logSessionInfo(`next_button_reminder_spoken_${mode}_phrase_${overallPhraseIndex}`, {
          phraseIndex: this.state.currentPhraseIndex,
          overallPhraseIndex: overallPhraseIndex
        });
        
        this.props.speech.speak({
          textToSpeak: COPY_STRINGS.next_button_reminder,
          locale: getUserData().locale,
        });
      }
    }, customTimeout || 20000); // 20 seconds
  }

  /**
   * Clears the Next button reminder timer.
   */
  clearNextButtonReminderTimer(){
    if (this.nextButtonReminderTimerRef.current) {
      window.clearTimeout(this.nextButtonReminderTimerRef.current);
      this.nextButtonReminderTimerRef.current = null;
    }
  }

  /**
   * Handler for "Next" button click.
   * Mimics natural phrase completion flow by stopping recording and setting endOfPhrase state.
   * Triggers end-of-phrase (EoP) intervention selection pipeline.
   */
  onNextButtonClick(){
    // Enhanced guard: check both flags to prevent race with checkTranscription's 500ms delay
    // waitingForFinalTranscript is set alongside endOfPhrase in handlePotentialEndOfPhrase
    // and protects against the async setState window before endOfPhrase flushes
    if (this.state.endOfPhrase || this.state.waitingForFinalTranscript) {
      return;
    }

    // Tap-to-read: deliberately no tapToReadInterventionInProgress guard here. The button only
    // arms once the cursor reaches the last word (syncTapToReadNextButton, plus a 3s delay), and
    // word-level interventions are suppressed at the last word from both entry points --
    // onWordTapped does not start the intervention timer there, and handleDefaultPauseDetected
    // returns early in tap mode (checked at fire time, so it also catches an already-scheduled
    // timer). A give-word/skip that advances INTO the last word clears the flag before arming the
    // button. So "button visible" and "word intervention in flight" are mutually exclusive.

    // Log the button click with mode and overallPhraseIndex in title
    const mode = isTapToReadBehavior() ? 'tap-to-read' : 'cursor-free';
    logSessionInfo(`next_button_clicked_${mode}_phrase_${overallPhraseIndex}`, {
      phraseIndex: this.state.currentPhraseIndex,
      overallPhraseIndex: overallPhraseIndex
    });

    // Set flag to track that this phrase ended via Next button
    // Used in onErrorsAreValid to detect EDM all-TRUE scenario for retry
    this.phraseEndedViaNextButton = true;
    
    // Clear the Next button timer and hide button
    this.clearNextButtonTimer();
    
    // CRITICAL: Stop recording before proceeding
    // All other EoP paths (skipWord, onPhraseTimeout, checkTranscription) call stopListening
    // to prevent recording contamination during intervention audio
    this.props.speech.stopListening();
    
    // CRITICAL: Roll up intervention timing metrics (like all other EoP paths)
    // This accumulates phraseTimeSpentIntervening into totalTimeSpentIntervening
    // which is used for accurate EDM timing calculations
    // Note: handlePotentialEndOfPhrase() also calls clearInterventionTimer() internally
    this.handlePotentialEndOfPhrase();
    
    // Clear phrase timeout to prevent stale callbacks during the setTimeout below
    this.clearPhraseTimeout();
    
    // Use overallPhraseIndex (module-level, tracks across pages) instead of currentPhraseIndex (page-relative)
    // This ensures the lastEndedPhrase guard in onPhraseEnd works correctly across page boundaries
    const immutablePhraseIndex = Number(overallPhraseIndex);
    const isRecording = this.props.speech.isRecording();

    // Tap mode: pad the last (untapped) word so the client errors array reaches full phrase
    // length before EDM merges in onErrorsAreValid, avoiding the Zero Length Errors warning.
    if (isTapToReadBehavior()) {
      const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
      const phraseErrors = this.getCurrentPhraseErrors() || [];
      if (phraseErrors.length === cleanPhrase.length - 1) {
        phraseErrors.push(false);
        this.setCurrentPhraseErrors(phraseErrors);
      }
    }

    // Trigger end-of-phrase logic (EDM + Mastery Model + Intervention Selection)
    this.onPhraseEnd(isRecording, immutablePhraseIndex);
  }

  /**
   * Calculates inactivity timeout for "Are you still here?" modal.
   * Formula: max(5 × WCPM-based reading time, 60 seconds)
   * When WCPM is unavailable or <= 0, falls back to a conservative 20 WCPM assumption
   * (a slow reader) so the formula produces a generous timeout rather than dividing
   * by zero, which would produce Infinity and cause setTimeout to fire immediately (TT-1247).
   * @returns {number} timeout in milliseconds
   */
  calculateInactivityTimeout(){
    const userData = getUserData();
    const FALLBACK_WCPM = 20;
    const studentWcpm = (userData.WCPM && userData.WCPM > 0) ? userData.WCPM : FALLBACK_WCPM;
    
    // Get word count for current phrase
    const currentPhrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    const wordCount = cleanAndSplit(currentPhrase).length;
    
    // Calculate expected read time based on WCPM
    const expectedSeconds = (wordCount / studentWcpm) * 60;
    const inactivityFactor = 3.75; // 5x the expected read time and this starts 1.25X after the phrase starts (next button timer) and hence 3.75x the expected read time
    const calculatedSeconds = expectedSeconds * inactivityFactor;
    
    // Ensure timeout is at least 60 seconds
    const minInactivitySeconds = 60;
    const finalSeconds = Math.max(calculatedSeconds, minInactivitySeconds);
    
    return finalSeconds * 1000; // Convert to milliseconds
  }

  /**
   * Starts the inactivity timer for "Are you still here?" modal.
   * Timer starts when Next button is shown and triggers modal if student doesn't respond.
   * @param {number} [customTimeout] - Optional custom timeout in milliseconds. Defaults to calculated timeout based on student WCPM.
   */
  startInactivityTimer(customTimeout = undefined){
    // Only for cursor-free behavior (eligible student, non-ERSS story) in tutor mode OR tap-to-read mode
    if (!isTapToReadBehavior() && !isCursorFreeBehavior()) {
      return;
    }
    
    // Clear any existing timer
    this.clearInactivityTimer();
    
    const timeout = customTimeout || this.calculateInactivityTimeout();
    
    this.inactivityTimeoutRef.current = window.setTimeout(() => {
      // Only show modal if phrase hasn't been completed yet and Next button is still showing
      if (!this.state.endOfPhrase && this.state.showNextButton) {
        this.showInactivityModal();
      }
    }, timeout);
  }

  /**
   * Clears the inactivity timer.
   */
  clearInactivityTimer(){
    if (this.inactivityTimeoutRef.current) {
      window.clearTimeout(this.inactivityTimeoutRef.current);
      this.inactivityTimeoutRef.current = null;
    }
  }

  /**
   * Clears the delayed page end timer.
   */
  clearDelayedPageEndTimer(){
    if (this.delayedPageEndTimeoutRef.current) {
      window.clearTimeout(this.delayedPageEndTimeoutRef.current);
      this.delayedPageEndTimeoutRef.current = null;
    }
  }

  /**
   * Shows the inactivity modal after timeout.
   * First shows loading modal (via onPhraseEnd's existing logic) while EDM processes,
   * then displays the inactivity modal when ready.
   */
  showInactivityModal(){
    // Capture phrase index at time of modal trigger (global can change during processing)
    const immutablePhraseIndex = Number(overallPhraseIndex);
    
    const mode = isTapToReadBehavior() ? 'tap-to-read' : 'cursor-free';
    logSessionInfo(`inactivity_modal_triggered_${mode}_phrase_${immutablePhraseIndex}`, {
      phraseIndex: this.state.currentPhraseIndex,
      overallPhraseIndex: immutablePhraseIndex
    });

    // Set flag to indicate we're waiting for modal dismissal
    this.waitingForInactivityModalDismissal = true;
    
    // Store the phrase index for logging in enableInactivityModalButton
    this.inactivityModalPhraseIndex = immutablePhraseIndex;
    
    // Tap mode: pad the last (untapped) word so the client errors array reaches full phrase
    // length before EDM merges in onErrorsAreValid, avoiding the Zero Length Errors warning.
    // This mirrors the logic in onNextButtonClick() since inactivity also ends the phrase.
    if (isTapToReadBehavior()) {
      const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
      const phraseErrors = this.getCurrentPhraseErrors() || [];
      if (phraseErrors.length === cleanPhrase.length - 1) {
        phraseErrors.push(false);
        this.setCurrentPhraseErrors(phraseErrors);
      }
    }
    
    // Stop the mic and call onPhraseEnd to process the phrase (for scoring)
    // onPhraseEnd will show the loading modal automatically
    // We'll ignore the intervention decision and always trigger re-read on dismissal
    this.onPhraseEnd(this.props.speech.isRecording(), immutablePhraseIndex);
  }

  /**
   * Shows the inactivity modal after EDM processing completes.
   * Called from handleEndOfPhraseInterventions after phrase is scored.
   * Replaces the loading modal with the inactivity modal.
   */
  enableInactivityModalButton(){
    // Clear loading modal
    this.setIsLoading(false);
    
    const mode = isTapToReadBehavior() ? 'tap-to-read' : 'cursor-free';
    logSessionInfo(`inactivity_modal_shown_${mode}_phrase_${this.inactivityModalPhraseIndex ?? overallPhraseIndex}`, {
      phraseIndex: this.state.currentPhraseIndex,
      overallPhraseIndex: this.inactivityModalPhraseIndex ?? overallPhraseIndex
    });
    
    // Amira VO - You seem to be idle for a while. Tap OK to continue reading.
    this.props.speech.speak({
      textToSpeak: COPY_STRINGS.inactivity_modal_voice_over,
      locale: getUserData().locale,
    });
    const modalContent = (
      <div className="inactivityModal labelFontOverride">
        <div className="alert">{COPY_STRINGS.inactivity_modal_alert}</div>
        <div className="explanation">{COPY_STRINGS.inactivity_modal_explanation}</div>
        <div 
          className="primaryButton" 
          onClick={this.dismissInactivityModal}
          {...doNotUseAccessibleStaticElementInteractions({onClick: this.dismissInactivityModal})}
        >
          {COPY_STRINGS.inactivity_modal_button}
        </div>
      </div>
    );
    
    this.openModal(modalContent, {
      closeButton: false,
      backgroundClose: false,
      logName: "inactivityModal",
    });
  }

  /**
   * Dismisses the inactivity modal and triggers a re-read intervention.
   * Always does re-read, never advances to next phrase or triggers other interventions.
   */
  dismissInactivityModal(){
    const mode = isTapToReadBehavior() ? 'tap-to-read' : 'cursor-free';
    logSessionInfo(`inactivity_modal_dismissed_${mode}_phrase_${this.inactivityModalPhraseIndex}`, {
      phraseIndex: this.state.currentPhraseIndex,
      overallPhraseIndex: this.inactivityModalPhraseIndex,
      triggering_reread: true
    });
    
    this.props.closeModal();
    
    // Clear the flag
    this.waitingForInactivityModalDismissal = false;
    
    // Clear any pending end-of-page callback
    this.setState({
      callbackAfterIntervention: null,
      interveningAtEndOfPage: false
    });
    
    // Clear the Next button timer before retry
    this.clearNextButtonTimer();
    
    // Clear any pending delayed page end timer
    this.clearDelayedPageEndTimer();
    
    // Decrement lastEndedPhrase to allow phrase retry (same as read intervention)
    this.lastEndedPhrase = this.lastEndedPhrase - 1;
    
    // Clear loading overlay
    this.setIsLoading(false);
    
    // Abort ongoing speech (modal VO) and wait for it to complete before continuing
    this.props.speech.abortSpeech(() => {
      // After abort completes, start the intervention flow
      // Speak intervention lead-in (e.g., "Let's try that again")
      speakInterventionLeadIn(this.props.speech, interventionType.read);
      
      // Read phrase aloud, THEN trigger retry (same as read intervention)
      this.readAloudWithCallback(this.tryAgain.bind(this));
    });
  }

  startMinTimeTimer(){
    // TODO: take out this special case and start reading this from the storyDB (phrase item object)
    //        ticket AE-2230
    if(this.props.story.nonAudio){
      this.setState({minTimeElapsed: true});
      return;
    }

    //Clear any active timers
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);

    this.minTimeTimerRef.current = window.setTimeout(() => {
      if(this.state.phraseComplete){
        this.setState({minTimeElapsed: true}, () => {
          this.onPhraseEnd(this.state.phraseComplete.isRecording, this.state.phraseComplete.phraseIndex);
        });
      } else {
        this.setState({minTimeElapsed: true});
      }
    }, this.getMinPhraseTime());
    this.setState({minTimeElapsed: false});
  }

  getMinPhraseTime(){
    const item = this.props.story.items ? this.props.story.items[overallPhraseIndex] : null;
    if (item && item.minPhraseTime){
      return this.props.story.items[overallPhraseIndex].minPhraseTime;
    }

    if (this.props.shouldUseAOS) {
      let minStoryTypeTimes = aosMinPhraseDefaultTimes[this.props.story.type];
      if (minStoryTypeTimes && item && item.type) {
        return minStoryTypeTimes[item.type];
      }
    }

    let minTime = minPhraseTimes.default;

    if(item && (item.type === "word" || item.type === "wordPartDeletion" || item.type === "nonsenseWordRepetition" || item.type === "changeOnePart" || item.type === phraseTypes.LETTER_FLIES)){
      if(this.props.story.type === assignmentTypes.NWF){
        minTime = minPhraseTimes.nwf;
      } else if(isEarlyReaderMode(this.state.earlyReaderMode)){
        minTime = minPhraseTimes.earlyReaderWord;
      }else if(item.type === "nonsenseWordRepetition"){
        minTime = minPhraseTimes.nonsenseWordRepetition;
      }else if(this.props.story.type === assignmentTypes.DYSLEXIA){
        minTime = minPhraseTimes.dyslexiaWord;
      }
    }
    return minTime;
  }

  itemTypeUsesArrayResponse(type) {
    return ["visualAttention"].includes(type);
  }

  itemTypeUsesEncodedResponse(type) {
    return ENCODED_RESPONSE_ITEM_TYPES.includes(type);
  }

  /**
   * Returns whether new Spanish PM behavior should be active for the current session.
   * Spanish pilot can use the new PM in assessment; district-license enablement is tutor-only.
   */
  shouldUseNewSpanishPlacementManagerInCurrentSession() {
    return shouldUseNewSpanishPlacementManagerForCurrentSession(this.props.config.assessmentMode, {
      spanishContent: isSpanishAsrCheckStoryId(this.props.asrStoryID),
    });
  }

  // This assumes that full array is in metadata.options, and that phrase is the correct option
  getExpectedArrayResponse() {
    const phraseMetadata = this.getCurrentPhraseMetaData();
    const phrase = this.props.story.phrases[overallPhraseIndex];

    return phraseMetadata.options.map(option => option.key === phrase ? 1 : 0);
  }


  getRecordingProps(){
    const {phraseId, graphSuffix} = this.buildPhraseId(overallPhraseIndex);
    let expectedText = unidecode(this.props.story.phrases[overallPhraseIndex]);
    // TODO: Does this need to be here since it's text based responses?
    if (this.itemTypeUsesArrayResponse(this.getCurrentPhraseMetaData().type)) {
      expectedText = JSON.stringify(this.getExpectedArrayResponse());
    } else if (this.shouldUseNewSpanishPlacementManagerInCurrentSession() && this.isStandardPhrase() && this.props.orfMode && this.props.config.assessmentMode) {
      expectedText = this.getCurrentPage().map(phrase => unidecode(phrase)).join(' ');
    }
    let storyTitle = unidecode(this.props.story.title);

    let recordingProps ={
      phraseIndex: overallPhraseIndex,
      expectedText: expectedText,
      phraseId,
      graphSuffix,
      // tutor upAndDown phrases are scored against server-Kaldi phoneme tokens
      // (e.g. "ch_phon ih_phon k_phon chick"). Local ASR (Vosk word-list grammar)
      // cannot emit those tokens and decodes the isolated sounds to <UNK>, stranding
      // the cursor on the phoneme portion (TT-1285). Flag these phrases so local ASR
      // stays off and server Kaldi owns the whole phrase.
      usesKaldiPhonemePlacement: FEATURE_FLAGS.ENABLE_KALDI_FOR_UPDOWN && isItemTutorUpAndDown(this.props.story, overallPhraseIndex),
      // TT-1283: a phrase marked (at end-of-phrase or story launch) as having no usable
      // biased LM graph routes to server Kaldi rather than the defective word-list grammar.
      // The mark is authoritative — the prep already treated missing bytes / build failure
      // / unsupported runtime as "not decodable", so no store recheck here (a bytes-present
      // recheck would wrongly re-arm local for a build-failed phrase and land on word-list).
      forceServerPlacement: this._needsServerPlacement(overallPhraseIndex),
      storyId: this.props.story.storyId,
      storyTags: this.props.story.tags,
      storyLocale: getStoryContentLocaleOrNull(this.props.story),
      title: storyTitle,
      storyVersion: "1",
      version: "1",
      activityType: this.props.story.type,
      studentId: getUserData().userId,
      flagPhrase: getIsInReadWithMeMode(),
      intervention_data: this.getInterventionSelectionV2Params(),
      user_data: this.getUserDataParams(),
    }

    if (this.state.assessmentTestletId) {
      recordingProps = {
        ...recordingProps,
        testletId: this.state.assessmentTestletId,
        itemId: this.getCurrentPhraseMetaData().itemId,
        gradeLevel: getUserData().actualGrade,
        activityId: this.state.activityId,
      }
    }

    return recordingProps;
  }

  isStandardPhrase(){
    const currentPhraseMetaData = this.getCurrentPhraseMetaData();
    const metadataType = currentPhraseMetaData?.type;

    // Includes: undefined (default), "phrase", and "pictureStoryPage" (picture stories)
    const result = !metadataType || metadataType === 'phrase' || metadataType === 'pictureStoryPage';
    
    return result;
  }

  /**
   * Determines if the current phrase should wait for ASR connection before showing UI
   * and if timeouts should be affected by waitingForAsrConnection state.
   * Only applies to regular reading phrases (type undefined or "phrase") in tutor mode.
   * 
   * @returns {boolean} True if should wait for ASR connection
   */
  shouldWaitForAsrConnection(){
    if (this.props.config.assessmentMode || !FEATURE_FLAGS.WAIT_FOR_ASR_CONNECTION) {
      return false;
    }

    // TT-1283: a phrase routed to server ONLY because its biased graph is unavailable is a
    // convenience server phrase in an otherwise-local session. The socket is effectively
    // instant in prod, so do not hold the loader / run the kickstart poll for it. (This is
    // already the effective behavior in a local session, where shouldUseLocalAsrForNextPhrase
    // returns true below; made explicit so it does not depend on that coincidence.)
    if (this._needsServerPlacement(overallPhraseIndex)) {
      return false;
    }

    // The TRANSIENT question, not shouldUseLocalAsr (TT-1218). This wait exists to make
    // sure Kaldi is ready before the student reads, so what it needs to know is whether
    // THIS phrase is Kaldi's — which includes a session provisionally routed to the
    // server by an overrun warmup that has not settled. shouldUseLocalAsr answers the
    // durable question and would say local there, skipping the wait for a phrase already
    // on its way to the server.
    if (shouldUseLocalAsrForNextPhrase({ storyLocale: getStoryContentLocaleOrNull(this.props.story) })) {
      return false;
    }

    // Don't apply if using GoogleNRT or Spanish placement (these don't use Kaldi ASR)
    const placementConfig = this.props.speech?.getPlacementConfig?.();
    if (placementConfig?.forceGoogleNRT || placementConfig?.useSpanish) {
      return false;
    }

    return this.isStandardPhrase();
  }

  /**
   * Whether the between-phrase loading overlay should be shown when the current
   * phrase ends. The overlay is a pure "loading the next phrase" indicator for
   * the gap between phrases, so it applies to every standard tutor reading phrase
   * regardless of ASR backend (server Kaldi, local browser ASR, Spanish placement,
   * GoogleNRT). It is suppressed only in assessment mode and for non-standard
   * phrases (assessment items, non-audio pages, etc.).
   *
   * This subsumes the older shouldWaitForAsrConnection()-gated behavior:
   * shouldWaitForAsrConnection() can only be true for a non-assessment standard
   * phrase, so this predicate is a strict superset of it — it just also shows the
   * indicator for the non-Kaldi tutor phrases (local ASR, Spanish, GoogleNRT) that
   * have no socket wait.
   *
   * Clear side (unchanged): for non-Kaldi phrases phraseStartCallback clears it
   * when the next phrase begins (its clear is gated on !shouldWaitForAsrConnection(),
   * which is true for them); for Kaldi server phrases componentDidUpdate clears it
   * when waitingForAsrConnection settles.
   *
   * @returns {boolean} True if the inter-phrase loading overlay should be shown.
   */
  shouldShowInterPhraseLoader(){
    return !this.props.config.assessmentMode && this.isStandardPhrase();
  }

  phraseStartCallback(){
    if (!this.shouldWaitForAsrConnection()) {
      this.setIsLoading(false);
    }
    
    // Reset receivedTranscript and receivedValidTranscript at the start of each phrase
    this.props.updateContextStates({receivedTranscript: false, receivedValidTranscript: false});
    
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_START, overallPhraseIndex: overallPhraseIndex});
    
    expectedWord = cleanAndSplit(this.props.story.phrases[overallPhraseIndex])[0];
    
    logSessionInfo(`phrase_start_callback_${overallPhraseIndex}`, {});

    // TT-1344: story-milestone logs for the first two phrases feed tutor abandon-rate
    // tracking (see logStoryMilestone for tutor-only / mic-check gating and date pinning).
    if (overallPhraseIndex === 0 || overallPhraseIndex === 1) {
      this.logStoryMilestone(`phrase_${overallPhraseIndex}_started.json`, {phraseIndex: overallPhraseIndex});
    }

    // Only activate monitoring here if we are already listening. Activating before
    // listening starts made the detector measure the ASR connection handshake
    // (kickstart probe traffic) as if it were network health. When listening starts
    // later, the isListening transition in componentDidUpdate activates monitoring.
    if (this.networkMonitoringService && this.props.speech.isListening) {
      this.networkMonitoringService.setAudioMonitoringActive(true);
    }

    this.clearInterventionTimer();

    const earlyReaderMode = getEarlyReaderMode(this.props.story);
    this.setState({
      pauseLength: this.getStudentPauseTime(),
      earlyReaderMode: earlyReaderMode,
    });

    if(earlyReaderMode.readWithMe){
      this.repeatAfterMeMode();
    }

    let useReadingTimer = false;
    if(overallPhraseIndex === 0){
      this.setState({storyInProgress: true})
      if(earlyReaderMode && earlyReaderMode.wordList){
        logSessionInfo("early_reader_word_list_story_started", {expandedEarlyReaderEnabled: getUserData().expandedEarlyReaderEnabled});
      }
      let startReadingTimer = null;
      if(!this.props.config.assessmentMode){
        console.log("🔵 startReadingTimer")
        this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
        startReadingTimer = window.setTimeout((this.onPauseDetected).bind(this,true),10000);
        useReadingTimer = true;
      }
      this.setState({
        startReadingTimer: startReadingTimer,
        pageNavRestrictedTimeout: this.setPageNavRestrictedTimeout(),
        pageNavEnabled: false
      });
      this.props.speech.setLanguage(getUserData().locale);
    }

    setCurrentPhrase(overallPhraseIndex);

    // Clear prior phrase transcript/state before arming local ASR for the new phrase.
    // Must run before enableRecording(); reset after enableRecording clears shouldRouteAudioToLocalAsr.
    if (this.props.speech && this.props.speech.resetTranscript) {
      this.props.speech.resetTranscript();
    }

    if(this.props.speech && !this.props.story.nonAudio){
      let recordingProps = this.getRecordingProps();

      if(true){//enableRecording){//TODO: Solve this (only used in ReadToMe). ReadToMe should pass the appropriate enableRecording in the props.
        this.props.speech.enableRecording(recordingProps);
        this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.ENABLE_RECORDING });
        if(recordingStart === 0){
          recordingStart = Date.now();
        }
      }
      if(lastRecordingStop){
        timeBetweenPages += Date.now() - lastRecordingStop;
      }
      phraseStartTime = Date.now();

      // check whether we should be listening for phonemes on the first word of the phrase.
      //  If so, enable phoneme listening mode
      const firstWord = this.getCurrentWord(0);
      if(this.shouldListenForPhonemes(firstWord)){
        this.props.speech.togglePhonemeListeningOn();
      }

      // Set the needed variables in Speech for sending audio segments to AOS
      if (this.props.shouldUseAOS) {
        // Only force AOS for non-assessment tasks
        this.props.speech.setForceAOS(this.props.story.type !== aosTaskTypes.assessment, () => {
          this.props.speech.startListening("phraseStartCallback");
        });
      } else {
        const isAtPhraseStart = true;
        const waitForAsr = isAtPhraseStart && !this.props.asrStoryID && this.shouldWaitForAsrConnection();
        this.props.speech.startListening("phraseStartCallback", null, false, false, null, false, true, waitForAsr);
      }
      this.setState({recordingProps: recordingProps}); //Save the props so we can pass them again on a reread.
    }

    // Start timers - they will check waitingForAsrConnection and return early if needed
    // Only start intervention timer if we're not using the startReadingTimer (to avoid doubling up on inactivity timers)
    if (!useReadingTimer) {
      this.startInterventionTimer(null, this.getStudentPauseTime());
    }
    interventionHoldoffs = 0;
    this.startMinTimeTimer();
    this.resetPhraseTimeout(true,useReadingTimer); //NOTE: do this here instead of in getPhraseTimeout so that we can consolidate rerenders

    // Start "Next" button timer for cursor-free students
    this.startNextButtonTimer();
    // Tap-to-read: student is at word 0 on a fresh phrase, so this clears any button left
    // showing from a prior phrase (and shows it immediately only for single-word phrases).
    this.syncTapToReadNextButton(0);

    // Clear the Next button flag when starting a new phrase
    this.phraseEndedViaNextButton = false;
  }

  nonAudioPhraseStartCallback() {
    this.resetPhraseTimeout(true,false);

    if(recordingStart === 0){
      recordingStart = Date.now();
    }
  }

  /**
   * clears timers and timeouts
   */
  pausePhrase(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_PAUSE, overallPhraseIndex: overallPhraseIndex});
    console.log("🔴 pausePhrase")
    this.clearInterventionTimer();
    this.clearMinTimeTimer();
    this.clearPhraseTimeout();
    this.clearNextButtonTimer();
  }

  /**
   * restarts timers and timeouts as if they were just started
   */
  resumePhrase(){
    // Tap-to-read: Only clear intervention flag if no word intervention is in progress.
    // If an intervention is in-flight (e.g., skipWord onEnd callback from bad network auto-progress),
    // let it complete naturally to avoid race condition where tap and intervention both advance.
    if (!isWordInterventionInProcess) {
      this.clearTapToReadInterventionFlag();
    }
    
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_RESUME, overallPhraseIndex: overallPhraseIndex});
    this.startInterventionTimer(null, this.getStudentPauseTime());
    this.startMinTimeTimer();
    this.resetPhraseTimeout();
    this.startNextButtonTimer();
    // Tap-to-read: restore the end-of-phrase button if the student had already tapped to the
    // last word before the pause (e.g. a bad-network pause). Without this the button — the only
    // way to finish the phrase in tap mode — would stay hidden with no tappable word left.
    this.syncTapToReadNextButton();
  }


  setDisableInterventionsForPhrase(disableInterventionsForPhrase){
    this.disableInterventionsForPhrase = disableInterventionsForPhrase;
  }

  setAllowFirstWordSkipOnPause(allowFirstWordSkipOnPause){
    this.allowFirstWordSkipOnPause = allowFirstWordSkipOnPause;
  }

  // GT-301 / GT-400: skipWord never advances the first word of a story unless forced. A phrase item
  // that disables interventions (Change One Part, SingleWord after its scaffold) has no other exit on
  // silence, so an unrecognized first word waited out onLongPauseDetected, whose AUDIO modal restarts
  // the activity -- and ERSS hands back the same locked story, looping the student. Only phrase items
  // that opt in via setAllowFirstWordSkipOnPause get the forced skip, and only in standard-cursor tutor
  // mode with audio actually streaming:
  // - assessment never restarts on a long pause, and its items have their own phrase timeouts;
  // - cursor-free never advances the cursor on a pause, and tap-to-read advances via its Next button;
  // - muted / blank audio is a real mic problem, left to the AUDIO modal and onBlankAudioDetected.
  shouldForceFirstWordSkip(){
    const speech = this.props.speech;
    return this.allowFirstWordSkipOnPause
      && this.disableInterventionsForPhrase
      && !this.props.config.assessmentMode
      && !isCursorFreeBehavior()
      && !isTapToReadBehavior()
      && !!speech?.isListening
      && !speech.isMicMuted
      && !speech.blankRecording;
  }

  loadPotentialUtterances(){
    //Keep here for a day where we do optimize for this
  }

  configuredToExtendAssessmentTimeout() {
    // Apply timeout multiplier for students with extendAssessmentTime flag
    // Check assignment tags first, then fall back to user metadata
    if (this.props.config.assessmentMode) {
      const hasAssignmentTag = this.props.studentAssignment && this.props.studentAssignment.tags && this.props.studentAssignment.tags.includes(EXTEND_ASSESSMENT_TIME_TAG);
      const hasUserMetadataFlag = getUserData().extendAssessmentTime;
      return hasAssignmentTag || hasUserMetadataFlag;
    }

    return false;
  }

  getAssessmentTimeoutExtensionMultiplier() {
    let extensionMultiplier = 1.5;
    const userData = getUserData();
    if (userData.assessmentTimerMultiplier) {
      const parsedMultiplier = parseFloat(userData.assessmentTimerMultiplier);
      if (!isNaN(parsedMultiplier) && parsedMultiplier > 0) {
        extensionMultiplier = parsedMultiplier;
      }
    }
    return extensionMultiplier;
  }

  startPhraseTimeout(){
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);

    if(this.props.story && this.props.story.items && this.props.story.items[overallPhraseIndex] && this.props.story.items[overallPhraseIndex].timeoutInMS){
      let timeoutInMS = this.props.story.items[overallPhraseIndex].timeoutInMS;
      
      if (this.configuredToExtendAssessmentTimeout()) {
        // Exclude visual attention, nonsense word repetition, retell, RAN, and ORF assessments
        const isVisualAttention = this.getCurrentPhraseMetaData().type === "visualAttention";
        const isRanStory = this.props.story && (this.props.story.type === aosTaskTypes.ran || this.props.story.items[overallPhraseIndex].type.toUpperCase() === "RAN");
        const isOrfAssessment = this.props.orfMode;
        const isNonsenseWordRepetition = this.getCurrentPhraseMetaData().type === "nonsenseWordRepetition";
        const isRetell = this.getCurrentPhraseMetaData().type === "retell";

        const isExcludedType = isVisualAttention || isRanStory || isOrfAssessment || isNonsenseWordRepetition || isRetell;
        
        if (!isExcludedType) {
          const extensionMultiplier = this.getAssessmentTimeoutExtensionMultiplier();
          timeoutInMS = Math.round(timeoutInMS * extensionMultiplier);
        }
      }
      
      this.phraseTimeoutRef.current = window.setTimeout(this.onPhraseTimeout, timeoutInMS);
    } else {
      this.phraseTimeoutRef.current = null;
    }

    // Start RAN relevel timer after the instructions complete
    const isRanStory = this.props.story && this.props.story.type === aosTaskTypes.ran && this.props.shouldUseAOS; // Only enabled relevel timer for RAN stories in AOS
    if (isRanStory && !this.state.doNotRelevel) {
      this.stopRelevelTimer();
      this.startRelevelTimer();
    }
  }

  clearPhraseTimeout(startOfPhrase=false){
    console.log("🟡 clearPhraseTimeout")
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
    this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
    // If we're at the start of the phrase, we have just set the startReadingTimer so it won't be in state
    // Nulling it here not only causes it to never get cancelled, it causes it to never really fire.
    if(!startOfPhrase){
      this.setState({startReadingTimer: null});
    }
  }

  resetPhraseTimeout(startOfPhrase=false,enableStartReading=true){ //NOTE: only use this in situations where you are not making another call to setState
    this.clearPhraseTimeout(startOfPhrase);
    if(this.state.startReadingTimer && enableStartReading){
      console.log("🔵 startReadingTimer")
      let startReadingTimer = window.setTimeout((this.onPauseDetected).bind(this,true),10000);
      this.setState({
        startReadingTimer: startReadingTimer,
      });
    }else{
      console.log("🟢 resetPhraseTimeout")
      this.startPhraseTimeout();
    }
  }

  handlePhraseSplits(storyId=null, story=null, prevSlices = [], shouldSave = true){
    const rawTimings = JSON.parse(JSON.stringify(timings));
    let shouldPadSlices = true; //TODO: restore this line when we're glitch-free this.props.orfMode; //Don't add padding to the slicing for dyslexia since it's 1 phrase, 1 page.
    return calculatePhraseSplits(timings, storyId, stopTime-this.props.speech.silentSegments().timingOffset, shouldPadSlices, story, prevSlices)
      .then(splits => {
        if (shouldSave) {
          saveAssessmentTiming(this.state.activityId, splits, rawTimings);
        }

        return splits;
      })
      .catch((err)=>{
        logSessionInfo("errorCalculatingSlicing",{
          timings: timings,
          storyId: this.props.story.storyId,
          stopTime: stopTime,
          timingOffset: this.props.speech.silentSegments().timingOffset,
          shouldPadSlices: shouldPadSlices,
          error: err
        });
      })
  }

  /**
   * resets reader manager states related to pauses
   */
  doneHandlingPause(){
    this.setState({
      firstPass: false,
      paused: false,
    })
  }

  // these getters and setters are necessary because of the multi layered array structure used for tracking errors and timers by page and phrase
  getCurrentPhraseScore(){
    if(this.state.errors[this.props.pageIndex] && this.state.errors[this.props.pageIndex][this.state.currentPhraseIndex]){
      return  this.state.errors[this.props.pageIndex][this.state.currentPhraseIndex];
    } else {
      return {};
    }
  }

  //Clean and split the gurrent phrase errors to pass to the intervention selection
  // and add the index pf the error into the original array so that we can
  // correct the word if doing the clap intervention.
  getWordErrors(inErrors=null){
    let phrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    phrase = cleanAndSplit(phrase);
    let errors = inErrors ? inErrors : this.getCurrentPhraseErrors();
    let wordErrors = [];

    for(let i=0;i<phrase.length;i++){
      if(errors[i]) wordErrors.push({word: phrase[i],index: i});
    }
    return wordErrors;
  }

  //TODO: Hacked so we always show everything correct while the student is reading.
  // If this sticks, will remove the old method but wanted to preserve it.
  setCurrentPhraseScore(score,endOfPhrase){
    //TODO: HACK allow EDM to opt out of styling
    let currentErrors = this.state.errors;
    let currentPageErrors = currentErrors[this.props.pageIndex] || [];
    currentPageErrors[this.state.currentPhraseIndex] = score;
    currentErrors[this.props.pageIndex] = currentPageErrors;

    //Handle the styling array
    // The logic here is: If an error is set, do not allow subsequent updates to clear it.
    let currentStylingErrors = this.state.stylingErrors;
    let currentStylingPageErrors = currentStylingErrors[this.props.pageIndex] || [];

    //Save the current state of styling errors
    const currentState = currentStylingPageErrors[this.state.currentPhraseIndex] ? currentStylingPageErrors[this.state.currentPhraseIndex].totalErrors : [];

    //Then update with the new errors
    let newErrors = JSON.parse(JSON.stringify(score));

    //Then re-set any errors that existed before we updated the array.
    //###Hack to turn everything green.
    if(currentState && !endOfPhrase){
      /*for(let i=0;i<currentState.length;i++){
        if(currentState[i]){
          newErrors.totalErrors[i] = true;
        }*/
      for(let i=0;i<newErrors.totalErrors.length;i++){
        //newErrors.totalErrors[i] = newErrors.skips[i];
        newErrors.totalErrors[i] = false;
      }
    }

    currentStylingPageErrors[this.state.currentPhraseIndex] = newErrors;
    currentStylingErrors[this.props.pageIndex] = currentStylingPageErrors;

    this.setState({
      stylingErrors: currentStylingErrors,
      errors: currentErrors,
      currentWordIndex: score.totalErrors.length
    });

    return currentErrors;
  }

  getCurrentPhraseErrors(){
    let currentPhraseScore = this.getCurrentPhraseScore();
    return Array.isArray(currentPhraseScore.totalErrors) ? currentPhraseScore.totalErrors : [];
  }

  setCurrentPhraseErrors(errors,endOfPhrase=false){
    let currentScore = this.getCurrentPhraseScore();
    let cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    //Make sure we're never writing more than the current phrase length
    try{
      if(errors && Array.isArray(errors)){
        currentScore.totalErrors = errors.slice(0,cleanPhrase.length);
      }else{
        currentScore.totalErrors = errors;
      }

    }catch(e){
      logSentryException(new Error('Phrase error tracking failure'), 'Error setting current phrase errors', { originalError: e?.message, originalStack: e?.stack });
      currentScore.totalErrors = errors;
    }

    return this.setCurrentPhraseScore(currentScore,endOfPhrase);

  }

  openModal(content, props={}){
    if (!this._isMounted) {
      return;
    }
    
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.OPEN_MODAL, modalName: props.logName });
    if(!this.state.error){
      this.setState({
        displayContainer: !props.hideReaderContainer
      });
      this.props.openModal(content, props);
    }
  }

  openModalAndStopListening(content, props={}){
    this.props.speech.stopListening("openModalAndStopListening");
    this.openModal(content,{...props, logName: "openModalAndStopListening"});
  }

  handleMessage(message) {
    try {
      let messageCallback = message.endOfPhrase ? this.cleanUpAfterIntervention : this.onInterventionEnd;

      if(!message){
        messageCallback();
        return;
      }

      // Attach a callback function to the message if none provided
      if(!message["callback"]){
        message["callback"] = messageCallback;
      }
      if(message.listen){
        message.listen();
      }
      if(message.text){
        this.props.sendMessage(message);
      }
      if(message.speakFunction){
        message.speakFunction(message.callback || messageCallback);
      }
      if(message.continueWithoutSpeaking){
        if(message.endOfPhrase){
          this.closeModal();
          this.cleanUpAfterIntervention();
        }else{
          this.onInterventionEnd();
        }
      }
    } catch(err) {
      console.log("ERROR IN WORD INTERVENTION -- HANDLE MESSAGE",err);
      logSessionInfo(err.name + " " + err.message,{error: err.stack});
      logSentryException(new Error('Word intervention message handling failure'), 'Error in word intervention -- handle message', { originalError: err?.message, originalStack: err?.stack });
      this.abortIntervention();
    }
  }

  onInterventionEnd(){
    let timeSpentIntervening =  this.state.interventionStartTime ? Date.now() - this.state.interventionStartTime : 0;
    phraseTimeSpentIntervening+=timeSpentIntervening;
    isWordInterventionInProcess = false;
    
    // Tap-to-read: Clear intervention flag and timeout
    this.clearTapToReadInterventionFlag();
    
    this.setState({
      interventionStartTime: 0,
      repeateAfterMeInterventionInProcess: false,
      interventionWordIndex: -1,
      interventionWord: null,
    });
    this.doneHandlingPause();
    this.closeModal(true);
    // closeModal starts listening asynchronously (after the modal unmounts), so
    // isListening is still false here. Guard like phraseStartCallback/skipWord so
    // monitoring is never armed while the mic is down — the componentDidUpdate
    // isListening transition re-arms it when listening actually resumes.
    if (this.networkMonitoringService && this.props.speech.isListening) {
      this.networkMonitoringService.setAudioMonitoringActive(true);
    }
  }

  // open up a Modal and send the message to the coach
  // TODO: Rename/rethink this
  openWordInterventionModal({
    modal,
    message,
    closeButton,
    delayedCloseButton=true,
    delayedCloseButtonTimeoutOverride,
    hideBackground,
    hideReaderContainer
  }){
    logSessionInfo("modalOpened",{modal: modal,message: message});
    if(modal){
      try{
        this.openModalAndStopListening(modal, {
          closeButton,
          delayedCloseButton,
          delayedCloseButtonTimeoutOverride,
          close: this.abortIntervention.bind(this),
          key:"intervention",
          hideBackground,
          hideReaderContainer,
        });
        this.setState({interventionStartTime: Date.now()});
      }catch(err){
        console.log("ERROR IN WORD INTERVENTION -- OPEN MODAL FAILED",err);
        logSessionInfo(err.name + " " + err.message,{error: err.stack});
        logSentryException(new Error('Word intervention modal failure'), 'Error in word intervention -- open modal failed', { originalError: err?.message, originalStack: err?.stack });
        this.abortIntervention();
        return;
      }
    }

    if(message){
      this.handleMessage(message);
    }
  }

  continueReading(){
    logSessionInfo("modalClosedInContinue_"+this.state.lastIntervention,{word: this.getCurrentWord().trim(), type: this.state.lastIntervention, index: this.state.currentWordIndex});
    if(this.state.matchTimeout) window.clearTimeout(this.state.matchTimeout);
    this.setState({matchTimeout: null});
    this.props.speech.cancelMatchRequest();
    this.props.closeModal();
    let textToSpeak = this.state.interveningAtEndOfPage ? getLastPhraseOnPageResponse() : getKeepReading(getStudentReadingLevel());
    this.setState({interveningAtEndOfPage: false});
    let prompt={
      textToSpeak: textToSpeak,
      onEnd: this.cleanUpAfterIntervention.bind(this),
    }
    this.props.speech.speak(prompt,true); //TODO: Re-evaluate/watch this - not sure I like forcing listen here.
  }

  async launchInteraction() {
    this.setIsLoading(false);
    const phraseMetadata = this.getCurrentPhraseMetaData();
    await new Promise(resolve => {
      this.setState({
        readerScreenContentOverride: (
          <Interaction
            speech={this.props.speech}
            onDone={() => {
              this.setState({
                readerScreenContentOverride: null
              });
              resolve();
            }}
            interactions={phraseMetadata.interactions}
            phraseIndex={overallPhraseIndex}
            storyId={this.props.story.storyId}
            activityId={this.state.activityId}
            showFTUE={!getUserData().hasSeenDialogFTUE || this.props.forceDialogFTUE}
            onFinishFTUE={() => StudentInformationService.setDialogFTUESeen(getUserData().userId, true)}
          />
        ),
      })
    })
  }

  // Returns why a word should be diverted to skipWord without a real intervention -- 'stop_word',
  // 'first_word_of_story', or 'short_word' -- or null when it should get a real intervention. These are the
  // "we never actually intervened" cases the end-of-phrase EDM override must not treat as errors (TT-1279),
  // so this set is exactly what setStorySuppressedIntervention exempts. forceSkip is composed at the call
  // site (it is a "deliberately skip an intervention we would otherwise deliver" signal, NOT a
  // never-intervened reason) so it is never mistakenly exempted. Checks are first-match: a stop word that is
  // also < 3 chars reports 'stop_word'.
  getWordSuppressionReason(inWord){
    if(isStopWord(inWord)) return 'stop_word';
    if((overallPhraseIndex == 0 && this.state.currentWordIndex == 0) && !isEarlyReaderMode(this.state.earlyReaderMode)) return 'first_word_of_story';
    if(inWord.length < 3) return 'short_word';
    return null;
  }

  //TODO: Move all the conditional down into InterventionSelect - Pete note: conditionally, depending on good separation of concerns.
  async launchWordIntervention(inWord, mostRecentScores, endOfPhrase=false, intervention=null, forceSkip = false, fromUNKFallback = false){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.INTERVENTION_ON_WORD });

    let didIntervene = true;
    let lastWordInterventionIndex = this.state.lastWordInterventionIndex;
    let intervenedOnLastWord = false;
    isWordInterventionInProcess = true;
    
    // Tap-to-read: Set flag ONLY for word-level interventions (not end-of-phrase)
    // to block taps during intervention and prevent cursor double-advance race condition
    if (isTapToReadBehavior() && !endOfPhrase) {
      this.setTapToReadInterventionFlag();
    }
    
    // Uncomment this when we want recorder to run with a mock audio file so that giveword interventions are skipped
    // and audio analysis is performed on the mock audio file
    // forceSkip = true;
    
    // Track UNK fallback interventions to prevent skip backs
    if (fromUNKFallback) {
      this.lastUNKFallbackIndex = this.state.currentWordIndex;

      // Log suppressed interventions for UNK fallback scenarios
      // Log when forceSkip is true OR intervention is not null (and no word-level suppression reason applies).
      const otherSuppressionConditions = this.getWordSuppressionReason(inWord) !== null;

      if ((forceSkip || intervention !== null) && !otherSuppressionConditions) {
        // Determine log title based on whether forceSkip is true or intervention was selected
        const selectedType = forceSkip 
          ? 'skip'
          : intervention?.type || 'unknown';
        const logTitle = `word_level_intervention_suppressed_phrase_${overallPhraseIndex}_word_${this.state.currentWordIndex}_selected_${selectedType}`;
        
        const logData = {
          word: inWord,
          wordIndex: this.state.currentWordIndex,
          phraseIndex: overallPhraseIndex,
          fromUNKFallback: true
        };
        
        // Log to intervention bucket
        logInterventionEvent(logTitle, logData, this.state.activityId);
        
        // Log to session bucket
        logSessionInfo(logTitle, logData);
      }
    }

    //If the intervention selection logic chose an intervention on a word we don't want, override it with skipword
    // wordSuppressionReason is the "never actually intervened" reason; it (not forceSkip) is what exempts the
    // word from the end-of-phrase EDM override below. A forceSkip still enters this branch but is not exempted.
    const wordSuppressionReason = this.getWordSuppressionReason(inWord);
    if(wordSuppressionReason || forceSkip){
      //Only call skipWord if we're not at end of phrase or bad things will happen.
      if(!endOfPhrase){
        // For early reader activities (including word lists) or UNK fallback scenarios, we need to pass force=true
        // to allow skipping the first word of the story. See skipWord() line 1996 for details.
        const shouldForceSkip = isEarlyReaderMode(this.state.earlyReaderMode) || forceSkip || fromUNKFallback;
        if((forceSkip || inWord.length < 3) || isStopWord(inWord)) {
          this.skipWord(false, shouldForceSkip, false, fromUNKFallback);
        } else {
          this.skipWord(true, shouldForceSkip, false, fromUNKFallback);
        }
        lastWordInterventionIndex = this.state.currentWordIndex;

        // We want to count give word or skip word interventions for the purposes of counting how often user needed intervening
        // Skip counting for UNK fallback interventions (they should be transparent)
        if (!fromUNKFallback) {
          addInterventionCountForPhrase(overallPhraseIndex);
        }
      }else{
        didIntervene = false;
      }

    } else if(!intervention || (intervention.type !== interventionType.none)){
      try{
        const cleanInterventionWord = this.getCurrentWord(this.state.currentWordIndex, true);
        
        // Get WCPM for intervention selection logic with fallback
        const interventionParams = this.getInterventionSelectionV2Params();
        const interventionWCPM = interventionParams.prev_equatedwcpm ?? getUserData().interventionFallbackWCPM;
        
        let chosenIntervention = await selectWordIntervention(
          cleanInterventionWord,
          intervention,
          this.state.currentWordIndex,
          this.props.forceIntervention,
          this.props.interventionBias,
          interventionWCPM,
          overallPhraseIndex,
          this.props.transcript.interim
        );
        this.setState({lastIntervention: chosenIntervention.type});

        if (
          chosenIntervention.type !== interventionType.skip &&
          chosenIntervention.type !== interventionType.giveword &&
          chosenIntervention.type !== interventionType.none) {
          if (this.networkMonitoringService) {
            this.networkMonitoringService.setAudioMonitoringActive(false);
          }
        }

        if (chosenIntervention.type === interventionType.clap) {
          const wordToUse = cleanInterventionWord.replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()""?!]/g, "");
          this.playRepeatAfterMe(wordToUse, this.state.currentWordIndex);
        } else {
          if (chosenIntervention.type === interventionType.vocabularyWithPictures || chosenIntervention.type === interventionType.soundSeeker) {
            // Both interventions need word metadata, and vocabularyWithPictures also lists its distractor images in S3.
            // Absent metadata or a failed/empty fetch (e.g. a 403 on the assets bucket) means the modal can't
            // render, so skip before opening it. advanceAfterPreModalSkip keeps end-of-phrase
            // from freezing the reader (TT-1277 / TT-1284).
            if (chosenIntervention.metadata) {
              // SoundSeeker doesn't use DISTRACTORS: Since intervention-library 4.0.0 its imageUtil.js
              // maps the word's phonemes to fixed image URLs on the asset CDN, so it skips the S3 listing.
              if (chosenIntervention.type === interventionType.vocabularyWithPictures) {
                chosenIntervention.metadata.DISTRACTORS = await getRandomDistractorImages(chosenIntervention.metadata);
                if (!chosenIntervention.metadata.DISTRACTORS.length) {
                  logSessionInfo("distractor_images_unavailable_skip", { word: inWord, type: chosenIntervention.type, reason: "no_distractors" });
                  this.advanceAfterPreModalSkip(endOfPhrase, fromUNKFallback); // advanced above; resolve truthy so caller doesn't skip again
                  return true;
                }
              }
            } else {
              logSessionInfo("distractor_images_unavailable_skip", { word: inWord, type: chosenIntervention.type, reason: "no_metadata" });
              this.advanceAfterPreModalSkip(endOfPhrase, fromUNKFallback); // advanced above; resolve truthy so caller doesn't skip again
              return true;
            }
          }
          // Syllable interventions read per-syllable mp3s; if any is missing from the bucket,
          // skip here (before the modal opens) so it doesn't pop up and immediately bail.
          if (
            chosenIntervention.type === interventionType.syllableBlendClick ||
            chosenIntervention.type === interventionType.syllableDecoding ||
            chosenIntervention.type === interventionType.phonemeSyllableWord
          ) {
            const alphsyl = chosenIntervention.metadata && chosenIntervention.metadata.ALPHSYL;
            if (!alphsyl || !(await allSyllableAudioAvailable(alphsyl))) {
              logSessionInfo("syllable_audio_unavailable_skip", { word: inWord, encoding: alphsyl || null });
              this.advanceAfterPreModalSkip(endOfPhrase, fromUNKFallback);
              return true;
            }
          }
          getIntervention({
            speech: this.props.speech,
            inWord: inWord,
            callback: this.openWordInterventionModal,
            endOfPhrase: endOfPhrase,
            chosenIntervention: chosenIntervention,
            currentWordIndex: this.state.currentWordIndex,
            handleMessage: this.handleMessage,
            skipWord: this.skipWord,
            phraseMeta: this.getCurrentPhraseMetaData(),
            mostRecentScores:  mostRecentScores,
            fromUNKFallback: fromUNKFallback,
            story: this.props.story,
            isSpanishPilot: this.props.isSpanishPilot,
          });
        }
      }catch(err){
        console.log("ERROR IN WORD INTERVENTION",err);
        logSessionInfo(err.name + " " + err.message,{error: err.stack});
        logSentryException(new Error('Word intervention failure'), 'Error in word intervention', { originalError: err?.message, originalStack: err?.stack });
        didIntervene = false;
      }

      lastWordInterventionIndex = this.state.currentWordIndex;

      //If we're intervening on the last word of a phrase
      if(lastWordInterventionIndex >= cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length-1){
        intervenedOnLastWord = true;
      }
    } else{
     if(endOfPhrase){
       this.cleanUpAfterIntervention();
     }
    }
    
    // Only update intervention tracking if NOT from UNK fallback
    // UNK fallback interventions should be treated as if the user read the word correctly
    if (!fromUNKFallback) {
      if(!endOfPhrase && didIntervene && !this.state.endOfPhrase){
        this.setStoryIntervention();
        // TT-1279: keep the mark (so escalation/scoreTutoring/counts are unchanged) but record whether it was
        // a "never actually intervened" suppression. Written on every mark so the flag reflects the latest
        // decision. Only wordSuppressionReason exempts -- a force_skip is a deliberate skip of a real
        // intervention and must still override EDM. The end-of-phrase override is the only consumer.
        this.setStorySuppressedIntervention(wordSuppressionReason !== null);
      }

      this.setState({
        lastProgress: defaultLastProgress,
        lastWordInterventionIndex,
        intervenedOnLastWord,
      });
    } else {
      // For UNK fallback, still update lastProgress but not other intervention tracking
      this.setState({
        lastProgress: defaultLastProgress,
      });
    }

    if (!didIntervene) {
      isWordInterventionInProcess = false;
      
      // Tap-to-read: Clear intervention flag and timeout
      this.clearTapToReadInterventionFlag();
    }

    return Promise.resolve(didIntervene);
  }

  setStoryIntervention(){
    let {storyInterventions} = this.state;
    const phraseRow = storyInterventions?.[overallPhraseIndex];
    // Row-guard matches setStorySuppressedIntervention so the pair either both write or both no-op, keeping
    // the suppressed set a subset of the marked set. A missing row previously threw a TypeError (rejecting
    // the intervention promise); it now no-ops, so log it to keep phrase-index drift observable instead of
    // silent. The in-range check below keeps its original silent no-op (unchanged, benign).
    if(!phraseRow){
      logSessionInfo('story_intervention_mark_skipped_missing_row', {
        overallPhraseIndex,
        currentWordIndex: this.state.currentWordIndex,
      });
      return;
    }
    if(this.state.currentWordIndex < phraseRow.length){
      phraseRow[this.state.currentWordIndex] = true;
      // Pass a state patch, not the bare array: setState(array) would merge the array's numeric indices in
      // as top-level state keys. Behavior-neutral because the array is mutated in place first.
      this.setState({storyInterventions})
    }
  }

  // TT-1279: parallel to setStoryIntervention, records whether the mark at the current word index came from a
  // suppression (stop word, < 3 chars, first word of story) rather than a real intervention. The end-of-phrase
  // EDM override in onErrorsAreValid uses this set to leave EDM's score for suppressed indices. Callers pass
  // the current decision so the value is authoritative (a re-marked word can flip false), keeping the
  // suppressed set a subset of the marked set. Optional-chains the row (like the override loop) so an
  // uninitialized / out-of-range phrase is a no-op instead of a throw.
  setStorySuppressedIntervention(suppressed){
    let {storySuppressedInterventions} = this.state;
    if(storySuppressedInterventions?.[overallPhraseIndex] && this.state.currentWordIndex < storySuppressedInterventions[overallPhraseIndex].length){
      storySuppressedInterventions[overallPhraseIndex][this.state.currentWordIndex] = suppressed;
      this.setState({storySuppressedInterventions})
    }
  }

  //If a phrase timeout was specified, call PhraseEnd if it expires
  onPhraseTimeout(){

    //If we're on the first page of a dyslexia test and the cursor has not moved, terminate the test
    //If there is only one word in the phrase, don't fire muted.
    let currentPhraseLength = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length;
    const isRetellTask = this.props.story && this.props.story.type === aosTaskTypes.retell; // Don't check for stuck placement on retell tasks
    const isUpAndDownTask = this.props.story && this.props.story.type === aosTaskTypes.upAndDown;
    const isFreeAnswerItem = this.getCurrentPhraseMetaData().type === phraseTypes.FREE_ANSWER;
    if((this.props.pageIndex == 0) && !this.props.asrStoryID && !this.props.story.nonAudio && !this.props.orfMode && !isRetellTask && !isUpAndDownTask && !isFreeAnswerItem && (this.state.currentWordIndex === 0) && (currentPhraseLength > 1)){
      logSessionInfo("stuck_placement_manager",this.props.speech.silentSegments());
      this.onBlankAudioDetected(statusType.STUCK_PLACEMENT);
    }else{
      const immutablePhraseIndex = Number(overallPhraseIndex);
      this.onPhraseEnd(this.props.speech.isRecording(), immutablePhraseIndex);
    }
  }

  // this will contain the original onPauseDetected code
  // pass it down to Phrase, and let the Phrase decide if it should call this default handler
  // or it should not do it and let the Phrase item component handle it
  handleDefaultPauseDetected(){
    // Skip word-level (mid-phrase) intervention timer for cursor-free behavior only:
    // these students are above the WCPM threshold and don't need placement-manager-driven
    // auto-interventions (they still get end-of-phrase interventions via the EDM pipeline).
    // Tap-to-read is intentionally NOT skipped here — word-level interventions run through their
    // normal paths: a give-word/skip still advances the cursor (so the student moves on from the
    // word they were just helped with, rather than re-attempting it), and interactive/modal
    // interventions present help without advancing (the student then taps to continue). When the
    // network can't produce an ASR transcript, findWordToIntervene() returns nothing and the path
    // below degrades gracefully with no advance, so reading continues via tapping.
    // TODO(TT-1009): tap-mode-specific tuning (extended pause timeout, 1/phrase cap) if desired.
    if (isCursorFreeBehavior()) {
      // Explicitly return false to match convention; Phrase.js will call doneHandlingPause to clear paused state
      return false;
    }
    
    // Tap-to-read: Skip word-level interventions on the last word of a phrase.
    // At the last word, only the Next button and end-of-phrase flow should be active.
    if (isTapToReadBehavior()) {
      const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
      const isAtLastWord = this.state.currentWordIndex === cleanPhrase.length - 1;
      if (isAtLastWord) {
        // Don't intervene, just clear the paused state
        this.doneHandlingPause();
        this.syncTapToReadNextButton();
        return false;
      }
    }

    //Don't intervene on the very first word of a story. Just say "please start reading". This will happen even when other word interventions are disabled.
    //Temporarily disable the whole start reading thing. TODO: This whole timer needs to be either removed or we need to implement this in a way that doesn't wreak havoc.
    if(false && overallPhraseIndex === 0){
      if((!this.props.story.nonAudio) && (this.state.firstPass && (this.props.orfMode || isEarlyReaderMode(this.state.earlyReaderMode)) || this.state.startReadingTimer)){
        let props = {};
        //### DISABLE FOR NOW props.textToSpeak = COPY_STRINGS.start_reading;
        //### DISABLE FOR NOW this.props.speech.speak(props);
        this.setState({
          startReadingTimer: null,
        }, this.resetPhraseTimeout(false,false))
        return;
      }
    }

    //If all of the above checks fail but this is the first pass, do not do interventions (this is the please start reading timer)
    if(this.state.firstPass){
      return;
    }

    // if this is within the last two words of the final phrase of the page in assessment mode then we should turn the page
    // this will keep kids from getting stuck if they are having trouble getting their speech recognized in the final words of the page
    // TODO: remove when we do away with assessment pagination (in tutor mode this is taken care of by the "skip word" intervention)
    let phrases = this.getCurrentPage();
    let currentPhraseLength = phrases[this.state.currentPhraseIndex];
    if(currentPhraseLength){
      currentPhraseLength = currentPhraseLength.split(" ").length;
    }else{
      return;
    }

    // put this.disableInterventionsForPhrase here instead of in the below if to keep from getting stuck
    if((this.props.config.assessmentMode && this.props.orfMode && !getUserData().assessmentPageNavEnabled) || this.disableInterventionsForPhrase){
      //We are always recording in assessment mode
      if(this.shouldForceFirstWordSkip()){
        this.skipWord(false, true, false, false, FORCED_FIRST_WORD_SKIP_SOURCE.PAUSE);
      }else{
        this.skipWord(false);
      }
      return;
    }

    //Disable Word Interventions
    if(this.props.config.disableWordInterventions || !this.props.config.enableInterventions){
      return;
    }

    let currentWord = this.findWordToIntervene();
    if(this.props.speech && this.props.speech.isListening && currentWord){
      // Track which words have fired word-level interventions (regardless of whether they've triggered an intervention selection event)
      trackWordIntervention(this.state.currentWordIndex);

      // Launch the word intervention (which will move the cursor on stopWords, short words, and first words in a phrase)
      let skipIntervention = false;
      let forceInterventionType = null;
      let fromUNKFallback = false;
      
      // WCPM-based intervention override logic
      // Get WCPM for intervention selection logic with fallback
      const interventionParams = this.getInterventionSelectionV2Params();
      const interventionWCPM = interventionParams.prev_equatedwcpm ?? getUserData().interventionFallbackWCPM;
      
      // Check if expanded intervention suppression is enabled via license key
      // When enabled, this applies the 30-50 WCPM logic to users below 30 WCPM as well
      // Check both the general app settings (district 9999999) and user's specific district license
      const expandedSuppressionEnabled = getUserData().appSettings?.expandedInterventionSuppression || getUserData().expandedInterventionSuppression;
      
      if (interventionWCPM !== undefined && !this.shouldUseNewSpanishPlacementManagerInCurrentSession()) {
        // Check if current phrase already has a word intervention
        const currentPhraseHasWordIntervention = this.state.storyInterventions && 
          this.state.storyInterventions[overallPhraseIndex] &&
          this.state.storyInterventions[overallPhraseIndex].some(intervened => intervened === true);
        
        // Count UNKs in the current phrase's transcript
        const interimTranscript = this.props.transcript.interim || '';
        const unkMatches = interimTranscript.match(/<UNK>|UNK/g);
        const totalUNKs = unkMatches ? unkMatches.length : 0;
        
        // For WCPM 30-50 users, OR < 30 WCPM when license key enabled
        if ((interventionWCPM >= 30 && interventionWCPM < 50) || (expandedSuppressionEnabled && interventionWCPM < 30)) {
          // If UNK count reaches 3 or more, suppress further word level interventions
          if (totalUNKs >= 3) {
            skipIntervention = true;
            fromUNKFallback = true;
          }
          // Otherwise, give word if current phrase has a word intervention
          else if (currentPhraseHasWordIntervention) {
            forceInterventionType = interventionType.giveword;
            fromUNKFallback = true;
          }
        }
        // WCPM >= 50
        else if (interventionWCPM >= 50) {
          // Check if the last word in the transcript is UNK
          const interimWords = interimTranscript.trim().split(/\s+/);
          const lastInterimWord = interimWords[interimWords.length - 1];
          const isLastWordUNK = lastInterimWord === '<UNK>' || lastInterimWord === 'UNK';
          
          // Check for null placement in the scored transcript
          let containsNullPlacement = false;
          const cleanTranscript = this.state.errors?.[this.props.pageIndex]?.[this.state.currentPhraseIndex]?.cleanTranscript;
          if (cleanTranscript) {
            // Check if the array is shorter than expected
            if (cleanTranscript.length < (this.state.currentWordIndex - 1)) {
              containsNullPlacement = true;
            } else {
              // Check for sparse array (missing indices) or empty elements
              for (let i = 0; i < cleanTranscript.length; i++) {
                if (!(i in cleanTranscript) || !cleanTranscript[i] || cleanTranscript[i] === '') {
                  containsNullPlacement = true;
                  break;
                }
              }
            }
          }
          
          // If last word is UNK AND there's at least 1 other UNK AND there's null placement, skip intervention
          if (isLastWordUNK && totalUNKs >= 2 && containsNullPlacement) {
            skipIntervention = true;
            fromUNKFallback = true;
          } else {
            forceInterventionType = interventionType.giveword;
            fromUNKFallback = true;
          }
        }
      }

      this.calculateScoresAndLaunchWordIntervention({
        word: currentWord, 
        skipIntervention, 
        forceInterventionType,
        fromUNKFallback
      });
    } else {
      this.setState({
        lastProgress: defaultLastProgress,
      });
    }
    return true // notify the caller that an intervention will be launched
  }

  calculateScoresAndLaunchWordIntervention({word, skipIntervention=false, forceInterventionType=null, fromUNKFallback=false}){
    const mostRecentScores = calculateMostRecentScores(this.state.errors, getAudioDuration());
    const intervention = forceInterventionType ? {type: forceInterventionType} : null;
    this.launchWordIntervention(word,mostRecentScores,this.state.endOfPhrase,intervention,skipIntervention,fromUNKFallback).then((success) => {
      if(!success){
        this.skipWord(false);
      }
    }, (err) => {
      console.log("ERROR LAUNCHING WORD INTERVENTION:",err);
      logSessionInfo(err.name + " " + err.message,{error: err.stack});
      logSentryException(new Error('Word intervention launch failure'), 'Error launching word intervention', { originalError: err?.message, originalStack: err?.stack });
      this.skipWord(false);
    });
  }

  //This essentially just wraps launch so that it can get launched asynchronously
  //  and we select the current word. This is the callback that gets triggered by
  //  the timer.
  onPauseDetected(firstPass=false){
    this.setState({
      firstPass: firstPass,
      paused: true,
    })
  }

  refreshBrowser(){
    endUserSession();
  }

  // When we have blank audio (note: different from muted)
  // Shows error modal or initiates mid-session mic troubleshoot flow via StudentPreChecks.
  onBlankAudioDetected(status){
    // Prevent multiple calls - once triggered, ignore subsequent calls until reset
    if (this._blankAudioTriggered) {
      return;
    }
    this._blankAudioTriggered = true;
    
    this.clearAssessmentStoryTimeouts();

    return studentRecordService.markAbortedKeepingAssignment(this.state.activityId,status)
    .finally(()=>{
      // Close any open modals and stop listening
      this.props.closeModal();
      this.props.speech.stopListening();
      
      // Initiate troubleshoot flow via App.js if feature flag is enabled and not suppressed
      const suppressMidSessionTroubleshoot = this.props.initialUrlParams?.suppressMidSessionTroubleshoot === 'true';
      if (FEATURE_FLAGS.MUTED_AUDIO_FULL_TROUBLESHOOT && this.props.startMidSessionTroubleshoot && !suppressMidSessionTroubleshoot) {
        this.props.startMidSessionTroubleshoot();
      } else {
        // Default behavior: show simple error modal
        this.openModalAndStopListening(
          <ErrorModal
            type={getErrorModalTypes().BLANK}
            speech={this.props.speech}
            continue={this.refreshBrowser}
            returnUrl={this.props.returnUrl}
          />
        );
      }
    });
  }

  onNoStories(){
    return this.markForcedAssessmentComplete(this.state.activityId,status)
    .then(()=>{
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().NOSTORIES}
          speech={this.props.speech}
          continue={this.refreshBrowser}
          returnUrl={this.props.returnUrl}
        />
      );
    });
  }

  calculateWordsCorrect(){
    return this.getCurrentPhraseErrors().reduce((total,error)=>{
      return error ? total : total+1;
    },0);
  }

  // These methods are now imported from relevelService.js

  //Start timer to check relevel. Simplified logic is to check student's progress after a minute and downlevel if they're not 8 words in.
  startRelevelTimer(){
    //Disable down/upleveling if a particular story is forced
    if(this.props.forceStory || this.props.forceSkill) return;
    
    //Disable releveling if doNotRelevel is set
    if(this.state.doNotRelevel) return;
    
    const isRanStory = this.props.story && this.props.story.type === aosTaskTypes.ran && this.props.shouldUseAOS; // Only enabled relevel timer for RAN stories in AOS
    const timerDuration = isRanStory ? 20000 : 60000;
    
    relevelTimer.set(timerDuration)
    .then(()=>{
      // Re-check doNotRelevel when timer fires to handle race conditions
      // where doNotRelevel was set after the timer started
      if(this.state.doNotRelevel) {
        logSessionInfo("relevel_timer_blocked_doNotRelevel", {src: 'relevelTimer', doNotRelevel: this.state.doNotRelevel});
        return;
      }

      const assignmentType = this.props.studentAssignment ? this.props.studentAssignment.assignmentType : null;
      const isCalibration = assignmentType === 'CALIBRATION';

      if(this.props.config.assessmentMode && (this.props.pageIndex == 0) && 
         (this.props.orfMode || (isRanStory && !isCalibration))){
        let studentGrade = getUserData().actualGrade;
        let storyGrade = parseInt(this.props.story.grade);
        let errors = this.getCurrentPhraseErrors();
        let wordsCorrect = errors.reduce((total,error)=>{
          return error ? total : total+1;
        },0);

        logSessionInfo('downlevel_check', {
          src: 'relevelTimer',
          wordsCorrect,
          errors: this.state.errors,
          currentPhraseErrors: errors,
          studentGrade,
          storyGrade,
          isRanStory,
          currentWordIndex: this.state.currentWordIndex
        });

        //downlevel based on story type criteria
        const shouldDownLevel = isRanStory ? 
          ranDownLevelCriteriaMet(this.state.currentWordIndex) :
          downLevelWordsCorrectCriteriaMet(wordsCorrect, studentGrade, storyGrade, isCalibration, this.props.shouldUseAOS, this.props.story);

        if(shouldDownLevel){
          logSessionInfo('downlevel', {
            src: 'relevelTimer',
            wordsCorrect,
            errors: this.state.errors,
            currentPhraseErrors: errors,
            studentGrade,
            storyGrade,
            isRanStory,
            currentWordIndex: this.state.currentWordIndex
          });

          if (isCalibration) {
            // If the student is in calibration mode, exit assessment instead of downlevel
            const skipWaitModal = true;
            this.handleEndOfAssessment(statusType.PREREADER, skipWaitModal);
          } else {
            this.reLevel("long_pause");
          }
        }
        else if (!isCalibration && !isRanStory) {
          let {wcpm} = calculateMostRecentScores(this.state.errors, getAudioDuration());
          const locale = isSpanishStory(this.props.story) ? "es-mx" : "en-us";
          let wcpmPR = getWCPMGradePR(wcpm, this.props.story.grade, locale);

          logSessionInfo('uplevel_check', {
            src: 'relevelTimer',
            errors,
            wcpm,
            wcpmPR,
            locale,
          });

          //up level story if the student's wcpm is above 95% of the PR for the story's grade
          //and the student has not been downleveled
          // Set the uplevel grade to 13 if we are using AOS, grades don't go that high / need to ignore
          const maxUplevelGrade = this.props.shouldUseAOS ? 13 : (assignmentType === 'PROGRESS_MONITORING') ? 5 : 6;
          if(upLevelCriteriaMet(storyGrade, studentGrade, maxUplevelGrade, wcpmPR, this.props.shouldUseAOS, this.props.story)){
            logSessionInfo('uplevel', {
              src: 'relevelTimer',
              errors,
              wcpm,
              wcpmPR,
              locale,
            });
            this.reLevel("above_grade_level");
          }
        }
      }
    })
  }

  stopRelevelTimer(){
    relevelTimer.clear();
  }

  // when the studnet has made no progress for 60 seconds, if we're on the first page, relevel the assessment. Otherwise, throw up the error modal
  onLongPauseDetected(){
    if(this.props.asrStoryID) return;
    if(this.props.config.assessmentMode){
      return;
    }
    if(overallPhraseIndex === 0){
      // GT-400: safety net for opted-in phrase items whose own pause handling never handed control
      // back (e.g. a prompt that never finished speaking), so the pause-path skip never ran. Audio is
      // still streaming (shouldForceFirstWordSkip checks it), so this is not a mic problem and the
      // AUDIO modal would only restart the locked story.
      const longPauseLogPayload = { pathname: this.props.location?.pathname, activityId: this.state.activityId, currentPhraseIndex: this.state.currentPhraseIndex };
      if(this.shouldForceFirstWordSkip()){
        logSessionInfo("longpause_firstword_forced_skip", longPauseLogPayload);
        this.skipWord(false, true, false, false, FORCED_FIRST_WORD_SKIP_SOURCE.LONG_PAUSE);
        return;
      }
      logSessionInfo("longpause_firstword", longPauseLogPayload);
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().AUDIO}
          speech={this.props.speech}
          continue={this.restartAssignment}
          returnUrl={this.props.returnUrl}
        />
      );
    }
  }

  async reLevel(src=null){
    logSessionInfo("placement_logs",timings);

    // Prevent releveling if doNotRelevel is set
    if(this.state.doNotRelevel) {
      logSessionInfo("relevel_blocked_doNotRelevel", {doNotRelevel: this.state.doNotRelevel, src: src});
      return;
    }

    const downLevel = (src === null || ["long_pause", "frustration_error_count"].includes(src));
    const upLevel = (src === "above_grade_level");

    if (this.props.shouldUseAOS) {
      this.clearAssessmentStoryTimeouts();
      this.setState({pageNavEnabled: false});

      if (downLevel) {
        this.shouldDownLevel = true;
      } else if (upLevel) {
        this.shouldUpLevel = true;
      }

      const isRanStory = this.props.story && this.props.story.type === aosTaskTypes.ran;

      // If releveling in AOS, we call onTestletEnd to allow AOS to handle the releveling
      if(!isRanStory && downLevel && getStudentGradeLevel(true) <= 0){
        await flagNewEarlyReader(getUserData().userId,getUserData().locale);
        const fromRelevel = true;
        this.onTestletEnd(fromRelevel);
      }
      else {
        let props = {};
        props.textToSpeak = isRanStory ? COPY_STRINGS.try_different_story_ran : getCopyByGradeband(COPY_STRINGS, 'try_different_story');
        const fromRelevel = true;
        props.onEnd = () => this.onTestletEnd(fromRelevel);
        this.props.speech.speak(props);
      }

      return;
    }

    if(downLevel && getStudentGradeLevel(true) <= 0){
      await flagNewEarlyReader(getUserData().userId,getUserData().locale);
      const skipWaitModal = true;
      this.handleEndOfAssessment(statusType.PREREADER, skipWaitModal);
    }
    else {
      const status = upLevel ? statusType.UPLEVELED : statusType.DOWNLEVELED;
      studentRecordService.markAborted(this.state.activityId,status)
      .then((response) => {
        let props = {};
        props.textToSpeak = getCopyByGradeband(COPY_STRINGS, 'try_different_story');
        props.onEnd = () => {
          this.handleAbortedAssessment(src).then(() => {
            const currentGrade = parseInt(this.props.story.grade);
            const newGrade = downLevel ? currentGrade - 1 : currentGrade + 1
            setStudentGradeLevel(newGrade);
            this.restartAssignment();
          });
        }
        this.props.speech.speak(props);
      })
      .catch((error) => {
        console.error('Error marking activity aborted during relevel:', error);
        logSessionInfo('error_marking_aborted_relevel', {
          error: error?.message || error,
          activityId: this.state.activityId,
          status
        });
      });
    }
  }

  getInterventionSelectionV2Params() {
    const { errorCount, errorRate } = calculateMostRecentScores(this.state.errors);

    let overrideWCPM;
    let overrideARM;

    let overrideGrade = parseInt(this.props.forceInterventionSelectionGrade);
    overrideGrade = !isNaN(overrideGrade) ? overrideGrade : undefined;

    if (overrideGrade !== undefined) {
      switch (overrideGrade) {
        case 0:
          overrideWCPM = 16.5;
          break;
        case 1:
          overrideWCPM = 27.1;
          break;
        case 2:
          overrideWCPM = 73.8;
          break;
        case 3:
          overrideWCPM = 86.2;
          break;
        case 4:
          overrideWCPM = 90.3;
          break;
        case 5:
          overrideWCPM = 113.3;
          break;
        case 6:
          overrideWCPM = 128;
          break;
      }

      overrideARM = overrideGrade + 0.4;
    }

    let forceInterventionSelectionWCPM = parseInt(this.props.forceInterventionSelectionWCPM);
    forceInterventionSelectionWCPM = !isNaN(forceInterventionSelectionWCPM) ? forceInterventionSelectionWCPM : undefined;

    if (forceInterventionSelectionWCPM) {
      overrideWCPM = forceInterventionSelectionWCPM;
    }

    let forceInterventionSelectionARM = parseFloat(this.props.forceInterventionSelectionARM);
    forceInterventionSelectionARM = !isNaN(forceInterventionSelectionARM) ? forceInterventionSelectionARM : undefined;

    if (forceInterventionSelectionARM) {
      overrideARM = forceInterventionSelectionARM;
    }

    const interventionSelectionParams = {
      isESL: getUserData().isESL ? true : false,
      grade: getUserData().actualGrade,
      prev_equatedwcpm: overrideWCPM ?? getUserData().interventionSelectionWCPMScore,
      prev_arm_estimate: overrideARM ?? getUserData().interventionSelectionARMScore,
      error_count: errorCount,
      error_rate: errorRate,
    };

    let screeningWindow;
    const windowString = getScreeningWindow();
    if (windowString) {
      switch (windowString) {
        case "BOY":
          screeningWindow = 0;
          break;
        case "MOY":
          screeningWindow = 1;
          break;
        case "EOY":
          screeningWindow = 2;
          break;
      }
    }

    if (screeningWindow !== undefined) {
      interventionSelectionParams.window = screeningWindow;
    }

    if (this.props.forceSkill) {
      interventionSelectionParams.skill = this.props.forceSkill;
    }

    return interventionSelectionParams;
  }

  /**
   * Get user data parameters for logging to scatter gather
   * Returns an object containing user metadata for analytics and debugging
   */
  getUserDataParams() {
    const userData = getUserData();
    const browserInfo = device.getBrowserForSession() || {};
    
    return {
      grade: userData.actualGrade,
      studentId: userData.userId,
      districtId: userData.districtId,
      platform: browserInfo.os || 'unknown',
      browser: browserInfo.name || 'unknown',
      micSourceType: this.props.speech.getMicSourceType(),
      isESL: userData.isESL ? true : false,
    };
  }

  launchNextAssignment(skipPastLastEnglish = false){
    // the order of these two call matters, don't move them unless you know what you are doing.
    this.props.nextAssignment(skipPastLastEnglish);
    this.props.resetStory();
  }

  // TODO: make this work well with tutor (resetting back to the old story selection and skipping grade picker)
  // for now this will work as expected for assessment but will make tutor go back through story selection process
  restartAssignment(){
    // remove the most recent assignment (the one which was downleveled) from the list of "completed" assignments,
    //    and make it a failed parent in the chain instead
    this.props.setMidAssessment();
    let failedActivityId = removeLastActivityFromStack();
    this.props.setParentActivityId(failedActivityId);
    this.props.resetStory();
  }

  advanceOneWord() {
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.WORD_INCREMENT });
    let phraseErrors = this.getCurrentPhraseErrors() || [];
    phraseErrors.push(true);
    setSkipWindow(getSkipWindow() + 1);

    this.setCurrentPhraseErrors(phraseErrors);

    this.setState({
      lastProgress: defaultLastProgress,
    });
    this.syncTapToReadNextButton(phraseErrors.length);

    // Checek whether we should advance to the next phrase
    let cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    if(phraseErrors.length >= cleanPhrase.length){
      //we just skipped the last word
      
      // Tap-to-read mode: Let the Next button handle phrase end (don't auto-advance).
      // In tap mode, syncTapToReadNextButton (called above) already armed the button.
      // The student must click it to proceed; onNextButtonClick will call onPhraseEnd.
      if (isTapToReadBehavior()) {
        // Still clear the intervention timer since we're done with word-level interventions
        this.clearInterventionTimer();
        // Mark that we're no longer in an intervention process
        isWordInterventionInProcess = false;
        
        // Tap-to-read: Clear intervention flag and timeout
        this.clearTapToReadInterventionFlag();
        
        return; // Exit early; Next button click will complete the phrase
      }
      
      // Standard mode: Auto-advance to next phrase
      this.props.speech.stopListening();
      let isRecording = this.props.speech.isRecording();

      // Account for stop words, etc.
      for(let i=0; i<cleanPhrase.length; i++){
        phraseErrors[i] = this.finalizeError(cleanPhrase[i],phraseErrors[i]);
      }
      this.setCurrentPhraseErrors(phraseErrors);
      if(!this.state.endOfPhrase){
        this.handlePotentialEndOfPhrase();
      }

      this.clearInterventionTimer();
      const immutablePhraseIndex = Number(overallPhraseIndex);
      this.onPhraseEnd(isRecording, immutablePhraseIndex);
    }
  }

  /**
   * Sets the tap-to-read word-level intervention flag.
   * Does NOT start a timeout - timeout only starts if student tries to tap while blocked.
   * 
   * This is a safety mechanism for tap-to-read mode only.
   */
  setTapToReadInterventionFlag() {
    // Only run in tap-to-read mode
    if (!isTapToReadBehavior()) {
      return;
    }
    
    // Clear any stale timeout from a previous intervention before setting the flag
    // This prevents intervention B from inheriting intervention A's countdown
    if (this.tapToReadInterventionTimeoutRef) {
      window.clearTimeout(this.tapToReadInterventionTimeoutRef);
      this.tapToReadInterventionTimeoutRef = null;
    }
    
    this.tapToReadInterventionInProgress = true;
  }

  /**
   * Starts a 10-second timeout to auto-clear the intervention flag.
   * Called only when a tap is attempted while the flag is set.
   * If the intervention completes normally before 10s, the timeout is cleared.
   */
  startTapToReadInterventionTimeout() {
    // Only run in tap-to-read mode
    if (!isTapToReadBehavior()) {
      return;
    }
    
    // Clear any existing timeout first
    if (this.tapToReadInterventionTimeoutRef) {
      window.clearTimeout(this.tapToReadInterventionTimeoutRef);
    }
    
    // Set 10-second fallback timeout
    // This timeout serves as a fallback in case tapToReadInterventionInProgress is not cleared due to an unexpected issue.
    // The race condition is only a concern for giveword interventions. Other intervention types are displayed in a modal,
    // preventing the student from tapping to advance while the intervention is in progress.
    this.tapToReadInterventionTimeoutRef = window.setTimeout(() => {
      if (this.tapToReadInterventionInProgress) {
        console.warn('Tap-to-read intervention flag auto-cleared after 10s timeout');
        logSessionInfo(`tap_intervention_flag_timeout_phrase_${overallPhraseIndex}_word_${this.state.currentWordIndex}`);
        this.tapToReadInterventionInProgress = false;
      }
      this.tapToReadInterventionTimeoutRef = null;
    }, 10000);
  }

  /**
   * Clears the tap-to-read intervention flag and cancels any pending timeout.
   */
  clearTapToReadInterventionFlag() {
    this.tapToReadInterventionInProgress = false;
    
    if (this.tapToReadInterventionTimeoutRef) {
      window.clearTimeout(this.tapToReadInterventionTimeoutRef);
      this.tapToReadInterventionTimeoutRef = null;
    }
  }

  onWordTapped(index) {
    if (this.state.endOfPhrase || this.state.waitingForFinalTranscript) return;
    
    // Tap-to-read: Block taps during word-level intervention to prevent
    // race condition where both tap and intervention advance the cursor
    if (isTapToReadBehavior() && this.tapToReadInterventionInProgress) {
      // Start the 10-second fallback timeout (only if not already started)
      if (!this.tapToReadInterventionTimeoutRef) {
        logSessionInfo(`word_tap_blocked_intervention_in_progress_phrase_${overallPhraseIndex}_word_${this.state.currentWordIndex}`, {
          tappedIndex: index,
          overallPhraseIndex
        });
        this.startTapToReadInterventionTimeout();
      }
      
      return;
    }
    
    const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    if (!acceptTap({ tappedIndex: index, currentWordIndex: this.state.currentWordIndex,
                     phraseLength: cleanPhrase.length, lastAdvanceAt: this.lastTapAdvanceAt, now: Date.now() })) return;
    this.lastTapAdvanceAt = Date.now();
    // Per ticket: clear pause timeout on valid tap, then restart for the next word (product-confirmed).
    this.clearInterventionTimer();
    const phraseErrors = this.getCurrentPhraseErrors() || [];
    // Provisional value; safe: EDM replaces this array at end of phrase (onErrorsAreValid),
    // and `false` (correct) is intended for the leak-through cases (phonemes, last-word cheat).
    phraseErrors.push(false);
    this.setCurrentPhraseErrors(phraseErrors); // moves the cursor: currentWordIndex = totalErrors.length
    this.setState({ lastProgress: defaultLastProgress });

    // Tap-to-read: Do NOT start the intervention timer if we're at the last word.
    // At the last word, only the Next button flow should be active (no word-level interventions).
    const isAtLastWord = phraseErrors.length === cleanPhrase.length - 1;
    if (!isAtLastWord) {
      this.startInterventionTimer(null, this.getStudentPauseTime());
    }
    // Route the end-of-phrase button through the single source of truth (syncTapToReadNextButton)
    // rather than setting showNextButton directly, so the show/hide threshold lives in one place.
    // Pass the post-tap index explicitly since setCurrentPhraseErrors' setState may not have flushed.
    this.syncTapToReadNextButton(phraseErrors.length);
  }

  // forcedFirstWordSkip: a FORCED_FIRST_WORD_SKIP_SOURCE value when a GT-400 opted-in phrase item
  // forces past the first-word guard; tagged on chose_word_intervention for field tracking.
  skipWord(sayWord=true, force=false, noError=false, fromUNKFallback=false, forcedFirstWordSkip=null){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.WORD_SKIP });

    this.doneHandlingPause();

    //Don't ever advance on the first word of a story, unless we have manually passed a param in to
    //  force it. Right now we are using 'force' for our early reader activities because we want to be
    //  able to manually move the pre-reader forward as necessary
    if((this.state.currentWordIndex == 0) && (this.props.pageIndex == 0) && (this.state.currentPhraseIndex == 0) && !force) {
      isWordInterventionInProcess = false;
      
      // Tap-to-read: Clear intervention flag and timeout
      this.clearTapToReadInterventionFlag();
      
      return;
    }

    //Don't read if we're not listening.
    if((this.props.speech.isListening == false) && sayWord) {
      isWordInterventionInProcess = false;
      
      // Tap-to-read: Clear intervention flag and timeout
      this.clearTapToReadInterventionFlag();
      
      return;
    }

    let isRecording = this.props.speech.isRecording();
    let currentWord = this.getCurrentWord(this.state.currentWordIndex, true).trim();
    
    // Only track intervention if NOT from UNK fallback
    if (!fromUNKFallback) {
      this.setState({lastIntervention: interventionType.skip});
      wordDidIntervene({
        word: currentWord,
        type: interventionType.skip,
        index: this.state.currentWordIndex,
        ...(forcedFirstWordSkip ? { forcedFirstWordSkip } : {}),
      });
    }
    let props = {};
    props.textToSpeak = `"${currentWord}".`;
    props.skipTranslation = true;

    //Keep track of time we're not listening
    props.onEnd = ((startTime,isRecording,sayWord) => {
      let timeSpentIntervening = Date.now() - startTime;
      phraseTimeSpentIntervening += timeSpentIntervening;

      // Tap-to-read: clear the flag in the same synchronous block that advances the cursor.
      // The order of the two is not load-bearing (nothing can interleave), but they must not be
      // split across an async boundary. Under React 16 this setState flushes synchronously --
      // onEnd runs from a timer / native speech event, outside React's batching -- so
      // currentWordIndex is live before any tap can be dispatched. On a React 18 createRoot
      // upgrade that flush becomes deferred, and a tap landing in the gap would read a stale
      // cursor and double-advance; move this into a setState callback if we upgrade.
      // Note there is no throttle backstop: acceptTap ignores lastAdvanceAt (TODO TT-1005).
      this.clearTapToReadInterventionFlag();

      let phraseErrors = this.getCurrentPhraseErrors() || [];
      phraseErrors.push(noError ? false : true);

      this.setCurrentPhraseErrors(phraseErrors);

      this.setState({
        lastProgress: defaultLastProgress,
      });

      this.syncTapToReadNextButton(phraseErrors.length);

      // Widen out the single-match window
      // This is necessary because the skip intervention is moving the cursor forward and
      // as far as our diff algorithm is concerned any words uttered after this will look like
      // a skip, which will require multiple words to match unless we do this.
      // TODO: Re-evaluate this solution for this problem and look at directly modifying the transcript
      //       OR factoring the errors into the scoreTranscript.
      setSkipWindow(getSkipWindow() + 1);

      let cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
      if(phraseErrors.length >= cleanPhrase.length){
        //we just skipped the last word
        
        // Tap-to-read mode: Let the Next button handle phrase end (don't auto-advance).
        // In tap mode, syncTapToReadNextButton (called above) already armed the button.
        // The student must click it to proceed; onNextButtonClick will call onPhraseEnd.
        if (isTapToReadBehavior()) {
          // Still clear the intervention timer since we're done with word-level interventions
          this.clearInterventionTimer();
          // Mark that we're no longer in an intervention process
          isWordInterventionInProcess = false;
          
          return; // Exit early; Next button click will complete the phrase
        }
        
        // Standard mode: Auto-advance to next phrase
        this.props.speech.stopListening();

        // Account for stop words, etc.
        for(let i=0; i<cleanPhrase.length; i++){
          phraseErrors[i] = this.finalizeError(cleanPhrase[i],phraseErrors[i]);
        }
        this.setCurrentPhraseErrors(phraseErrors);
        if(!this.state.endOfPhrase){
          this.handlePotentialEndOfPhrase();
        }

        this.clearInterventionTimer();
        const immutablePhraseIndex = Number(overallPhraseIndex);
        this.onPhraseEnd(isRecording, immutablePhraseIndex);
      }else{
        if(!sayWord){
          this.startInterventionTimer(null);
        }
        if (this.networkMonitoringService && this.props.speech.isListening) {
          // Turn on network audio monitoring after skip word if we are not at end of phrase.
          // Guard on isListening (same as phraseStartCallback) so monitoring is never
          // armed while the mic is down — the detector must not measure a non-listening gap.
          this.networkMonitoringService.setAudioMonitoringActive(true);
        }
      }
      isWordInterventionInProcess = false;
    }).bind(this,Date.now(),sayWord ? isRecording:true,sayWord);

    if(sayWord){
      this.props.speech.speak(props);
    }else{
      window.setTimeout(props.onEnd,5);
    }
  }

  /** LOCAL INTERVENTION HANDLER **/
  // reads the current phrase aloud, highlighting the text in the passage to go along with the synthesized voice
  // when finished, updates the phrase index to move on to next phrase
  readAloudWithCallback(callback=null, readSlowly=true){
    let text = this.getCurrentPage()[this.state.currentPhraseIndex];

    if(text){
      let props = {};

      // stop listening when we start speaking
      props.onStart = ((event) => {
        this.props.speech.stopListening();
      });

      // start listening again, reset the interventionWordIndex so that we are no
      // longer highlighting words in the passage, and advance the phrase index
      props.onEnd= ((callback) => {
        this.setState({
          interventionWordIndex: -1,
        });
        if(callback){
          window.setTimeout(callback, 10);
        } else {
          if (!this.props.config.isNotInteractive) {
            this.startListening("readAloudWithCallback");
          }
        }
      }).bind(this,callback);

      // when we encounter a word boundary, highlight the currently spoken word
      // calculate the index of the highlighted word using the provided charIndex
      props.onBoundary = ((word) =>
        this.setState({
          interventionWordIndex: word.start,
        })
      );

      props.textToSpeak = text;
      if(readSlowly) {
        props.textToSpeak = "<prosody rate=\"slow\"> " + props.textToSpeak  + " </prosody>"
      }
      props.skipAvatar = false;
      props.skipTranslation = true;
      props.returnSpeechMarks = true;
      props.passThroughSpeechTags = true;
      this.props.speech.speak(props);
    }
  }

  readWithMe(){
    //TODO: embed this logic in `nextPhrase`. this will require a rework of existing logic
    if(this.state.currentPhraseIndex == (this.props.story.pages[this.props.pageIndex].length - 1)){//If Last Phrase
      if(this.props.pageIndex >= (this.props.story.pages.length - 1)){//If Last Page
        this.cleanUpAfterIntervention();
        return;
      }else{
        this.nextPhrase();
        this.props.goToNextPage();
      }
    }else {
      this.nextPhrase(this.props.speech.stopListening, false);
    }


    let callback = () => {
      this.tryAgain(getReadWithMePrompt(),false);
    }
    this.readAloudWithCallback(callback, true); // read aloud slowly
  }

  repeatAfterMeMode(){
    this.setIsLoading(false);
    let callback = () => {
      //TODO: should this use tryAgain, a different function or a new function?
      this.tryAgain(null, false, false);
    }
    this.readAloudWithCallback(callback, true); // read aloud slowly
  }

  endReadWithMeMode(){
    this.props.speech.speak({textToSpeak: COPY_STRINGS.end_read_with_me_mode});
    this.readWithMe();
  }

  initiateReadWithMeMode(){
    this.props.speech.speak({textToSpeak: COPY_STRINGS.read_with_me_mode});
    this.readWithMe();
  }

  playRepeatAfterMe(inWord,inIndex){
    this.setState({
      repeateAfterMeInterventionInProcess: true,
      interventionWord: inWord,
      interventionWordIndex: inIndex,
    });
  }

  /** SPEECH RECOGNITION **/
  startListening(source=""){
    if(!this.props.openModal){//do not listen for read phrases if the modal is open
      this.props.speech.startListening(source);
    }
  }

  /** TRANSCRIPTION PROCESSING **/
 getPauseCheck(progress, callback,source){
    return () => {

      const isBadNetwork = this.networkMonitoringService && getUserData().showBadNetworkResponse && this.networkMonitoringService.status === NetworkStatus.Bad;

      if((this.state.endOfPhrase == false) && this.props.speech.isListening && this.props.isReaderActive && isWordInterventionInProcess == false && !isBadNetwork){
        logSessionInfo("pause_check_fired",{holdOffs: interventionHoldoffs});
        callback();
      }
    }
  }


  //count the number of errors we have so far
  // if this number is greater than the story's frustration level, relevel the student
  // for now this only happens in assessment mode
  checkFrustrationLevel(errors){
    if(!this.props.config.assessmentMode || !this.props.orfMode){
      return;
    }
    
    // Skip frustration level checking if doNotRelevel is set
    if(this.state.doNotRelevel) {
      return;
    }

    errors = errors ? errors : this.state.errors;
    let accuracySoFar = calculateAccuracyFromScoredTranscript(errors);
    let studentGrade = getUserData().actualGrade;
    let storyGrade = parseInt(this.props.story.grade);
    logSessionInfo('downlevel_check', {
      src: 'accuracy',
      accuracy: accuracySoFar,
      errors,
      studentGrade,
      storyGrade,
    });

    if(downLevelAccuracyCriteriaMet(accuracySoFar, studentGrade, storyGrade, this.props.shouldUseAOS, this.props.story)){
      logSessionInfo('downlevel', {
        src: 'accuracy',
        accuracy: accuracySoFar,
        errors,
        studentGrade,
        storyGrade,
      });
      this.reLevel("frustration_error_count");
      return true;
    }
  }

  //This is a stub to use the phon stream for placement
  buildTranscriptFromPhons(phrase){
    let numWords = this.props.numPhonemes/1.5;
    let fakeTranscript = "";
    for(let i=0;(i<numWords && i<phrase.length);i++){
      fakeTranscript += phrase[i];
      if(i<phrase.length-1){
        fakeTranscript += " ";
      }
    }
    console.log(fakeTranscript);
    return {interim: fakeTranscript, final: fakeTranscript};
  }

  shouldUseStruggleMonitor(){
    //Use the struggle monitor if not a spanish story, if the global flag is enabled, and if this is a struggling reader

    // Don't use struggle monitor in ASR pre-check story
    if (this.props.asrStoryID) {
      return false;
    }

    // don't use struggle monitor if phoneme placement is enabled
    // currently setPhonemePlacementEnabled manages this flag
    if(getPhonemePlacementEnabled()){
      return false
    }

    return (!(this.props.story.tags && this.props.story.tags.includes("ES-MX")) && //Only if the story has no tags or is not spanish
              getUserData().useStruggleMonitor && isStrugglingReader() &&          //Only with struggling readers
              this.props.story.type === 'tutor');                                 //Only in tutor mode
  }

  evaluateStruggle(phonDelta){
    if(phonDelta && this.shouldUseStruggleMonitor()){
      if(expectedWord){
        const meta = this.props.currentWordMetadata;

        if (meta) {
          if(meta.abPHON){
            struggleType = struggleMonitor.rank(meta.abPHON, phonDelta).attemptKind;
          }else{
            console.log("NO ABPHON",expectedWord)
            struggleType = struggleMonitor.Attempt.SUCCEED;
          }
          wav2vecPhonemes.push({
            time: new Date().getTime() - totalTimeSpentIntervening - recordingStart - timeBetweenPages - this.props.speech.silentSegments().timingOffset,
            expectedWord: expectedWord,
            abPhon: meta && meta.abPHON,
            phonDelta: phonDelta,
            struggleType: struggleType
          })
          console.log("STRUGGLE",struggleType,meta.abPHON,phonDelta)
        } else {
          console.log('NO METADATA FOUND')
          struggleType = struggleMonitor.Attempt.SUCCEED;
        }
      } else {
        struggleType = struggleMonitor.Attempt.SUCCEED;
      }
    }else{
      struggleType = struggleMonitor.Attempt.SUCCEED;
    }
  }

  // checks the current transcription against the phrase to determine whether the user
  // is done reading the phrase and whether the user has read it correctly
  // if transcription for this phrase is finished, updates the UI accordingly
  checkTranscription(){
    let phrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    let newPhraseErrors = [];
    let noAudioTimer = this.state.noAudioTimer;
    const isSpanishCalibrationSoundActivity = this.props.spanishIsipCalibrationGuid && (this.props.story.type === aosTaskTypes.beginningLetterSound || this.props.story.type === aosTaskTypes.letterSound);

    if(phrase){
      // Check if this is an UpAndDown activity
      const currStory = this.props.story;
      const isItemTutorUpAndDownType = isItemTutorUpAndDown(currStory, overallPhraseIndex);
      
      // Check if Kaldi processing is enabled for UpAndDown
      const shouldUseKaldiForUpDown = FEATURE_FLAGS.ENABLE_KALDI_FOR_UPDOWN && isItemTutorUpAndDownType;
      
      // For UpAndDown activities with Kaldi enabled, convert the phrase from IPA to Kaldi format
      // because PlacementManager returns Kaldi phonemes (e.g., "k_phon ae_phon t_phon")
      // but the story content has IPA symbols (e.g., "k æ t")
      const processedPhrase = shouldUseKaldiForUpDown ? convertPhraseIpaToKaldi(phrase) : phrase;
      
      let cleanPhrase = cleanAndSplit(processedPhrase);
      //### Leave in for now until we're happy with placement
      // New Spanish PM sessions provide word-level transcripts, so skip the phoneme hack.
      let currentTranscript = (this.props.story && (this.props.story.type === assignmentTypes.DYSLEXIA || isSpanishCalibrationSoundActivity) && this.props.story.tags && (this.props.story.tags.includes("ES-MX") || this.props.story.tags.includes("ES_MX")) && !this.props.speech.getPlacementConfig().useSpanish && !this.shouldUseNewSpanishPlacementManagerInCurrentSession()) ? this.buildTranscriptFromPhons(cleanPhrase) : this.props.transcript;
      
      // Update didSaySomething flag if the student has said anything
      // Check if the transcript contains any content (including <UNK>)
      // Note: This flag is one-way - once set to true, it stays true until explicitly reset
      // at the start of each story to prevent race conditions where transcript temporarily becomes empty
      if (this.props.transcript && (this.props.transcript.interim || this.props.transcript.final)) {
        const interimText = this.props.transcript.interim || '';
        const finalText = this.props.transcript.final || '';
        const hasSaidSomething = (interimText.trim().length > 0) || (finalText.trim().length > 0);
        if (hasSaidSomething && !this.state.didSaySomething) {
          this.setState({ didSaySomething: true });
        }
      }

      //TODO: Reevaluate the signature of this method - way too many paramaters to pass.
      const letterNamingAndSoundsTypes = [assignmentTypes.LETTER_NAMING_AND_SOUNDS, aosTaskTypes.letterName, aosTaskTypes.letterSound, aosTaskTypes.beginningLetterSound, aosTaskTypes.letterNamingAndSounds];
      // Check if the current story type is a letter naming and sounds type
      const isLetterNamingAndSoundsType = letterNamingAndSoundsTypes.includes(currStory && currStory.type);
      // Spanish fuzzy match tuning: accent-normalized matching at min SPANISH_FUZZY_MATCH_THRESHOLD.
      const useSpanishFuzzyMatch = isSpanishStory(this.props.story) && this.shouldUseNewSpanishPlacementManagerInCurrentSession();
      const baseThreshold = currStory && (isLetterNamingAndSoundsType || shouldUseKaldiForUpDown) ? 1 : this.state.matchThreshold;
      const matchThreshold = useSpanishFuzzyMatch ? Math.max(baseThreshold, SPANISH_FUZZY_MATCH_THRESHOLD) : baseThreshold;
      const nlpOptions = useSpanishFuzzyMatch ? { stripDiacritics: true } : {};

      // Use matchWindow = 1 for upAndDown tutor with Kaldi enabled to enforce sequential sound matching
      const matchWindow = shouldUseKaldiForUpDown ? 1 : this.props.config.matchWindow;
      let scoredTranscript = scoreTranscript(processedPhrase, currentTranscript, this.state.currentWordIndex, matchThreshold,
      this.props.config.numMatchWords, matchWindow, this.props.config.assessmentMode, nlpOptions);
      let cleanTranscript = scoredTranscript.cleanTranscript;

      //TODO: think about moving this parsing into the Phrase component
      // if, based on the length of the transcription, we have not reached the end of the phrase yet
      if(cleanTranscript.length <= cleanPhrase.length){
        /*****************************************************************************
        * accumulators for state update, which will happen at the end of this function
        ******************************************************************************/
        let startReadingTimer = this.state.startReadingTimer;
        let lastProgress = this.state.lastProgress;
        /*****************************************************************************/

        // if we have made progress, update all of our pause check timers and our "last progress"
        if(lastProgress.transcriptLength !== cleanTranscript.length){
          // The just-matched word (value from cleanPhrase, index cleanTranscript.length - 1;
          // read directly rather than via the module-global expectedWord, which can go stale
          // after a skipWord intervention). This is transcript-indexed; struggleType is ranked
          // against the cursor-indexed currentWordMetadata, so after a skipWord (which advances
          // the cursor past an error the transcript hasn't matched) the two can name different
          // words. The guard combines them anyway — worst case is one extra advance committed or
          // deferred on an already-errored phrase. The util owns the LOW_EFFECT check, so pass a
          // plain stop-word flag; !!advancedWord only skips a pointless call on a skip-back where
          // cleanTranscript.length === 0 (isStopWord already tolerates it).
          const advancedWord = cleanPhrase[cleanTranscript.length - 1];
          if(shouldDeferLowEffortAdvance({
            transcriptLength: cleanTranscript.length,
            phraseLength: cleanPhrase.length,
            lastProgressLength: lastProgress.transcriptLength,
            struggleType,
            advancedWordIsStopWord: !!advancedWord && isStopWord(advancedWord),
          })){
            return;
          }

          struggleMonitor.reset();
          struggleType = this.shouldUseStruggleMonitor() ? struggleMonitor.Attempt.LOW_EFFECT : struggleMonitor.Attempt.SUCCEED;
          expectedWord = cleanPhrase[cleanTranscript.length];
          lastProgress = {
            transcriptLength: cleanTranscript.length,
            time: new Date().getTime(),
          };

          if(this.props.config.enableInterventions && !this.disableInterventionsForPhrase){
            if(startReadingTimer){
              window.clearTimeout(startReadingTimer);
              startReadingTimer = null;
            }
          }

          this.startInterventionTimer(lastProgress);
          interventionHoldoffs = 0;
          this.checkPageNavEnabled();
          if(noAudioTimer){
            window.clearTimeout(this.state.noAudioTimer);
          }
          noAudioTimer = window.setTimeout(this.getPauseCheck(lastProgress, this.onLongPauseDetected, "checktranscript").bind(this), 60000);
        }

        // Store the current transcript for the next comparison
        const interimTranscript = currentTranscript.interim || '';
        this.lastInterimTranscript = interimTranscript;

        // Implement the "skip-back" algorithm here.
        // Basic algorithm - if we've skipped ahead more than 2 words and read less than 4 words in a row,
        // then allow the user to skip back if the diff returns a match earlier in the string.
        // NOTE: Disabled in assessment mode

        // "Skip Back Logic"
        // We will allow a "skip back" if:
        // 1. A large-ish (> 2) skip was done.
        // 2. The student hasn't read more than 4 consecutive words after the skip
        // 3. The skip-back won't take us back to a word before the last word upon which we intervened or had UNK fallback.
        // The way we implement the skip-back is by simply not loading the last error state.
        // So, if we say that we want to reset the errors when:
        // (large skip) AND (short match) AND (the transcript is shorter than the error length) AND (skip is after the last word intervention/UNK fallback)
        // Then we only want to read the previous error state with the inverse of this logic, so:
        // IF !(large skip) OR !(short match) OR !(the transcript is shorter than the error length) OR !(desired word < last intervention/UNK fallback index)
        // One other note: we want to check the previous state of the skip metrics, because when we get
        // a "good" transcript the current state of the skip metrics will not trigger. IOW, what we're
        // really saying is that if we were skipped ahead before the current transcript, we want to trigger
        // the logic.
        let oldPhraseErrors = [];
        if((this.state.prevSkipMetrics.skipLength <= 2)
            || (this.state.prevSkipMetrics.matchLength > 4 ) || (this.getCurrentPhraseErrors().length <= (cleanTranscript.length+2))
            || (scoredTranscript.totalErrors.length < this.state.lastWordInterventionIndex)
            || (scoredTranscript.totalErrors.length < this.lastUNKFallbackIndex)){
          //store the result of the updated transcription
          oldPhraseErrors = this.getCurrentPhraseErrors();
        }

        let skipMetrics = calculateSkipMetrics(cleanTranscript);

        // combine the running error set with the newly calculated error set to produce our current errors.
        // if a word has been previously marked as correct, keep it correct in our new error set even if our new calculation disagrees
        let currentErrorLength = oldPhraseErrors.length;
        let newErrorHypothesis = scoredTranscript.totalErrors;
        //ensure that the error set is always growing
        let newErrorLength = Math.max(currentErrorLength, newErrorHypothesis.length);
        for(let i = 0; i < newErrorLength; i++){
          let expectedWord = cleanPhrase[i];
          let currentError = oldPhraseErrors[i]; //whether or not this word has been previously marked as an error

          // keep words correct which have previously been marked as correct
          if((currentError || i >= currentErrorLength) && i < newErrorHypothesis.length){
            let error = newErrorHypothesis[i];
            //If this is the last pass, mark all the noise words right
            if((newPhraseErrors.length >= cleanPhrase.length) || (this.state.testTimeExpired)){
              error = this.finalizeError(expectedWord,error);
            }
            newPhraseErrors[i] = error;
          } else {
            newPhraseErrors[i] = currentError;
          }
        }

        // if we've successfully moved the cursor, reset the skip window.
        if(newPhraseErrors.length > currentErrorLength){
          setSkipWindow('default');
        }

        // update the current word index and the score based on our new score data
        // note that this will also update the currentWordIndex, keeping the cursor consistant with our error length
        scoredTranscript.totalErrors = newPhraseErrors;
        this.setCurrentPhraseScore(scoredTranscript);

        //Calculate placement timings
        let timingObject = {
          position: newPhraseErrors.length + overallPosition,
          word: cleanPhrase[newPhraseErrors.length], //This is right (no -1) because we want to know where the cursor is.
          time: this.getPlacementTime(),
          transcript: this.props.transcript.interim,
          struggle: struggleType,
          errors: scoredTranscript.totalErrors,
          placementText: scoredTranscript.cleanTranscript,
          overallPhraseIndex
        }

        if((timings.length > 0) && (timings[timings.length-1].position !== newPhraseErrors.length)){
          timings.push(timingObject);
        }
        console.log("Streaming transcript: " + this.props.transcript.interim);
        /*********************************************************************
        * Update the state now that we have finished processing the transcript
        **********************************************************************/
        this.setState({
          noAudioTimer: noAudioTimer,
          startReadingTimer: startReadingTimer,
          lastProgress: lastProgress,
          prevSkipMetrics: skipMetrics,
        });
        /*********************************************************************/
      }

      // if we've hit the end of the phrase
      if((newPhraseErrors.length >= cleanPhrase.length) || this.state.waitingForFinalTranscript || (this.state.testTimeExpired)){
        //Deal with timing-related stuff regardless of whether we have a final transcript or not
        if(!this.state.endOfPhrase){
          this.handlePotentialEndOfPhrase();
        }

        this.clearInterventionTimer();

        // clear the "no audio timer"
        // this timer is used to call `onLongPauseDetected` if we have no progress after 30 seconds.
        // This progress monitoring is reset here because we don't want to be counting between phrases
        if(noAudioTimer){
          window.clearTimeout(noAudioTimer);
        }

        // If we are not in assessment mode, fire the end of phrase logic without waiting for the final transcript.
        // This has the net result of possibly cutting off part of the last word => we compensate for this in tutor
        // by using the front end 'answer' for the last word, but the assessment needs the whole recording.
        if(((!this.state.endOfPhrase) && (!(this.props.orfMode && getUserData().assessmentPageNavEnabled && this.props.config.assessmentMode)) ||this.state.testTimeExpired)){
          //Set the state variable to make sure this code only executes once
          this.setState({endOfPhrase: true});

          // Clear the phrase timeout if it exists to prevent phraseTimeoutRef from firing during the 500ms delay on next line
          this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
          this.phraseTimeoutRef.current = null;

          //###Put on a 500 ms delay to avoid cutting off the last word
          window.setTimeout(()=>{
            //call the function which ends this phrase, cleans up, and moves on to the next one
            const isRecording = this.props.speech.isRecording();
            const immutablePhraseIndex = Number(overallPhraseIndex);
            this.onPhraseEnd(isRecording, immutablePhraseIndex);
          },500)
        }
      }
    }
  }

  //This cleans up a single error - intended to be called as we iterate through our errors once we've hit the end of a phrase.
  finalizeError(expectedWord,inError){
    let error = inError;
    if((this.props.config.ignoreNoiseWords == true) && (isStopWord(expectedWord))){
      error = false;
    }
    return error;
  }

  //Handle various things when we believe we've reached the end of the current transcript
  handlePotentialEndOfPhrase(){
    this.clearInterventionTimer();
    totalTimeSpentIntervening += phraseTimeSpentIntervening;
    phraseTimeSpentIntervening = 0;

    this.setState({
      endOfPhrase: !this.props.config.assessmentMode,
      waitingForFinalTranscript: true, //This ensures that once we hit the end of phrase, we aren't reliant on the errors array to move on.
    });
  }

  findWordToIntervene(){
    let interventionIndex = this.state.currentWordIndex;
    return(this.getCurrentWord(interventionIndex, true)); //Don't do anything fancy, but keep the code below in case we want to turn it back on
  }

  /** READER UI **/

  //close the modal and start listening once it has been closed
  closeModal(advanceOneWord = false){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.CLOSE_MODAL });
    let onModalClose = null;
    if(!this.state.endOfPhrase){
      onModalClose = () => {
          if(this.props.speech && this.props.story && !this.props.story.nonAudio && this.state.storyInProgress){
            const isAtPhraseStart = this.state.currentWordIndex === 0 && !advanceOneWord;
            const waitForAsr = isAtPhraseStart && !this.props.asrStoryID && this.shouldWaitForAsrConnection();
            this.props.speech.startListening("closeModal", null, false, false, null, false, true, waitForAsr);
          }
          advanceOneWord && this.advanceOneWord();
      }
    }

    if(this.state.intervenedOnLastWord){
      this.setState({intervenedOnLastWord: false});
    }

    logSessionInfo("modalClosed_"+this.state.lastIntervention,{word: this.getCurrentWord().trim(), type: this.state.lastIntervention, index: this.state.currentWordIndex});
    this.props.closeModal(onModalClose);
  }

  abortIntervention(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.INTERVENTION_ABORT });
    // Call props.closeModal directly first to avoid race condition where abortListen and abortSpeech are resolved before the modal is unmounted
    // If modal is not unmounted before those calls, then cancellablePromise in intervention-library cannot work properly
    this.props.closeModal(); // It is safe for props.closeModal to be called multiple times, which will happen when we call this.closeModal()

    abortListen(this.props.speech, this.state.endOfPhrase);
    this.props.speech.abortSpeech(() => {
      if (this.state.endOfPhrase) {
        this.closeModal();
        this.cleanUpAfterIntervention();
      }else{
        this.onInterventionEnd();
      }
      logSessionInfo("interventionClosed", { pathname: this.props.location?.pathname, activityId: this.state.activityId, currentPhraseIndex: this.state.currentPhraseIndex });

      // Safegaurd to account for intervention audio right after clicking aborting sometimes gets through, but is so far disjuncted from this method
      window.setTimeout(() => this.props.speech.startListening("abortIntervention"), 2500);
    }, {returnToListening: true});
  }

  returnHome(){
    this.props.history.push('/student/home');
  }

  readAloudIntent(){
    if(this.props.config.squashedStory){
      this.readAloudWithCallback(this.returnHome);
    }else{
      this.readAloudWithCallback(() => {
        if(this.state.currentPhraseIndex == (this.props.story.pages[this.props.pageIndex].length - 1)){//If Last Phrase
          if(this.props.pageIndex >= (this.props.story.pages.length - 1)){//If Last Page
            this.returnHome();
          }else{
            this.props.goToNextPage();
          }
        }else {
          this.nextPhrase(this.readAloudIntent);
        }
      });
    }
  }

  /**
   * Sets the independent loading overlay state. This loading state is managed separately
   * from the main modal system to prevent other modal operations from inadvertently
   * affecting the loading indicator.
   * 
   * @param {boolean} isLoading - Whether to show (true) or hide (false) the loading overlay
   */
  setIsLoading(isLoading) {
    if (!this._isMounted) {
      return;
    }
    this.setState({ isLoading });
  }

  /**
   * The pre-checks ASR check story (as opposed to a normal story).
   *
   * Covers BOTH the Ready Module check at session start and the mid-session mic
   * troubleshoot: startMidSessionTroubleshoot sets preChecksDone back to false (App.js),
   * because rewinding the pre-checks is the whole point of that flow, and
   * StudentASRChecks' retry then pushes /student/pre-checks/asr — which mounts a reader
   * with a non-blank asrStoryID. An earlier revision of this claimed the opposite from
   * reading getReader's `!preChecksDone ? asrStoryId : ""` without checking who writes
   * preChecksDone; anything that reasons about "only at session start" is wrong here.
   *
   * Extracted because three separate decisions have to agree on it for TT-1217 to hold:
   * componentDidMount skips the fire-and-forget props prime, componentDidMount routes to
   * launchAsrCheckStory, and render applies the asrCheckReadingActivity class that hides
   * the reader subtree — which is the whole reason the wait has to be covered by
   * StudentASRChecks' spinner rather than this component's own loading overlay. Spelled
   * out separately in each place, they could drift apart silently.
   * @returns {boolean}
   */
  get isAsrCheckPath() {
    return Boolean(this.props.asrStoryID && !this.props.preChecksDone);
  }

  /**
   * The one warm point every story-launch path shares: prime the story's per-phrase LM
   * decode graphs, then measure whether this device can decode fast enough to serve
   * reading locally.
   *
   * The order is load-bearing. Warmup times phrase 0's biased HCLG graph, which the
   * download above it is what makes exist (TT-1209), so priming first is what makes the
   * measurement representative instead of a word-list-grammar approximation. And both
   * run before the story launches, while a loader is still up, so warmup spends idle
   * time rather than competing with the student's own audio for the decode queue.
   *
   * Awaiting to completion is the point, not a detail. If a phrase arms mid-run,
   * startPhrase calls cancelWarmup and the run reports WARMUP_VERDICT.CANCELLED with the
   * launch deadline unfired — which TT-1169 reads as "not a capability answer": no route
   * is latched and the once-per-session latch is released. A path that systematically
   * cancels its own warmup is a path that never gets measured, which is the TT-1158
   * failure mode (see launchAsrCheckStory).
   *
   * Neither callee throws and both are self-bounding — the graph prime by
   * LM_GRAPH_DOWNLOAD_DEADLINE_MS, the warm by WARMUP_CAP_MS + 1500 — so callers get a
   * bounded wait without needing a timeout of their own. Deliberately NOT wrapped in an
   * outer race: a bound that fires while the run is still in flight would let the next
   * phrase arm into it and produce exactly the live-audio cancel this exists to avoid.
   *
   * `story` is captured by the caller rather than re-read from props, so a story that
   * changes while the download is in flight cannot warm against the wrong graph.
   * @param {object} story
   * @returns {Promise<void>}
   */
  async primeAndWarmStory(story) {
    // The Spanish ASR check never decodes locally (GT-413), so it has no graphs to fetch and
    // must not spend the session's warmup measurement on a Spanish phrase.
    if (isSpanishAsrCheckStoryId(story?.storyId)) {
      return;
    }
    await this.downloadStoryLmGraphs(story);
    await warmLocalAsrForStory(story);
    // Phrase 0 gets no end-of-phrase prep (no preceding onErrorsAreValid), so decide its
    // routing here — recover its graph or route it to server ASR before the story launches
    // (TT-1283 phrase-0 gap).
    await this._prepareFirstPhraseBiasedGraph(story);
  }

  /**
   * Fire-and-forget prime-and-warm for stories that arrive via props.
   *
   * Now only a catch-all. The asrStoryID (Ready Module) path owns an awaited warm point
   * of its own (launchAsrCheckStory, TT-1217), so what is left here is the
   * assessment-direct / AOS testlet path — which is locally INELIGIBLE
   * (shouldUseLocalPlacementAsr returns false in assessmentMode) and so has no capability
   * verdict to establish — plus mounting with a story already in props. Both want the
   * graphs primed; neither can usefully hold a loader for a measurement.
   *
   * @param {object} story
   * @returns {void}
   */
  primeAndWarmStoryFromProps(story) {
    // The catch is load-bearing, not decoration: nothing awaits this chain, so an
    // escaping throw becomes an unhandled rejection. It records rather than swallows
    // because both callees already handle their own failures — graph priming so a
    // story never blocks on a missing graph, warmup so a measurement never blocks a
    // story — which makes anything arriving here a bug in the chain by definition,
    // and a bug that reaches a fire-and-forget catch leaves no other trace.
    this.primeAndWarmStory(story)
      .catch((error) => recordLocalAsrFailure('graphs.primeAndWarmThrew', {
        storyId: story?.storyId,
        error: error?.message,
      }));
  }

  /**
   * Downloads the story's per-phrase LM decode graphs (vosk biased HCLG .fst files)
   * up front, showing count-based progress in the loading overlay. Runs between story
   * fetch and activity launch (before Ready-Set-Go), only when the session uses local
   * ASR in vosk mode. Never blocks the story — the downloader bounds per-file fetches
   * and the total launch wait, and a phrase whose graph never arrives simply decodes
   * via the word-list grammar, so this resolves regardless. All the decision logic
   * (per-story dedup, progress-UI supersession, store clearing) lives in the unit-
   * tested storyLmGraphDownloader; this method just maps progress onto state.
   *
   * @param {object} story - The fetched story (storyId + phrases drive the file list)
   */
  async downloadStoryLmGraphs(story) {
    const startedAt = Date.now();
    try {
      const result = await this.lmGraphDownloader.download(story, {
        onProgress: (fraction) => {
          if (this._isMounted) {
            this.setState({ lmGraphProgress: fraction });
          }
        },
      });
      if (result) {
        const summary = { storyId: story?.storyId, durationMs: Date.now() - startedAt, ...result };
        // Recorded on the shared lifecycle timeline rather than as its own S3 object so
        // graph coverage sits next to the per-phrase fallbacks it predicts. `ok` false
        // always means some phrase will decode on the word-list grammar.
        if (result.ok) {
          recordLocalAsrLifecycle('graphs.downloadCompleted', summary);
        } else {
          // `unavailable` means the LM pipeline has not published this story yet, which is
          // expected and not a fault — still a degraded decode, so it is recorded, just
          // not shouted about. The recorder writes the console line either way.
          // EXCEPT when the prefix served non-graph bytes (`notAGraph` > 0): that is a
          // CDN misroute, never expected, and must stay loud here as well as on
          // graphs.storyUnpublished.
          recordLocalAsrFailure('graphs.downloadIncomplete', summary, {
            expected: Boolean(result.unavailable) && !result.notAGraph,
          });
        }
      }
    } catch (error) {
      // Previously console-only, so a wholesale download failure was invisible in the
      // session logs even though every phrase then decodes on the word-list grammar. The
      // recorder mirrors it to the console, so there is no separate line here.
      recordLocalAsrFailure('graphs.downloadThrew', {
        storyId: story?.storyId,
        durationMs: Date.now() - startedAt,
        error: error?.message,
      });
    }
  }

  /**
   * Re-download ONE phrase's biased LM graph on demand, bounded by budgetMs (TT-1283).
   * Recovers a phrase whose graph the up-front prime gave up on when the weak network has
   * since recovered. Writes into the existing story-graph store; a no-op when the graph is
   * already present, the story does not use local ASR, or the story has moved on.
   * @param {object} story
   * @param {number} overallGraphPhraseIndex Story-relative phrase index.
   * @param {number} [budgetMs] Max wait before backgrounding the download (defaults to the
   *   full reprime budget; the caller passes the remaining shared deadline so the download
   *   and the readiness warm together stay within one budget).
   * @returns {Promise<{ok: boolean, landed: boolean}>}
   */
  async ensureBiasedGraphForPhrase(story, overallGraphPhraseIndex, budgetMs = LM_GRAPH_REPRIME_BUDGET_MS) {
    return this.lmGraphDownloader.ensurePhrase(story, overallGraphPhraseIndex, { budgetMs });
  }

  /**
   * End-of-phrase preparation of the NEXT phrase's biased LM graph (TT-1283), run from
   * onErrorsAreValid while end-of-phrase timers are paused and no Next button is live.
   * For the next STORY-relative phrase (overallPhraseIndex + 1):
   *   1. If its graph is missing, await a bounded re-download (the weak network usually
   *      recovers mid-read, and nothing else re-primes a gave-up phrase).
   *   2. Ask local ASR whether the phrase will now decode on a real biased graph — this
   *      also load-bearing WARMS it, and only touches a graph that is present.
   *   3. If it will not (missing after the re-download, FST build failure, or unsupported
   *      runtime), mark the phrase for server placement so getRecordingProps routes it to
   *      server Kaldi instead of the defective word-list grammar. Otherwise clear any
   *      stale mark so the phrase decodes locally.
   *
   * Story-relative indexing is load-bearing: onErrorsAreValid's `phrases` is the current
   * PAGE, and state.currentPhraseIndex is page-relative, but the CDN graph file and the
   * _serverPlacementPhrases lookup are keyed on the story-wide overallPhraseIndex. Using
   * the page index would skip every page-first phrase (which is exactly where TT-1283
   * degraded) and never run on one-phrase-per-page stories.
   *
   * Guarded so it is a no-op unless the next phrase exists in the
   * STORY, this is not a retry/readback, and the session uses local ASR. Any failure is
   * swallowed (the phrase simply keeps its default routing) so a rejected re-download
   * cannot escape into onErrorsAreValid as an unhandled rejection.
   * @returns {Promise<void>}
   */
  async _prepareNextPhraseBiasedGraph() {
    const story = this.props.story;
    const storyId = story && story.storyId;
    // getStoryPhraseCount (not story.phrases.length) so this bound and ensurePhrase's bound
    // read the story the same way across the raw/transformed shapes.
    const phraseCount = getStoryPhraseCount(story);
    const nextPhraseIndex = nextPhraseGraphPrepTarget({
      storyId,
      retry: this.state.retry,
      currentOverallPhraseIndex: overallPhraseIndex,
      phraseCount,
      // Guarded on storyId so shouldUseLocalAsr is not evaluated when there is no story.
      usesLocalAsr: Boolean(storyId) && shouldUseLocalAsr({ storyLocale: getStoryContentLocaleOrNull(story) }),
    });
    if (nextPhraseIndex === null) {
      return;
    }
    // Speculative: the NEXT phrase may never be read (page abandon, testlet end, relevel),
    // so a warm build failure there must not report as a real degradation.
    await this._prepareBiasedGraphForPhraseIndex(story, nextPhraseIndex, { speculative: true });
  }

  /**
   * Prepare the FIRST phrase's biased LM graph at story launch (TT-1283), before
   * Ready-Set-Go. Phrase 0 has no preceding onErrorsAreValid, so it cannot be prepared
   * during an inter-phrase gap; without this, a phrase-0 graph that the up-front prime
   * gave up on (the weak-network story-start case this ticket is about) would arm local
   * ASR and decode on the defective word-list grammar. Runs on the story-launch path
   * (primeAndWarmStory) rather than phraseStartCallback, so the phrase-start lifecycle is
   * untouched. A no-op when the session does not use local ASR or the story is empty.
   * @param {object} story
   * @returns {Promise<void>}
   */
  async _prepareFirstPhraseBiasedGraph(story) {
    const storyId = story && story.storyId;
    // getStoryPhraseCount (not story.phrases.length) reads BOTH story shapes — the mainline
    // selectStory path hands over the raw chapters[0].phrases shape, on which story.phrases
    // is undefined; using .length there returned 0 and silently skipped phrase-0 prep, the
    // exact weak-network story-start case this method exists for. Matches downloadStoryLmGraphs
    // and _prepareNextPhraseBiasedGraph.
    const phraseCount = getStoryPhraseCount(story);
    if (
      !storyId
      || phraseCount === 0
      || !shouldUseLocalAsr({ storyLocale: getStoryContentLocaleOrNull(story) })
    ) {
      return;
    }
    // Not speculative: phrase 0 is about to be read, so a warm build failure here is a real
    // degradation and reports unlabeled.
    await this._prepareBiasedGraphForPhraseIndex(story, 0, { speculative: false });
  }

  /**
   * Prepare ONE story-relative phrase's biased LM graph (TT-1283), shared by the
   * end-of-phrase prep (next phrase) and the story-launch prep (phrase 0). If the graph
   * is missing, await a bounded re-download; then ask local ASR whether the phrase will
   * decode biased (this is also the load-bearing warm, and only touches a graph that is
   * present). If it will not — graph never downloaded, FST build failure, or a runtime
   * that cannot bind a graph — mark the phrase for server placement so getRecordingProps
   * routes it to server Kaldi instead of the defective word-list grammar; otherwise clear
   * any stale mark.
   *
   * Story-guarded at the WRITE, against the graph store's active story (not props.story,
   * which lags on the launch path): a superseded prep re-primes the store to the newer
   * story, so isStoryGraphStorePrimedFor rejects the stale write. The mark itself is tagged
   * with its storyId (_serverPlacementStoryId) and reads ignore a mismatched tag, so no
   * clear on story change is needed. Never throws — a failed re-download just leaves the
   * phrase on its default routing.
   *
   * INTENTIONAL BLAST RADIUS (TT-1283): this routes to server for ANY unusable-graph reason,
   * including a story whose graphs are not published at all (every phrase 404s). Such a
   * story previously decoded locally on the word-list grammar; it now reads on server Kaldi,
   * because that grammar is defective on the zoov lineage. Expect a corresponding rise in
   * placement.phraseFellBackToServer volume for unpublished-graph stories.
   * @param {object} story
   * @param {number} phraseIndex Story-relative index (matches the CDN `<storyId>_<n>.fst`).
   * @returns {Promise<void>}
   */
  async _prepareBiasedGraphForPhraseIndex(story, phraseIndex, { speculative = false } = {}) {
    const storyId = story && story.storyId;
    if (!storyId || !Number.isInteger(phraseIndex) || phraseIndex < 0) {
      return;
    }
    // Guard on the graph store's active story, NOT props.story. On the mainline launch
    // path primeAndWarmStory runs before setStory, so props.story still holds the previous
    // story and would wrongly discard phrase 0's decision; the graph store is already
    // primed for THIS story (downloadStoryLmGraphs ran first) and is re-primed to a newer
    // story on supersession, so it is the correct "still active" signal here.
    if (!isStoryGraphStorePrimedFor(storyId)) {
      // The store being unprimed for this story is a real decode degradation — phrase 0 (or
      // N) silently back on the defective word-list grammar — almost always because
      // primeStoryGraphs bailed on unusable inputs and cleared the store (missing ASSET_ROOT)
      // or the download threw. Recorded as an EXPECTED failure so it carries failure:true and
      // surfaces in the problem query over the flushed timeline (localAsrLifecycle), while
      // staying off console.warn since its cause is a known config state (TT-1283).
      recordLocalAsrFailure('graphs.prepStoreNotPrimed', { storyId, phraseIndex }, { expected: true });
      return;
    }
    // ONE shared deadline across both awaits (the download and the readiness warm), so the
    // total end-of-phrase / launch wait is at most LM_GRAPH_REPRIME_BUDGET_MS — not 2x.
    const deadline = Date.now() + LM_GRAPH_REPRIME_BUDGET_MS;
    const remaining = () => Math.max(0, deadline - Date.now());
    try {
      await this.ensureBiasedGraphForPhrase(story, phraseIndex, remaining());
      // Missing bytes is AUTHORITATIVE: the phrase cannot decode biased regardless of the
      // handler/runtime, so route to server. This holds even on the phrase-0 launch path
      // where the handler may not have finished init yet (prepareLocalAsrPhraseGraph would
      // otherwise fail open to "local"). Only when bytes are present do we consult the warm,
      // which is the only thing that can detect an FST build failure / unsupported runtime;
      // it is bounded by the remaining deadline (it queues behind the serialized decode
      // queue), defaulting to "not decodable" -> server on expiry.
      const bytesPresent = hasStoryGraph(storyId, phraseIndex);
      const willDecodeBiased = bytesPresent && await withBudget(
        prepareLocalAsrPhraseGraph({ storyId, phraseIndex }, { speculative }),
        remaining(),
        false,
      );
      // A newer story may have re-primed the store during the (bounded) wait — the store
      // is the active-story source of truth, so re-check it and drop a stale write. Silent:
      // supersession is expected, unlike the never-primed case above.
      if (!isStoryGraphStorePrimedFor(storyId)) {
        return;
      }
      // Tag the marks with this story; a story change resets the set so it only ever holds
      // one story's decisions (reads ignore a mismatched tag, so no clear-on-change needed).
      if (this._serverPlacementStoryId !== storyId) {
        this._serverPlacementPhrases?.clear();
        this._serverPlacementStoryId = storyId;
      }
      if (willDecodeBiased) {
        this._serverPlacementPhrases?.delete(phraseIndex);
      } else {
        this._serverPlacementPhrases?.add(phraseIndex);
      }
    } catch (error) {
      recordLocalAsrFailure('graphs.preparePhraseThrew', {
        storyId,
        phraseIndex,
        error: error?.message,
      });
    }
  }

  /**
   * Whether a phrase must decode on server Kaldi because it has no usable biased LM graph
   * (TT-1283). Single source of truth for both getRecordingProps (which routes the phrase)
   * and shouldWaitForAsrConnection (which skips the Kaldi wait for it), so the two readers
   * cannot drift. The prep's mark is authoritative — see _prepareBiasedGraphForPhraseIndex.
   * @param {number} overallGraphPhraseIndex Story-relative phrase index.
   * @returns {boolean}
   */
  _needsServerPlacement(overallGraphPhraseIndex) {
    // Only honor a mark whose story matches the story now in props (correct at phrase-start
    // read time). Require a truthy storyId so an absent story cannot produce a vacuous
    // undefined === undefined match, and stay null-safe for Object.create test instances.
    const storyId = this.props.story?.storyId;
    return Boolean(storyId
      && this._serverPlacementStoryId === storyId
      && this._serverPlacementPhrases?.has(overallGraphPhraseIndex));
  }

  //Display this while Amira is saying her opening statement during the assessment
  async openIntroModal(callback,type,story,isNotInitialTestlet,fromRelevel){
    // Close loading modal before showing intro modal
    this.setIsLoading(false);
    
    await this.props.speech.playAppSoundsWithPromise({
      url: silence,
      key: "silence",
    }, 2500);
    this.openModal(
      <div className="introModal labelFontOverride">
        {COPY_STRINGS.please_wait(GetBrandedTutorName())}
      </div>,
      { logName: "introModal", }
    );

    let textToSpeak = [];

    // select the intro text based on context
    // If this is the first activity in the browser session, greet the student
    if(this.props.firstAssignment && !isNotInitialTestlet){
      textToSpeak.push("<speak>" + COPY_STRINGS.hello + ", " + `"${getUserData().firstName}".` + "</speak>");
      if (this.props.forcedAssessment) {
        const introFunction = this.props.isNonVerbalAssignment ? COPY_STRINGS.assigned_amira_intro_non_verbal : COPY_STRINGS.assigned_amira_intro;
        textToSpeak.push(introFunction(GetBrandedTutorName()) + (FEATURE_FLAGS.UNIVERSAL_GENERATIVE_VOICE ? "" : " <break time=\"1.8s\"/> "));
      } else {
        textToSpeak.push(this.selfAssignedIntro);
      }
    }

    // Select the instructions based on activity type
    let assignment = this.getCurrentAssignment();
    // Use type passed into method if it exists, otherwise use assignment type
    const instructionType = type ? type : assignment.type
    let instructionText = (getActivityIntroText(instructionType, getUserData(), this.props.shouldUseAOS || isMockAOSNow(), this.props.isNonVerbalAssignment, this.props.isSpanishPilot))();

    if(this.props.story && this.props.story.alternateIntroText){
      textToSpeak.push(this.props.story.alternateIntroText);
    } else if (instructionText) {
      textToSpeak.push(instructionText);
    }

    //If we just did an activity in this browser session, give some props before continuing
    if(!this.props.firstAssignment || isNotInitialTestlet){
      textToSpeak = [COPY_STRINGS.next_section_transition];
      if (instructionText) {
        textToSpeak.push(instructionText);
      }
    }

    //If we just downleveled, forget all of the above and say the blurb for that.
    if(this.props.midAssessment || fromRelevel){
      textToSpeak = [this.getRepeatIntro()];
    }

    //If we're starting a reading comp activity, just speak the reading comp instructions
    //to avoid the redundancy in next_section_transition and repeatIntro
    if(instructionType === assignmentTypes.READING_COMPREHENSION && instructionText){
      textToSpeak = [instructionText];
    }

    if(this.props.skipIntros){
      textToSpeak = [this.devIntro];
    }

    let speechArray = textToSpeak.map((tts)=>{
      return({textToSpeak: tts})
    });

    let speechProps = {
      textToSpeak: speechArray,
      passThroughSpeechTags: true,
      onEnd: () => this.openGoModal(callback, story, instructionType),
    };

    this.props.speech.speakSequence(speechProps);
  }

  isERSSStory(story) {
    if (!story || !story.tags) {
      return false;
    }

    return story.tags.some(tag => tag.toLowerCase().includes('erss'));
  }

  openGoModal(callback, story, type){
    // Close loading modal before showing go modal or starting story
    this.setIsLoading(false);
    
    if(
      ( // If we are in an ERSS story, and we are not in an assessment ORF section
        this.isERSSStory(story) &&
        !(this.props.orfMode && this.props.config.assessmentMode)
      ) ||
      // If we are in an assessment and not in the ORF section
      ((!this.props.orfMode && type !== aosTaskTypes.assessment) && this.props.config.assessmentMode)
    ){
      //if this is an early reader or a dyslexia activity, skip the go modal
      // TODO: do this in a cleaner nicer way
      callback();
      return;
    }
    this.openModal(
      <GoModal
        callback={callback}
        speech={this.props.speech}
      />,
      { logName: "goModal", }
    );
  }


  /**
   * TT-1344: writes one tutor story-milestone file (activity_created / phrase_N_started /
   * story_ended) to the story_metrics S3 folder for near-real-time abandon-rate tracking.
   *
   * Tutor-only: assessments (assessmentMode) and ASR-check / Ready Module mic-check sessions
   * (truthy asrStoryID, which run through launchAsrCheckStory as 'tutor') write nothing, so
   * mic-check noise stays out of the abandon funnel. The activity id is resolved
   * getUserData().activityId first — setSessionActivityId writes the store synchronously while
   * setState({activityId}) is batched, so on the multi-story path state.activityId can still
   * hold the previous story's id when onStoryStart fires from componentDidUpdate (same reason
   * the STARTED-status calls in onStoryStart/onStoryEnd prefer getUserData). The day folder is
   * pinned on the first milestone (isFirstMilestone) so a session crossing midnight UTC keeps
   * all four files in one folder. Fire-and-forget: a write failure must never block the flow.
   *
   * @param {string} eventFileName - Milestone key, e.g. 'activity_created.json'.
   * @param {Object} [extra] - Extra payload fields merged into the milestone (e.g. phraseIndex).
   * @param {boolean} [isFirstMilestone] - When true, (re)pins the activity's day folder to today.
   */
  logStoryMilestone(eventFileName, extra = {}, isFirstMilestone = false) {
    if (this.props.config.assessmentMode || this.props.asrStoryID) {
      return;
    }

    const activityId = getUserData().activityId || this.state.activityId;
    if (isFirstMilestone || !this.storyMetricsDateFolder) {
      this.storyMetricsDateFolder = getFormattedUTCDate();
    }

    logStoryMetric(eventFileName, {
      activityId,
      storyId: this.props.story && this.props.story.storyId,
      timestamp: Date.now(),
      ...extra,
    }, activityId, this.storyMetricsDateFolder);
  }

  onStoryStart(){
    // Reset blank audio guard flag on story start to allow detection in new activity
    this._blankAudioTriggered = false;
    
    if (!this.props.shouldUseAOS) {
      this.props.logTimeOnStoryStart();//Log the time when the story starts, in AOS, this is called in the getTestlet response
    }
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "logged time on story start" });

    this.closeModal();
    this.setIsLoading(false);
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "closed modal" });

    this.props.initializeStoryWordMetadata(this.props.story, overallPhraseIndex, this.state.currentWordIndex);
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "initialized story word metadata" });

    setStudentLevelByGrade(this.props.story.grade);
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "set student level by grade", 'grade': this.props.story.grade });

    const currentActivityId = getUserData().activityId;
    if (!this.props.shouldUseAOS && currentActivityId) {
      studentRecordService.updateStatus(currentActivityId, statusType.STARTED)
        .catch((error) => {
          console.error('Error updating activity status to STARTED:', error);
          logSessionInfo('error_updating_activity_status', {
            error: error?.message || error,
            activityId: currentActivityId,
            status: 'STARTED'
          });
        });
    }

    // TT-1344: first story-milestone for tutor abandon-rate tracking; pins the activity's day
    // folder (see logStoryMilestone for tutor-only / mic-check gating and date pinning).
    this.logStoryMilestone('activity_created.json', {}, true);

    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "updated status to started" });

    // check the phrase type to see if we need to enable phoneme placement
    this.props.speech.setPhonemePlacementEnabled(shouldEnablePhonemePlacement(this.props.story, overallPhraseIndex, FEATURE_FLAGS.ENABLE_KALDI_FOR_UPDOWN));

    // Reset didSaySomething flag at the start of each story
    this.setState({storyStarted: true, storyLoaded: true, didSaySomething: false});
    if(this.props.story && this.props.story.type !== assignmentTypes.ASSESSMENT){
      // Use getUserData().activityId instead of this.state.activityId to avoid a race condition
      // where setState({activityId}) may not have flushed by the time onStoryStart fires.
      // setSessionActivityId sets userData_store.activityId synchronously before setState.
      if(this.isEarlyReader() && currentActivityId){
        updateErssStatus(getUserData().userId,currentActivityId,this.props.story.tags,'STARTED',this.props.story.storyId)
          .catch((error) => {
            console.error('Error updating ERSS status to STARTED:', error);
            logSessionInfo('error_updating_erss_status', {error: error.message, activityId: currentActivityId, status: 'STARTED'});
          });
      }

      //temporary fix for non-assessment activities being down-leveled. need to investigate why orfMode = true during tutor
      this.setState({
        frustrationLevelChecked: true,
        storyInterventions: this.getBoolArrayFromStory(this.props.story),
        // TT-1279: parallel per-phrase/word array marking which storyInterventions marks came from a
        // suppression (so the end-of-phrase EDM override can leave EDM's score for those indices).
        storySuppressedInterventions: this.getBoolArrayFromStory(this.props.story)
      });
    }else if(this.props.orfMode && this.props.config.enableAssessmentTimer){ //TODO: make a separate dyslexia config instead of checking mode here
      //Set up the assessment timer here if applicable
      let assessmentTime = this.props.config.developerMode ? 20000 : this.props.config.assessmentTime;
      assessmentTimer.set(assessmentTime)
      .then(()=>{
        handleAssessmentTimerExpiry({
          reLevel: this.reLevel,
          setTestTimeExpired: () => this.setState({ testTimeExpired: true }),
          currentGradeLevel: getStudentGradeLevel(true),
        });
      });

      //Set up the downleveling checks
      this.startRelevelTimer();
      this.setState({frustrationLevelChecked: false});
    }
  }

  getBoolArrayFromStory(story){
    if(story){
      return story.phrases.map((phrase)=>{
        return cleanAndSplit(phrase).map(()=>false);
      })
    }else{
      return [[]]
    }
  }

  onError(forceError = false){
    //for now only do this in assessment mode. It is less critical if an activity is not recorded in tutor mode
    if(this.props.config.assessmentMode || forceError){
      this.props.speech.abortSpeech();
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().ERROR}
          speech={this.props.speech}
          returnUrl={this.props.returnUrl}
        />
      );
      this.setState({
        error: true,
      });
    }
  }

  // We have different workflows depending on whether a student self-selected or whether a teacher assigned an activity.
  // This method is used when a student selects a story or picks "take a test" from the UI.
  async launchSelfAssignedActivity(id,callback,activityType,story){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_LAUNCH_SELF_ASSIGNED });

    this.setState({ NRTRecording: this.isNrtRecording() });

    try {
      // When we choose a story, create an activity object on the server to start tracking the student's audio and errors
      if(activityType === assignmentTypes.ASSESSMENT){
        this.setIsLoading(false);
        console.log("Forcing assignment");
        this.props.forceAssignment();
        return;
      }

      let { userId, schoolId, districtId, locale } = getUserData();
      let activityTags = [];
      // The Spanish ASR check is tagged whatever the session locale, so EPS runs the Spanish NRT pass (GT-413).
      if(locale === 'es-mx' || isSpanishAsrCheckStoryId(id)){ //TODO: this is gross. need to pick a locale format and use constants
        activityTags.push('ES_MX');
      }
      let assignmentId = this.props.studentAssignment ? this.props.studentAssignment.assignmentId : null;
      if (this.props.asrStoryID) { // Do not attach asr only activity to an assignment
        assignmentId = undefined;
      }
      console.log("Self assigned",id,callback,activityType,assignmentId);
      let response;
      try {
        response = await studentRecordService.createActivity(activityType, userId, id + "", activityStatus.SCORING_NOT_STARTED,statusType.LAUNCHED,districtId,schoolId,activityTags,assignmentId,this.props.period,this.props.schoolYear,this.props.onCampus);
      } catch (putActivityError) {
        this.setIsLoading(false);
        console.error("putActivity failed after retries", putActivityError);
        logSessionInfo("put_activity_launch_self_assigned_failure", {
          activityType,
          studentId: userId,
          storyId: id,
          error: putActivityError.message
        });
        logSentryException(new Error('Activity PUT failure in self-assigned launch'), 'putActivity failed in launchSelfAssignedActivity', { originalError: putActivityError?.message, originalStack: putActivityError?.stack });
        this.onStoryFetchFailure();
        return;
      }

      const { activityId } = response.data.putActivity;
      //Leave this log statement in - it's our only way of knowing what activityId was assigned
      // and tracing it through the system while debugging.
      console.log("Created new activity. activityId: ", activityId, activityType);
      this.resetAudioNetworkSignalsForActivity();
      setSessionActivityId(activityId, this.props.config.assessmentMode);
      
      // Log cursor-free mode status to activity bucket
      this.logCursorFreeModeStatus(story);

      // Log tap-to-read mode status to activity bucket
      this.logTapToReadModeStatus(story);

      this.logCursorBadSignalDecision(story);
      this.persistBadSignalPlacementForStory(story, activityId);

      // GT-413: the Spanish ASR check decodes on Spanish server ASR whatever the session locale.
      // Keyed off `id`, not props.asrStoryID, which App blanks once preChecksDone flips and can
      // change across the createActivity await above.
      const spanishContent = isSpanishAsrCheckStoryId(id);
      const useNewSpanishPlacementManager = shouldUseNewSpanishPlacementManagerForCurrentSession(
        this.props.config.assessmentMode,
        { spanishContent },
      );
      // Self-assigned: Spanish PM is tutor-only; this path has no inbox ASSESSMENT.
      const useSpanishPlacementForSession = activityType === assignmentTypes.TUTOR && useNewSpanishPlacementManager;
      this.props.speech.initializeSpeechSession(activityId,activityType === assignmentTypes.TUTOR ? getUserData().locale : 'en-us',isStrugglingReader(),useSpanishPlacementForSession,false /* useKaldiPhons */,spanishContent);
      logSystemData();
      // Use setState callback to guarantee activityId is in state before triggering
      // the story load. Without this, a race condition can cause onStoryStart to fire
      // (via componentDidUpdate) before activityId is flushed, leading to null activityId
      // in downstream calls like updateErssStatus.
      this.setState({activityId}, () => {
        if(this.props.config.assessmentMode){
          this.openIntroModal(callback, activityType, story);
        } else {
          if(this.props.asrStoryID){
            callback() // starts the story
          }else{
            this.openGoModal(callback, story);
          }
        }

        if(!this.props.config.assessmentMode){
          startEDMSession(this.onErrorsAreValidSafe,this.updateFrameTime, this.onDetectionEnd, this.props.isSpanishPilot);
        }
      });
    } catch (error) {
      console.error("launchSelfAssignedActivity", error);
      logSentryException(new Error('Self-assigned activity launch failure'), 'Error on launchSelfAssignedActivity', { originalError: error?.message, originalStack: error?.stack });
      throw error;
    }
  }


  getCurrentAssignment(){
    return this.props.forcedAssessment;
  }

  handleGetTestletError(result, context) {
    // Handle errors from getTestlet - don't retry on permanent errors
    if (result?.error) {
      logSessionInfo(`get_testlet_error_${context}`, {
        error: result.error,
        selectionError: result.error.selectionError,
        details: result.error.details
      });
      // Show error and return to home / student inbox (if returnUrl is present)
      this.onStoryFetchFailure();
      return true; // Indicates error was handled
    }
    return false; // No error to handle
  }

  markForcedAssessmentComplete(){
    if(this.props.forcedAssessment && this.props.forcedAssessment.activity && this.props.forcedAssessment.activity.length) {
      const completionPromises = this.props.forcedAssessment.activity
        .filter(activity => activity.status !== activityStatus.SCORING_NOT_STARTED)
        .map(activity => {
          let displayStatus = (this.isOldAssignment(this.props.forcedAssessment)) ? this.props.forcedAssessment.displayStatus : statusType.UNASSIGNED;
          return studentRecordService.markCompleted(activity.activityId, displayStatus)
            .catch((error) => {
              console.error('Error marking forced assessment complete:', error);
              logSessionInfo('error_marking_forced_assessment_complete', {
                error: error?.message || error,
                activityId: activity.activityId,
                displayStatus
              });
            });
        });
      return Promise.all(completionPromises);
    }
    return Promise.resolve(null);
  }

  isOldAssignment(activity){
    if(!activity) return false;

    switch(activity.displayStatus){
      case statusType.UNASSIGNED:
      case statusType.MUTED:
      case statusType.STUCK_PLACEMENT:
        return true;
      default:
        return false;
    }
  }

  async reparentAllPreviousActivities(newParentId){
    let activityStack = getActivityStack();

    const { results, errors } = await PromisePool
    .withConcurrency(3)
    .for(activityStack)
    .process(async act => {
      const success = await this.reparentActivity(act,newParentId);
      return success;
    })
    return Promise.resolve(errors && errors.length ? false : true);
  }

  reparentActivity(activityId,newParentId,retries = 3){
    return studentRecordService.setParent(activityId,newParentId)
    .then(resp=>{
      //Retry on any errors (note: The srs method won't throw, we get back errors in the payload)
      if(resp.errors || !resp.data || !resp.data.updateActivity.activityId){
        if(retries){
          console.log("RETRYING PARENT");
          return(this.reparentActivity(activityId,newParentId,retries-1))
        }else{
          logSessionInfo("reparent_failed",{activityId, newParentId,resp});
          const parentError = new Error("reparent_failed");
          logSentryException(new Error('Activity reparent failure'), 'Error reparent_failed', { originalError: parentError?.message, originalStack: parentError?.stack });
          return Promise.reject(parentError);
        }
      }else{
        return Promise.resolve(true);
      }
    })
  }

  // add current activity as a child to the parent activity id that is passed from App.js
  addNewChildToChain(newChildId){
    if(this.props.parentActivityId){
      return studentRecordService.setParent(newChildId, this.props.parentActivityId);
    } else {
      return Promise.resolve(null);
    }
  }

  doParenting(type, activityId) {
    const activityStack = getActivityStack();
    const letterNamingAndSoundsTypes = [assignmentTypes.LETTER_NAMING_AND_SOUNDS, aosTaskTypes.letterName, aosTaskTypes.letterSound, aosTaskTypes.beginningLetterSound, aosTaskTypes.letterNamingAndSounds];
    // Check if the current story type is a letter naming and sounds type
    const isLetterNamingAndSoundsType = letterNamingAndSoundsTypes.includes(type);

    if (type === assignmentTypes.READING_COMPREHENSION || isLetterNamingAndSoundsType) {
      let parentId = null;

      if (activityStack.length > 0) {
        const activityObjectStack = getActivityObjectStack();
        // Find the last assessment activity
        const lastAssessment = activityObjectStack.reverse().find(activity => activity.type === assignmentTypes.ASSESSMENT);
        // If there is no assessment activity, then the parent is the last activity in the stack
        parentId = lastAssessment ? lastAssessment.activityId : activityStack[activityStack.length - 1];
      } else {
        const currentAssignment = this.getCurrentAssignment();
        parentId = currentAssignment ? currentAssignment.parentId : null;
      }
      return parentId ? this.reparentActivity(activityId, parentId) : Promise.resolve();
    } else {
      return this.reparentAllPreviousActivities(activityId);
    }
  }

  isNrtRecording(){
    return !this.props.config.assessmentMode || 
    this.props.shouldUseAOS
  }

  async launchAssessmentTestlet(testletId, testletType, activityId, callback) {
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.TESTLET_LAUNCH_ASSIGNED, testletId});

    this.setState({ NRTRecording: this.isNrtRecording() });

    try {
      // TODO: change if we support non English AOS
      let activityTags = [];
      const { assignmentConfiguration } = getUserData();
      if(assignmentConfiguration){
        activityTags.push(assignmentConfiguration)
      }
      let isCalibration = false;

      // Skip creating activity, AOS creates existing activity
      console.log("Started assigned activity. activityId: ", activityId, testletType);
      this.resetAudioNetworkSignalsForActivity();

      setSessionActivityId(activityId, this.props.config.assessmentMode);
      const spanishPlacementLikeCalibration =
        this.props.spanishIsipCalibrationGuid || this.shouldUseNewSpanishPlacementManagerInCurrentSession();
      const isSoundActivity = testletType === aosTaskTypes.beginningLetterSound || testletType === aosTaskTypes.letterSound; // to be extended further

      // Spanish sound activities should not use spanish placement - it should use Kaldi Phons instead.
      // In assessment, Spanish pilot can still use new PM; district-license-only students stay legacy.
      this.props.speech.initializeSpeechSession(activityId,
                                                spanishPlacementLikeCalibration && !isSoundActivity ? 'es-mx' : 'en-us',
                                                isCalibration, // useStruggleMonitor
                                                spanishPlacementLikeCalibration && !isSoundActivity ? true : false, // useSpanishPlacement
                                                spanishPlacementLikeCalibration && isSoundActivity ? true : false, // useKaldiPhons
                                              );   
      logSystemData();
      // Use setState callback to guarantee activityId is in state before triggering
      // the story load. See launchSelfAssignedActivity for detailed explanation.
      this.setState({ activityId }, () => {
        // Assessment mode block, always true in this path
        this.openIntroModal(callback, testletType);
      });

    } catch (error) {
      console.error("launchAssessmentTestlet", error);
      logSentryException(new Error('Assessment testlet launch failure'), 'Error on launchAssessmentTestlet', { originalError: error?.message, originalStack: error?.stack });
      this.onError(
        true, // force the error to show
      );
    }
  }

  async launchAssignedActivity(id,callback,story){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_LAUNCH_ASSIGNED, storyId: id});

    this.setState({ NRTRecording: this.isNrtRecording() });

    try {
      let userData = getUserData();

      //First, mark the old assignment completed. This is to avoid concatenating data (such as audio) with a previous attempt.
      await this.markForcedAssessmentComplete();

      const currentAssignment = this.getCurrentAssignment();
      const type = currentAssignment && currentAssignment.type ? currentAssignment.type : assignmentTypes.ASSESSMENT;
      const locale = (currentAssignment && currentAssignment.locale) ? formatLocale_UpperCaseUnderscore(currentAssignment.locale) : 'EN_US';
      let activityTags = locale === 'ES_MX' ? [locale] : [];
      const {assignmentConfiguration} = getUserData();
      if(assignmentConfiguration){
        activityTags.push(assignmentConfiguration)
      }
      let isCalibration = currentAssignment && currentAssignment.isCalibration;
      if(currentAssignment && currentAssignment.tags) activityTags = currentAssignment.tags;
      
      // Handle BENCHMARK assignment type
      if (this.props.studentAssignment && this.props.studentAssignment.assignmentType === StudentInboxAssignmentTypes.BENCHMARK) {
        activityTags.push(StudentInboxAssignmentTypes.BENCHMARK);
        if (this.props.studentAssignment.tags) {
          const allowedTags = ['BOY', 'MOY', 'EOY'];
          const filteredTags = this.props.studentAssignment.tags.filter(tag => allowedTags.includes(tag));
          activityTags = activityTags.concat(filteredTags);
        }
      }
      
      // Add EXTEND_ASSESSMENT_TIME tag for Spanish assignments when conditions are met
      if (locale === 'ES_MX') {
        const hasAssignmentTag = this.props.studentAssignment && this.props.studentAssignment.tags && this.props.studentAssignment.tags.includes(EXTEND_ASSESSMENT_TIME_TAG);
        const hasUserMetadataFlag = getUserData().extendAssessmentTime;
        
        // Check if this is an excluded activity type
        const isExcludedActivityType = type === aosTaskTypes.ran || 
                                     type === 'nonsenseWordRepetition' || 
                                     type === 'retell' || 
                                     type === assignmentTypes.ASSESSMENT || // ORF
                                     type === 'visualAttention';
        
        if ((hasAssignmentTag || hasUserMetadataFlag) && !isExcludedActivityType) {
          activityTags.push("EXTEND_ASSESSMENT_TIME");
        }
      }
      
      // Dedupe activityTags to prevent duplicate tags
      activityTags = [...new Set(activityTags)];
      
      const assignmentId = this.props.studentAssignment ? this.props.studentAssignment.assignmentId : null;
      console.log("ASSIGNMENT:", currentAssignment);

      //Next, create a new activity with a status of "assigned". This will ensure the student's status remains assigned until they finish
      // if they happen to close the browser and not give us the ability to change it.
      let response;
      try {
        response = await studentRecordService.createActivity(type, userData.userId, id + "", activityStatus.ASSIGNED,statusType.LAUNCHED,getUserData().districtId,getUserData().schoolId,activityTags,assignmentId,this.props.period,this.props.schoolYear,this.props.onCampus);
      } catch (putActivityError) {
        this.setIsLoading(false);
        console.error("putActivity failed after retries", putActivityError);
        logSessionInfo("put_activity_launch_assigned_failure", {
          type,
          studentId: userData.userId,
          storyId: id,
          error: putActivityError.message
        });
        logSentryException(new Error('Activity PUT failure in assigned launch'), 'putActivity failed in launchAssignedActivity', { originalError: putActivityError?.message, originalStack: putActivityError?.stack });
        this.onStoryFetchFailure();
        return;
      }

      //Leave this log statement in - it's our only way of knowing what activityId was assigned
      // and tracing it through the system while debugging.
      const { activityId } = response.data.putActivity;
      console.log("Started assigned activity. activityId: ", activityId, type);
      this.resetAudioNetworkSignalsForActivity();

      //set the abandoned "assignment" activity as the parent of the new activity, so that we can keep track of the history of attempts/assignments
      await this.addNewChildToChain(activityId);

      // Reparent any children of the old activity to the one we created above
      await this.doParenting(type, activityId);

      setSessionActivityId(activityId, this.props.config.assessmentMode);

      // Log cursor-free mode status to activity bucket
      this.logCursorFreeModeStatus(story);

      // Log tap-to-read mode status to activity bucket
      this.logTapToReadModeStatus(story);

      this.logCursorBadSignalDecision(story);
      this.persistBadSignalPlacementForStory(story, activityId);

      const useNewSpanishPlacementManager = this.shouldUseNewSpanishPlacementManagerInCurrentSession();
      // Assigned (inbox): ASSESSMENT can use new PM for Spanish pilot, but district-license-only students stay legacy.
      const useSpanishPlacementForSession =
        type === assignmentTypes.ASSESSMENT ||
        (type === assignmentTypes.TUTOR && useNewSpanishPlacementManager);
      this.props.speech.initializeSpeechSession(activityId,
                                                (type === assignmentTypes.TUTOR || type === assignmentTypes.ASSESSMENT) ? getUserData().locale : 'en-us',
                                                isCalibration,
                                                useSpanishPlacementForSession,
                                                getUserData().locale === 'es-mx' && type === assignmentTypes.DYSLEXIA);
      logSystemData();
      // Use setState callback to guarantee activityId is in state before triggering
      // the story load. See launchSelfAssignedActivity for detailed explanation.
      this.setState({activityId: activityId}, () => {
        if(this.props.bifurcatedAssignment){
          this.displayStudentStatus();
          return;
        }else{
          if(this.props.config.assessmentMode){
            this.openIntroModal(callback,type,story);
          } else {
            this.openGoModal(callback,story);
          }
        }
        if(!this.props.config.assessmentMode){
          startEDMSession(this.onErrorsAreValidSafe,this.updateFrameTime, this.onDetectionEnd, this.props.isSpanishPilot);
        }
      });
      //If there is an existing activity ID, then set the set the parent/child relationship.
      //Examples of this are when we're transitioning from Dyslexia to ORF, or when we're downleveling.
      //This will allow the last activity taken in this session to carry all previous attempts as children, so we can
      //walk through the history.
      //NOTE: the way this works is to just set the parentId. The childId on the ORF will automatically get updated by the back end
      let stack = getActivityStack();
      if(stack.length){
        // TODO: Evaluate whether this should be in the promise chain or if it's ok to leave this async task hanging
        // TODO: Proper error handling.
      }
      //Finally, push this activity onto our local stack for the next go-round.
      addToActivityStack(activityId);
    } catch (error) {
      console.error("launchAssignedActivity", error);
      logSentryException(new Error('Assigned activity launch failure'), 'Error on launchAssignedActivity', { originalError: error?.message, originalStack: error?.stack });
      this.onError(
        true, // force the error to show
      );
    }
  }

  onStoryFetchFailure() {
    this.setIsLoading(false);
    this.openModal(
      <ErrorModal
        type={getErrorModalTypes().FATAL_STORY_FETCH_FAILURE}
        speech={this.props.speech}
        continue={() => this.props.history.push('/student')}
        returnUrl={this.props.returnUrl}
      />,
      { logName: "storyFetchFailure", }
    );
  }

  onRecFetchFailure() {
    this.openModal(
      <ErrorModal
        type={getErrorModalTypes().FATAL_REC_FETCH_FAILURE}
        speech={this.props.speech}
        continue={() => this.props.history.push('/student')}
        returnUrl={this.props.returnUrl}
      />,
      { logName: "recFetchFailure", }
    );
  }

  onPutActivityFailure() {
    this.openModal(
      <ErrorModal
        type={getErrorModalTypes().FATAL_PUT_ACTIVITY_FAILURE}
        speech={this.props.speech}
        continue={() => this.props.history.push('/student')}
        returnUrl={this.props.returnUrl}
      />,
      { logName: "putActivityFailure", }
    );
  }

  // when a story is selected in the story picker, open the go modal and wait until it's done doing its thing to actually set the story
  async selectStory(id){
    // Handle null or undefined story ID
    if (!id || id === '') {
      console.error('selectStory called with null or undefined id');
      this.onStoryFetchFailure();
      return;
    }

    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_PICKED, storyId: id});
    // Reset intervention history before beginning a story
    resetInterventionHistory();
    resetComprehensionQuizCount();
    
    this.closeModal();
    this.setIsLoading(true);

    // Update manifest item if manifestItemId exists
    if (this.props.studentAssignment && this.props.studentAssignment.manifestItemId) {
      const updateInput = [{
        assignmentId: this.props.studentAssignment.assignmentId,
        manifestId: this.props.studentAssignment.manifestItemId,
        storyId: id
      }];
      
      try {
        await updateManifestItems(updateInput);
      } catch (error) {
        console.error('Failed to update manifest item:', error);
        this.onStoryFetchFailure();
        return;
      }
    }
    
    let callback = () => {
      this.setStory(id);
    };

    return getStory(id)
    .then(async (story)=>{
      // TT-991: decide the cursor for THIS tutor activity. ReaderManager stays mounted across
      // activities, and the mount-time init runs the legacy rules only, so this is the one place
      // the bad-signal branch runs at all.
      //
      // Here because this is the one funnel both launch paths pass through, and because it
      // is upstream of the shouldShowCursorBehaviorFTUE() gate below that consumes the
      // decision. Immediately above the setStoryContext() push for the same reason
      // componentDidMount inits then pushes: a re-init resets story context.
      //
      // What it touches depends on the rollout: live, a full re-init; log-only, the decision is
      // recorded for the log and the student's state is left exactly as mounted -- see
      // refreshCursorSessionForActivity. Gated and tutor-only, per the AC.
      if (isBadSignalCursorEnabled() && story?.type === assignmentTypes.TUTOR) {
        refreshCursorSessionForActivity();
      }

      // Give the orchestrator the story-level context before any cursor behavior decisions
      setStoryContext({ isERSS: this.isERSSStory(story) });

      let activityType = story.type;
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_FETCHED, storyId: id, storyType: activityType});

      // Vosk local ASR: prime this story's per-phrase LM graphs, then measure (once per
      // session) whether this device decodes fast enough to serve reading locally. Both
      // happen here, behind the loading overlay, and before the activity launches — see
      // primeAndWarmStory for why that ordering is load-bearing. Bounded and
      // non-throwing: a slow device costs a few extra seconds of loader, never a story
      // that will not start (TT-1209).
      await this.primeAndWarmStory(story);

      if(!story){
        activityType = this.props.config.assessmentMode ? 'assessment' : 'tutor';
      }

      // Check if we should show the cursor behavior FTUE AFTER story fetch but BEFORE launching activity
      // The orchestrator folds in eligibility, FTUE completion, and story context (ERSS keeps the cursor)
      if (
        shouldShowCursorBehaviorFTUE() &&
        story &&
        story.type !== assignmentTypes.ASSESSMENT
      ) {
        // Store the continuation logic to run after FTUE completes
        this.ftueCallback = () => {
          if(this.props.forcedAssessment){
            this.launchAssignedActivity(id, callback, story);
          }else{
            this.launchSelfAssignedActivity(id,callback,activityType,story);
          }
        };
        
        // Show FTUE component - it will call onTutorFTUEComplete when done
        if (isTapToReadBehavior({ isERSS: this.isERSSStory(story) })) this.tutorFTUEMode = 'tap-to-read';
        else if (isCursorFreeBehavior({ isERSS: this.isERSSStory(story) })) this.tutorFTUEMode = 'cursor-free';
        if (this.tutorFTUEMode) {
          this.setState({ showingTutorFTUE: true, isLoading: false });
          return; // Exit early, FTUE will call ftueCallback when done
        }
      }
      
      // If no FTUE, continue normally
      if(this.props.forcedAssessment){
        this.launchAssignedActivity(id, callback, story);
      }else{
        this.launchSelfAssignedActivity(id,callback,activityType,story);
      }
    }).catch(err => {
      this.setIsLoading(false);
      console.log("Error getting story.", err)
      logSentryException(new Error('Story fetch failure'), 'Error getting story.', { originalError: err?.message, originalStack: err?.stack });
      this.onStoryFetchFailure();
    });
  }

  setStory(id){
    const callback = this.props.config.isReadAloud ? this.readAloudIntent : null;
    this.props.setStory(id, this.props.config, () => {
      if (callback) {
        callback();
      }
    });
  }

  /**
   * Launches the pre-checks ASR check story (Ready Module), giving it the awaited warm
   * point selectStory has (TT-1217).
   *
   * Runs for the mid-session mic troubleshoot too, not just the Ready Module check at
   * session start — see isAsrCheckPath. Mid-session the warmup latch is usually already
   * spent by the real story, so there is nothing left to measure: the hold is skipped
   * outright rather than spending a fetch and a graph download on it, and what it reports
   * says so rather than reading back the earlier story's decision as if this check had
   * produced it.
   *
   * Why this path needed one. The story used to be handed straight to props, and
   * ReaderManager's componentDidUpdate then ran in a single pass: the fire-and-forget
   * primeAndWarmStoryFromProps, then handleStoryChange -> onStoryStart, then Phrase
   * mounting and auto-starting. So phrase 0 armed while warmup was still running,
   * cancelWarmup fired, and the run reported CANCELLED with the launch deadline unfired —
   * which TT-1169 latches no route for and releases the latch on. A session that lives on
   * this path stayed unmeasured and kept routing local on eligibility alone, which is the
   * TT-1158 Chromebook failure exactly. Awaiting here, before the story reaches props, is
   * the only place that helps: props.setStory's own callback already runs after React has
   * committed, i.e. after onStoryStart.
   *
   * The wait is covered by the spinner in StudentASRChecks, not by this component's
   * loading overlay — the reader container is display:none for the whole pre-checks ASR
   * check, so the overlay renders inside a hidden subtree. setIsLoading is still driven
   * below because it also gates phraseStartCallback's ASR-connection handoff.
   *
   * @returns {Promise<void>}
   */
  async launchAsrCheckStory() {
    try {
      // Preserved verbatim from the previous inline branch: teacher tests skip the
      // overlay. Note this only ever suppressed an already-invisible overlay on this
      // route; it is kept because setIsLoading also feeds shouldWaitForAsrConnection.
      const isTeacherTest = new URLSearchParams(window.location.search).get('teacherTest') === 'true'
      if (!isTeacherTest) {
        this.setIsLoading(true);
      }

      // Whether there is a measurement to make at all. Eligibility is only half of that:
      // warmLocalAsrForStory also returns before doing any work once the once-per-session
      // latch is spent, and this path runs a SECOND time mid-session — the mic troubleshoot
      // rewinds preChecksDone, so isAsrCheckPath is true again long after the real story
      // measured. Holding then costs a fetch and a full graph download for a measurement
      // that cannot happen, on a student already in a broken-audio state, and buys nothing:
      // the componentDidUpdate catch-all primes the graphs a moment later regardless.
      //
      // Safe to read this early. The latch un-spends only via a live-audio CANCELLED run or
      // a dispose, neither of which is pending here — and if one did, the next story load
      // measures behind selectStory's loader instead, which is the better place anyway.
      //
      // NOT gated on isLocalAsrRuntimeReady(): the runtime can finish initialising during
      // the fetch and graph prime, so refusing to hold on a not-yet-ready runtime would
      // trade a real measurement for latency. That case is reported instead (runtimeReady
      // below), because it is the one this path hits most — the ASR check is the earliest
      // reading moment in the session.
      //
      // Deliberately shouldUseLocalAsr and NOT shouldDownloadStoryLmGraphs: the latter is
      // additionally gated on the Vosk backend, while warmLocalAsrForStory has no backend
      // gate — so gating the hold on it would leave a NeMo session running a full unheld
      // warmup and cancelling it, the very bug this method exists to close. No storyLocale
      // here: the ASR-check story has not loaded yet, so the resolver falls through to
      // tutorLocale (if set) or session locale (TT-1258).
      const warmupAlreadySpent = isLocalAsrWarmupSpent();
      // The Spanish ASR check never decodes locally (GT-413); the next story load measures instead.
      const eligible = shouldUseLocalAsr() && !isSpanishAsrCheckStoryId(this.props.asrStoryID);
      const shouldMeasure = eligible && !warmupAlreadySpent;

      // Captured before any await, for the same reason `story` is: this method now spans
      // seconds, and App.getReader blanks asrStoryID to "" once preChecksDone flips. No
      // remount is forced (readerKey does not change) and _isMounted does not cover a props
      // change, so re-reading it after the awaits could launch an activity against an empty
      // story id.
      const asrStoryId = this.props.asrStoryID;

      // Stamped before the fetch, not after it: heldMs is meant to answer "how long does
      // the student sit on the pre-checks spinner", and a fetch is part of that wait.
      const heldFrom = Date.now();

      // The story is only ever a measurement input here — the one that actually RENDERS
      // comes from props.setStory below, which refetches through getPaginatedStory.
      //
      // Prefer the copy useASRStoryPreload already fetched during the volume check
      // immediately before this one (it reaches us through getReader's {...routerProps}
      // spread). It is the same uncached API.getStory result, so it is shape-identical to
      // what a fetch here would return, and reusing it removes a full serial round-trip
      // from directly in front of the warm point — on exactly the poor-network population
      // this feature exists for. This is the first time that preload has actually saved a
      // request: the branch below used to consume it without avoiding the fetch. The id
      // check is defensive — StudentASRReaderWrapper already nulls a non-matching
      // preload, so it guards a future caller rather than today's.
      //
      // Note this hands a shared, Immer-frozen Redux object to the ASR path rather than a
      // private copy. Safe today because the graph downloader and warmLocalAsrForStory only
      // read from `story` — but that is an assumption worth restating, since
      // addStoryAttributes in this same codebase mutates the story it is given. Anything
      // downstream that starts writing to `story` will throw on the frozen object here
      // before it is noticed anywhere else.
      const preloaded = this.props.preloadedStory;
      let story = (preloaded && preloaded.storyId === asrStoryId) ? preloaded : null;
      let fetchMs = 0;

      // Best-effort: a failure costs the measurement, not the session. Routing it to
      // onStoryFetchFailure would turn a transient blip into an error modal for a fetch
      // App is about to retry on its own behalf.
      //
      // Bounded, unlike the prime and warm below, because it is the one leg of this hold
      // that has no deadline of its own: StudentRecordService.getStory retries twice with
      // growing backoff, so a flaky network could hold the spinner indefinitely before the
      // activity even exists. Losing the race just means no measurement — which this path
      // already handles — so the cheap bound is strictly better than an open-ended wait.
      // Not rare on the population that matters either: StudentVolumeChecks clears the
      // preload when the volume check errored, so a session that already had network
      // trouble arrives here with nothing preloaded and pays the full fetch.
      let declinedReason = null;
      if (!eligible) {
        declinedReason = 'ineligible';
      } else if (warmupAlreadySpent) {
        declinedReason = 'warmupAlreadySpent';
      }
      if (shouldMeasure && !story) {
        const fetchFrom = Date.now();
        // Timer captured and cleared rather than left to expire: on the common path the
        // fetch wins in a few hundred ms and this would otherwise keep a 4s timer and its
        // closure alive for nothing. Production-harmless, but a stray timer is exactly what
        // bleeds across tests, and this area has already produced two real-clock flakes.
        let budgetTimer;
        try {
          story = await Promise.race([
            getStory(asrStoryId),
            new Promise((resolve) => {
              budgetTimer = setTimeout(() => resolve(null), ASR_CHECK_STORY_FETCH_BUDGET_MS);
            }),
          ]);
          if (!story) {
            declinedReason = 'storyFetchTimedOut';
            recordLocalAsrFailure('graphs.asrCheckStoryFetchTimedOut', {
              storyId: asrStoryId,
              budgetMs: ASR_CHECK_STORY_FETCH_BUDGET_MS,
            });
          }
        } catch (error) {
          declinedReason = 'storyFetchFailed';
          recordLocalAsrFailure('graphs.asrCheckStoryFetchFailed', {
            storyId: asrStoryId,
            error: error?.message,
          });
        } finally {
          clearTimeout(budgetTimer);
        }
        fetchMs = Date.now() - fetchFrom;
      }
      if (!this._isMounted) {
        return;
      }

      // Snapshotted BEFORE the hold, because the route decision is module state that
      // outlives any one story: mid-session the real story has usually already latched one,
      // and reading it back afterwards would let this record claim the ASR check decided
      // something it never measured.
      const decisionBeforeHold = getLocalAsrWarmupRouteDecision();

      if (shouldMeasure && story) {
        // Same reasoning as the fetch above, and the same reason primeAndWarmStoryFromProps
        // still defends against this call: a capability measurement must never be able to
        // eject the student. Without this, a throw would reach the outer catch and fire
        // onStoryFetchFailure — failure UI and back to home because a measurement broke.
        // Latent today (both callees catch internally) but the invariant lives in a JSDoc
        // on another method, and the fire-and-forget caller does not trust it either.
        try {
          await this.primeAndWarmStory(story);
        } catch (error) {
          recordLocalAsrFailure('graphs.asrCheckWarmThrew', {
            storyId: story?.storyId,
            error: error?.message,
          });
        }
        if (!this._isMounted) {
          return;
        }
      }

      // Emitted on EVERY pass through this path, including the ones that declined to
      // measure, because the fleet query this feeds asks "does the gate fire on the ASR
      // check" — and absence of the event cannot distinguish "declined" from "build not
      // deployed" from "logs dropped". The failure records above stay as they are: those
      // flag a degradation worth alerting on, this one is the census.
      //
      // latchedThisHold, not `decided`, is the field to read. A decision merely EXISTING
      // afterwards proves nothing on this path: the mid-session mic troubleshoot runs the
      // check again with the latch already spent, so warmLocalAsrForStory returns without
      // measuring and the earlier story's decision is still sitting there. Only a decision
      // that appeared across this hold was produced by it.
      const decisionAfterHold = getLocalAsrWarmupRouteDecision();
      recordLocalAsrLifecycle('placement.asrCheckWarmHeld', {
        storyId: story?.storyId || asrStoryId,
        heldMs: Date.now() - heldFrom,
        fetchMs,
        usedPreloadedStory: Boolean(story) && story === preloaded,
        // `attempted`, not `measured`: this says the hold ran the warm, not that the warm
        // measured anything. warmLocalAsrForStory still returns before doing work when the
        // runtime is not ready yet, which is why runtimeReady rides alongside — without it
        // an undecided hold is ambiguous between "ran and stayed undecided" and "never
        // started", and telling those apart would mean correlating a separate
        // runtime.warmupSkipped line.
        attempted: Boolean(shouldMeasure && story),
        runtimeReady: isLocalAsrRuntimeReady(),
        declinedReason,
        warmupAlreadySpent,
        latchedThisHold: !decisionBeforeHold && Boolean(decisionAfterHold),
        route: decisionAfterHold?.route || LOCAL_ASR_ROUTE.UNDECIDED,
        verdict: decisionAfterHold?.verdict,
      });

      // The story still renders via props.setStory, even when the preloaded copy was used
      // for the measurement above.
      //
      // The branch this replaces had a hasPreloadedStory arm that looked like it avoided
      // that fetch and did not: it still called props.setStory (which refetches through
      // getPaginatedStory) and merely wrote state.paginatedStory / state.rawStory
      // afterwards, two fields nothing in this component reads. Its only other effect was
      // skipping setIsLoading(true) — an overlay that is display:none on this route
      // anyway. Deliberately not revived: the preload is worth reusing as a measurement
      // input, not as a render path, and rendering from the raw story would skip
      // pagination.
      const callback = () => {
        this.setStory(asrStoryId);
      };

      await this.launchSelfAssignedActivity(asrStoryId, callback, 'tutor');
    } catch (err) {
      if (!this._isMounted) {
        return;
      }
      // Reachable now in cases it was not before: the previous inline try/catch was
      // synchronous, so a rejection out of launchSelfAssignedActivity (which rethrows)
      // became an unhandled rejection and the student sat on a dead screen. It now
      // surfaces the same failure UI as a story-fetch failure.
      //
      // Distinct Sentry title on purpose. launchSelfAssignedActivity already reports
      // 'Error on launchSelfAssignedActivity' immediately before rethrowing, so reusing
      // that wording would file two near-identical events for one failure. This one means
      // "the ASR check could not be launched", whatever the cause — the outer catch also
      // covers throws from the pre-launch setup, not just the rethrow.
      this.setIsLoading(false);
      console.log('Error launching the ASR check story.  Returning to home: ', err);
      logSentryException(new Error('ASR check launch failure'), 'Error launching the pre-checks ASR check story.', { originalError: err?.message, originalStack: err?.stack });
      this.onStoryFetchFailure();
    }
  }

  initializeAssessmentStory(story) {
    const callback = this.props.config.isReadAloud ? this.readAloudIntent : null;
    this.props.setAssessmentStoryDirectly(story, () => {
      if (callback) {
        callback();
      }
    });
  }

  // Called when new assessment testlet is fetched.  Resets all story placement values
  updateAssessmentStory(story, callback){
    overallPhraseIndex = 0;
    // GT-400: the testlet reuses this instance; never carry a phrase item's opt-in across stories.
    this.allowFirstWordSkipOnPause = false;

    // Reset lastEndedPhrase when updating assessment story/testlet
    this.lastEndedPhrase = -1;
    this.lastInterimTranscript = '';
    this.lastUNKFallbackIndex = -1;
    this._serverPlacementPhrases?.clear();
    this._serverPlacementStoryId = null;

    this.setState({
      currentPhraseIndex: 0,
      currentWordIndex: 0,
      phraseEnded: false,
      endOfPhrase: false,
      pauseLength: this.getStudentPauseTime(), // NOTE: reset pause time to default value, prior to fetching word metadata
      waitingForFinalTranscript: false,
      lastProgress: defaultLastProgress,
      prevSkipMetrics: {skipLength: 0, matchLength: 0},
      isFinal: false,
      lastWordInterventionIndex: -1,
      retry: false,
      phraseComplete: false,
      minTimeElapsed: false,
      savedPhraseErrors: null,
      errors: [[[]]],
      simpleErrors: [[[true]]],
      errorCount: [],
      interventionWordIndex: -1,
      phraseTimes: [[]],
      lastProgress: defaultLastProgress,
      testTimeExpired: false
    }, () => {
      this.props.setAssessmentStoryDirectly(story, callback);
    });
  }

  clearAssessmentStoryTimeouts() {
    //clear all our timeouts
    this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
    this.state.noAudioTimer && window.clearTimeout(this.state.noAudioTimer);
    assessmentTimer.clear();
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
    this.state.pageNavRestrictedTimeout && clearTimeout(this.state.pageNavRestrictedTimeout);
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);

    if (badNetworkInterval) {
      window.clearInterval(badNetworkInterval);
      badNetworkInterval = undefined;
    }

    if (badNetworkPauseReadingTimeout) {
      window.clearTimeout(badNetworkPauseReadingTimeout);
      badNetworkPauseReadingTimeout = undefined;
    }

    if (badNetworkRetryPauseTimeout) {
      window.clearTimeout(badNetworkRetryPauseTimeout);
      badNetworkRetryPauseTimeout = undefined;
    }

    if (badNetworkCriticalTimeout) {
      window.clearTimeout(badNetworkCriticalTimeout);
      badNetworkCriticalTimeout = undefined;
    }

    if (badNetworkPauseListeningTimeout) {
      window.clearTimeout(badNetworkPauseListeningTimeout);
      badNetworkPauseListeningTimeout = undefined;
    }

    this.clearInterventionTimer();
    this.stopRelevelTimer();
  }

  openStoryPicker(renderBackToInbox = false){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_PICKER_OPENED });
    if(this.props.speech){
      if(this.state.recommendedStories && this.state.recommendedStories.length > 0){
        const content = getCopyByGradeband(COPY_STRINGS, 'which_story');
        const title = content(this.props.config.isReadAloud);
        this.openModal(
          <StoryPicker
            title={title}
            setStory={this.selectStory}
            close={this.closeModal}
            recommendedStories={this.state.recommendedStories}
            speakChooseStoryMessage={speakChooseStoryMessage}
            sendMessage={this.props.sendMessage}
            speech={this.props.speech}
            resetTranscript={this.props.speech.resetTranscript}
            renderBackToInbox={renderBackToInbox}
            returnUrl={this.props.returnUrl}
          />,
          {backgroundClose: false, key:"storyPicker", logName: "storyPicker"}
        );
      } else {
        const content = getCopyByGradeband(COPY_STRINGS, 'no_stories_text');
        this.openModal(
          <div className="emptyMessage">{content}</div>,
          {backgroundClose: false, key:"storyPicker", logName: "storyPicker"}
        );
        speakChooseStoryMessage(this.props.speech, this.state.recommendedStories, (() => this.props.history.push('/student/home')));
      }
    } else {
      window.setTimeout(this.openStoryPicker, 5);
    }
  }

  async openGradePicker(){
      if(this.props && this.props.speech){
        if(this.props.speech.isMicMuted) {
          this.openModal(
            <ErrorModal
              type={getErrorModalTypes().MUTE}
              speech={this.props.speech}
              continue={this.openGradePicker}
              returnUrl={this.props.returnUrl}
            />,
            { logName: "muteError" }
          );
        } else {
          // Always use the actual grade of the student in assessment
          let grade = getUserData().actualGrade;
          if(!this.props.config.assessmentMode || this.props.midAssessment){
            let studentGradeLevel = getStudentGradeLevel(true);
            grade = (this.props.midAssessment || ((studentGradeLevel || studentGradeLevel == 0) && (!getUserData().demoMode && (process.env.IGNORE_STUDENT_HISTORY !== 'TRUE')))) ? studentGradeLevel : getUserData().grade;
          }

          // If we are launching directly into a readingComprehension portion of an assessment, fetch the last ORF to determine the grade
          // Handles case where user was releveled on an ORF, restarted, and is now on the readingComprehension portion. We want comprehension grade to match the ORF grade
          if (
            this.props.config.assessmentMode &&
            this.props.assignmentIndex === 0 &&
            this.props.allAssignments &&
            this.props.allAssignments[0].activityType === assignmentTypes.READING_COMPREHENSION
          ) {
            const allStatuses = ["scored","rescored","assigned","not_started","in_progress","scoring","underReview","inProgress","reassess"]; // Provide all possible statuses to ensure we grab the latest ORF
            const orfActivities = await studentRecordService.studentActivities(getUserData().userId, 1, ["assessment"], allStatuses);
            if (orfActivities && orfActivities.length > 0) {
              const orfGrade = parseInt(orfActivities[0].story.grade);
              setStudentGradeLevel(orfGrade);
              grade = orfGrade;
            }
          }

          //If we have a valid grade, bypass the grade picker, unless we explicitly want to pick stories or are on staging
          if((grade !== null) && (process.env.ENABLE_GRADEPICKER !== 'TRUE') && !this.props.selectStories){
            this.selectGrade(grade);
          }else{
            this.openModal(
              <GradePicker
                close={this.props.closeModal}
                sendMessage={this.props.sendMessage}
                studentName={this.props.studentName}
                history={this.props.history}
                speech={this.props.speech}
                resetTranscript={this.props.speech && this.props.speech.resetTranscript}
                selectGrade={this.selectGrade}
              />,
              {backgroundClose: false, key:"gradePicker", logName: "gradePicker"}
            );
          }
        }
      } else {
        window.setTimeout(this.openGradePicker, 5);
      }
  }

  /**
   * IDs for getTestlet / startAssessment. When using dev mock AOS without a real assessment assignment, use placeholders.
   */
  getAosAssignmentFieldsForTestlet() {
    if (isMockAOSNow()) {
      return {
        assignmentId: this.props.studentAssignment?.assignmentId ?? '00000000-0000-0000-0000-000000000001',
        assignmentType: this.props.studentAssignment?.assignmentType ?? assignmentTypes.ASSESSMENT,
      };
    }
    return {
      assignmentId: this.props.studentAssignment.assignmentId,
      assignmentType: this.props.studentAssignment.assignmentType,
    };
  }

  async selectGrade(grade){
    struggleType = struggleMonitor.Attempt.SUCCEED; // Reset struggleType at start of activity
    setStudentLevelByGrade(grade);
    setStudentGradeLevel(grade);
    let activityType = assignmentTypes.TUTOR;
    if(this.props.config.assessmentMode){
      let currentAssignment = this.getCurrentAssignment();
      if (!currentAssignment) {
        console.log("No current task.");
        this.displayStudentStatus();
        return;
      }

      activityType = currentAssignment && currentAssignment.type ? currentAssignment.type : assignmentTypes.ASSESSMENT;
      if(currentAssignment && !this.props.bifurcatedAssignment) {
        currentAssignment && this.props.setLocale(formatLocale_LowerCaseHyphen(currentAssignment.locale));
      }
    }

    const mockNow = isMockAOSNow();
    // Real AOS: prop is state.shouldUseAOS && preChecksDone. Mock: URL can turn on after assignment fetch — don't rely only on that prop.
    const useAosTestletFlow =
      (mockNow && this.props.preChecksDone) ||
      (this.props.shouldUseAOS && (this.props.studentAssignment || mockNow));

    // For english only ASSESSMENTS, we call the AOS service to get the testlet
    // The AOS process handles building the story, so skip calling the usual getStoriesByGrade and selectStory flow
    if (useAosTestletFlow) {

      // If we are coming from a Spanish assignment that had a BREAK tag, then we should exit early and force a new session
      if(this.props.bifurcatedAssignment && !mockNow){
        this.displayStudentStatus();
        return;
      }

      // Reset intervention history before beginning a story
      resetInterventionHistory();
      resetComprehensionQuizCount();

      this.setIsLoading(true);

      try {
        const studentId = getUserData().userId;
        const { assignmentId, assignmentType } = this.getAosAssignmentFieldsForTestlet();
        const grade = getUserData().actualGrade;
        const districtId = getUserData().districtId;
        const schoolId = getUserData().schoolId;

        // Get locale from current manifest item (forcedAssessment) for startAssessment
        // Backend accepts both EN_US/en_US/en-us formats, so we can pass manifest locale as-is
        const currentAssignment = this.getCurrentAssignment();
        const locale = currentAssignment && currentAssignment.locale ? currentAssignment.locale : null;

        await AssessmentOrchestrationService.startAssessment({
          studentId,
          assignmentId,
          grade,
          districtId,
          schoolId,
          onCampus: this.props.onCampus || false,
          extendAssessmentTime: (this.props.studentAssignment && this.props.studentAssignment.tags && this.props.studentAssignment.tags.includes(EXTEND_ASSESSMENT_TIME_TAG)) || getUserData().extendAssessmentTime,
          locale: locale
        })

        const getTestletParams = {
          assignmentId,
          assignmentType,
          studentId: getUserData().userId,
          districtId: getUserData().districtId,
          schoolId: getUserData().schoolId,
          grade: getUserData().actualGrade,
          story: this.props.rawStory,
          activityId: this.state.activityId,
          testletId: this.state.assessmentTestletId,
        };

        let result = await AssessmentOrchestrationService.getTestlet(getTestletParams);

        // Check for errors first - don't retry on permanent errors
        if (this.handleGetTestletError(result, 'in_reader_manager')) {
          return;
        }

        let { story, activityId: newActivityId, testletId, shouldContinue, doNotRelevel } = result || {};

        // Mock suite cursor is module-global; past end => shouldContinue:false and inbox redirect. Rewind once and retry.
        if (isMockAOSNow() && result && !result.error && !shouldContinue) {
          resetMockAosTestletCursor();
          result = await AssessmentOrchestrationService.getTestlet(getTestletParams);
          if (this.handleGetTestletError(result, 'in_reader_manager_mock_retry')) {
            return;
          }
          ({ story, activityId: newActivityId, testletId, shouldContinue, doNotRelevel } = result || {});
        }

        // Mock: returnUrl redirect is skipped when isMockAOSNow(); if cursor reset still yields no story,
        // fail explicitly instead of throwing "Failed fetching testlet story" with opaque context.
        if (isMockAOSNow() && !story && !shouldContinue) {
          logSessionInfo('mock_aos_no_story_after_cursor_reset', { testletId });
          this.onStoryFetchFailure();
          return;
        }

        // Inbox / return URL is for real AOS when there is no testlet — never send dev mock there.
        if (!shouldContinue && this.props.returnUrl && !isMockAOSNow()) {
          logSessionInfo('no_initial_testlet_found');
          window.location.href = this.props.returnUrl;
          return;
        }

        if (!story) {
          throw new Error("Failed fetching testlet story");
        }

        let activityType = story.type;
        this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.TESTLET_FETCHED, storyId: story.storyId, storyType: activityType});

        this.setState({assessmentTestletId: testletId, activityId: newActivityId, doNotRelevel: doNotRelevel}, () => {
          const callback = () => {
            this.initializeAssessmentStory(story);
            this.props.logTimeOnStoryStart(); // Log the time when a new type starts
          };

          this.launchAssessmentTestlet(testletId, activityType, newActivityId, callback);
        });
      } catch (err) {
        this.setIsLoading(false);
        console.error("Error getting testlet.", err)
        logSentryException(new Error('Testlet fetch failure'), 'Error getting testlet.', { originalError: err?.message, originalStack: err?.stack });
        this.onStoryFetchFailure();
      }

      return;
    }

    // We are not in AOS mode, fetch story and proceed as normal
    const { locale: userSelectedLanguage } = getUserData();
    const isStudentAssignedTutorMode = this.props.studentAssignment && this.props.studentAssignment.assignmentType?.toLowerCase() === assignmentTypes.TUTOR;
    const assignedTutorLocaleMatched = !this.props.studentAssignment?.manifest || this.props.studentAssignment?.manifest?.find( item => item.locale?.toLowerCase() === userSelectedLanguage?.toLowerCase())
    const isSupportedStudentAssignedTutorMode = isStudentAssignedTutorMode && assignedTutorLocaleMatched && this.props.forceStory;
    const isURLForcedStoryMode = this.props.forceStory && !isStudentAssignedTutorMode;
    
    if(isURLForcedStoryMode || isSupportedStudentAssignedTutorMode){
      this.selectStory(this.props.forceStory);
    } else {
      this.getRecommendedStoriesAndOpenPicker(grade, activityType);
    }
  }

  canDisplayBackButtonOnStoryPicker() {
    return window.location.pathname === '/student/tutor' && this.props.fromStudentInbox;
  }

  getRecommendedStoriesAndOpenPicker(grade, activityType, resetStory = false){
    this.setIsLoading(true);
    const assignmentType = this.props.studentAssignment ? this.props.studentAssignment.assignmentType : null;
    const recommendationMode = this.props.forceSkill && this.props.forceSkill.startsWith('BK') ? recommendationModes.SEQUENCE_LOCKED : undefined;
    
    // Determine appType: TUTOR if no studentAssignment, INSTRUCT if studentAssignment exists and not in assessment mode
    const appType = !this.props.studentAssignment 
      ? APP_TYPE.TUTOR 
      : (!this.props.config.assessmentMode ? APP_TYPE.INSTRUCT : undefined);
    // filterOnGradeLimits is true only if appType is TUTOR, the license flag is enabled,
    // and the appSettings override has not disabled it.
    const filterOnGradeLimits = appType === APP_TYPE.TUTOR
      && getUserData().filterStoryOnGradeLimits === true
      && getUserData().appSettings?.forceFilterStoryOnGradeLimitsOff !== true;
    
    getStoriesByGrade(grade,activityType,assignmentType,this.props.selectStories, this.props.forceSkill, recommendationMode, false, appType, filterOnGradeLimits).then((stories) => {
      if (!this._isMounted) return;
      this.closeModal();
      this.setIsLoading(false);
      if(!(stories && stories.length !== 0)){
        logSessionInfo("bin_exhaustion",this.props.forcedAssessment);
        this.onNoStories();
        return;
      }
      // if we only have 1 story, skip the story picker and get straight into reading. Otherwise, open the story picker
      if(stories.length == 1){
        this.selectStory(stories[0].storyId);
      } else {
        this.setState({
          recommendedStories: stories,
        }, () => this.openStoryPicker(this.canDisplayBackButtonOnStoryPicker()));
      }
    })
    .catch(err=>{
      console.log("ERROR IN SELECT GRADE",err);
      logSentryException(new Error('Grade stories fetch failure'), 'Error getting stories by grade', { originalError: err?.message, originalStack: err?.stack });
      // Guard below logging so stale-instance failures are still reported to Sentry
      if (!this._isMounted) return;
      this.setIsLoading(false);
      this.onRecFetchFailure();
    });
  }

  setPhraseGrammar(index){
    let phrases = this.getCurrentPage();

    if(this.props.speech && phrases[index]){
      this.props.speech.setGrammar(phrases[index]);
    }
  }

  // advance the phrase index, moving focus to the next phrase of the page
  nextPhrase(callback=null, enableRecording = true){
    // Tap-to-read: Clear intervention flag at phrase boundary to ensure fresh start for new phrase
    this.clearTapToReadInterventionFlag();
    
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_INCREMENT });
    // reset the aiService's record of word-level interventions
    trackWordInterventionPhraseBoundary();

    if(!this.state.minTimeElapsed && this.phraseRespectsMinTimeElapsed()){
      return;
    }
    handledErrors = false;
    setSkipWindow('default');
    this.setDisableInterventionsForPhrase(false);
    this.setAllowFirstWordSkipOnPause(false);
    this.setPhraseGrammar(this.state.currentPhraseIndex + 1);
    overallPhraseIndex++;
    // Pages that skip onPhraseEnd (goToNextPage → nextPhrase) would otherwise
    // fold leftover acks into the next phraseIndex. Drain after increment.
    this.networkMonitoringService?.drainPhraseAcks?.();
    
    // Reset interim transcript tracking when moving to a new phrase
    this.lastInterimTranscript = '';
    this.lastUNKFallbackIndex = -1;

    // check the phrase type to see if we need to enable phoneme placement
    this.props.speech.setPhonemePlacementEnabled(shouldEnablePhonemePlacement(this.props.story, overallPhraseIndex, FEATURE_FLAGS.ENABLE_KALDI_FOR_UPDOWN));

    this.setState({
      currentPhraseIndex: this.state.currentPhraseIndex + 1 ,
      phraseEnded: false,
      currentWordIndex: 0,
      pauseLength: this.getStudentPauseTime(), // NOTE: reset pause time to default value, prior to fetching word metadata
      endOfPhrase: false,
      waitingForFinalTranscript: false,
      lastProgress: defaultLastProgress,
      prevSkipMetrics: {skipLength: 0, matchLength: 0},
      isFinal: false,
      lastWordInterventionIndex: -1,
      retry: false,
      phraseComplete: false,
      minTimeElapsed: false,
      savedPhraseErrors: null,
      isFirstAssessmentItemOfType: false, // After first item/phrase, set to false
    }, callback);
  }

  getCurrentWord(index=this.state.currentWordIndex, forDisplay = false){
    let word = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex], forDisplay)[index];
    return word || '';
  }

  buildPhraseId(phraseIndex){
    let phraseId = "";
    let title = this.props.story.title.replace("\'","");
    title = unidecode(title);
    title = cleanAndSplit(title);
    phraseId = title.join('_');
    let graphSuffix = "_" + (phraseIndex+1);

    if(this.props.speech.altPlacement && this.props.config.assessmentMode && this.props.orfMode){
        graphSuffix += "_page";
    }

    phraseId += graphSuffix;
    return {phraseId,graphSuffix};
  }

  // Return the equivalent intervention types for the current (if any) ERSS skill that user is on.
  //    Used to disable said intervention when determining interventions
  getCurrentERSSInterventionTypes() {
    const tags = this.props.story.tags;

    if(!tags) return [];

    if (tags.includes("EARLY_READER_CHANGE_ONE_PART")) {
      return [interventionType.changeOnePart1];
    }

    if (tags.includes("EARLY_READER_UP_AND_DOWN")) {
      return [
        interventionType.upAndDown1,
        interventionType.upAndDown2,
        interventionType.upAndDown3
      ];
    }

    if (tags.includes("EARLY_READER_LETTER_FLIES")) {
      return [interventionType.letterFlies];
    }

    if (tags.includes("EARLY_READER_ELKONIN_BOXES")) {
      return [
        interventionType.elkoninBox0,
        interventionType.elkoninBox1,
        interventionType.elkoninBox2,
        interventionType.elkoninBox3,
        interventionType.elkoninBox4
      ];
    }

    return [];
  }

  // reset the phrase transcript and error tracking for the current phrase,
  // and prompt the reader to try reading the phrase again
  tryAgain(customGambit=getTryAgain(),disableRecording=true,speakPrompt=true){
    let callback = function () {
      // Tap-to-read: Clear intervention flag and timeout on retry
      this.clearTapToReadInterventionFlag();
      
      this.setCurrentPhraseErrors({});
      let myRecordingProps = JSON.parse(JSON.stringify(this.state.recordingProps));
      myRecordingProps.disableBackend = disableRecording;
      myRecordingProps.done = false;
      this.props.speech.enableRecording(myRecordingProps); // logs socket_connected event
      this.props.speech.startListening("tryAgain");
      this.lastInterimTranscript = '';
      this.setState({
        lastProgress: defaultLastProgress,
        currentWordIndex: 0,
        pauseLength: this.getStudentPauseTime(),
        callbackAfterIntervention: null,
        interveningAtEndOfPage: false,
        isFinal: false,
        endOfPhrase: false,
        waitingForFinalTranscript: false,
        retry: disableRecording ? true:false,
      });
      
      // Cursor-free & tap-to-read: reset the Next-button state for the new retry attempt.
      // The cursor was reset to word 0 above, so pass 0 explicitly (the setState may not have
      // flushed yet): single-word tap phrases re-show the button, multi-word ones clear it until
      // the student taps back to the end. Without covering tap mode here, a single-word phrase
      // retry would leave no button and no tappable word — a dead end.
      // !isERSSStory: defense-in-depth until TT-1012 (see componentDidMount) -- ERSS keeps the cursor.
      if (isCursorFreeBehavior() || isTapToReadBehavior()) {
        this.phraseEndedViaNextButton = false;
        this.startNextButtonTimer();
        this.syncTapToReadNextButton(0);
      }
    }.bind(this);

    if(speakPrompt){
      let props = {};
      props.text = customGambit;
      props.callback = callback;
      this.props.sendMessage(props);
    }else{
      callback();
    }
  }

  getCurrentPage(){
    if (this.props.shouldUseAOS && !this.state.storyLoaded) {
      return [];
    }

    if(this.props.story){
      return this.props.story.pages[this.props.pageIndex];
    } else {
      return [];
    }
  }

  getCurrentPhraseMetaData(){
    let currentMeta = {};
    if(this.props.story && this.props.story.items && this.props.story.items[overallPhraseIndex]){
      currentMeta = this.props.story.items[overallPhraseIndex];
    }
    return currentMeta;
  }

  clearTimingSessionVariables(){
    timings = [{time: 0, position: 0}];
    overallPosition = 0;
    timeBetweenPages = 0;
    lastRecordingStop = 0;
    phraseStartTime = 0;
    totalTimeSpentIntervening = 0;
    stopTime = 0;
    handledErrors = false;
    predictionConfidences = [];
    phraseDelays = [];
    interventionTime = 0;
    interventionHoldoffs = 0;

    if (this.props.shouldUseAOS) {
      recordingStart = 0;
      errordelay = 0;
      lastDelay = 0.0;
      averageDelay = 0;
      inProgressTimingSlices = [];
    }
  }

  clearTimingVariables(){
    this.clearTimingSessionVariables();
    phraseTimeSpentIntervening = 0;
  }

  resetInProgressTimingSessionVariables(){
    timings = [{time: lastRecordingStop - recordingStart, position: 0}];
    overallPosition = 0;
  }

  cleanUpAfterAssessment(aborted){
    this.clearTimingVariables();

    const shouldExitAfterAOS = this.props.shouldExitAfterAOS();

    //We are done if and only if:
    //1. We are using AOS and there are no Spanish items after AOS OR
    //2. It's the last assignment in a sequence OR
    //3. If we've aborted, the test is not a Spanish test, and either the student is not an ESL or if the student is an ESL and the English story isn't first.
    //If none are true, then we move on to the next assignment.
    if(
      (this.props.shouldUseAOS && shouldExitAfterAOS) ||
      this.props.lastAssignment ||
      (aborted && !isSpanishStory(this.props.story) &&
      (!getUserData().isESL ||
      (getUserData().isESL && (getUserData().spanishConfig !== 'BOTH_TWO_SESSIONS_ENGLISH_FIRST') && (getUserData().spanishConfig !== 'BOTH_ONE_SESSION_ENGLISH_FIRST'))
    ))){
      this.setState({testTimeExpired:false}); //TODO: Consolidate end of assessment stuff into one method.
      this.displayStudentStatus(this.state.testTimeExpired || aborted);
    }else{
      var nextAssignmentIndex = this.props.assignmentIndex + 1;
      if (this.props.aosAssignmentComplete) {
        // We skip past the last English assignment 
        nextAssignmentIndex = this.props.getLastEnglishAssignmentIndex() + 1;
      }

      // If next assignment is not readingComprehension, then we should reset the readerCharacteristics studentGrade back to actualGrade
      // We only want to carry over ORF releveling to readingComprehension. Not to any other assignments (like if we are going to a fresh spanish assessment)
      if (this.props.allAssignments && this.props.allAssignments[nextAssignmentIndex].activityType !== assignmentTypes.READING_COMPREHENSION) {
        setStudentGradeLevel(getUserData().actualGrade);
      }

      //TODO (post-MVP): Check licensing
      this.launchNextAssignment(this.state.aosAssignmentComplete);
    }
  }

  async finalizeAssessment(aborted){
    // Need to create a copy of the object because we use it asynchronously and the
    // timings will be cleared below before the calculatePhraseSplits call returns
    endUniversalSocketSession();

    if (this.props.shouldUseAOS) {
      this.cleanUpAfterAssessment(aborted);
      return;
    }

    if(this.props.story.nonAudio){
      studentRecordService.finalizeNonAudioActivity(this.state.activityId, this.state.simpleErrors, this.state.textResponse)
      .then(() => {
        this.cleanUpAfterAssessment(aborted);
      })
      .catch((error) => {
        console.error('Error finalizing non-audio activity:', error);
        logSessionInfo('error_finalizing_non_audio_activity', {
          error: error?.message || error,
          activityId: this.state.activityId
        });
        this.cleanUpAfterAssessment(aborted);
      });
    } else {
      const assignmentType = this.props.studentAssignment ? this.props.studentAssignment.assignmentType : null;
      const isCalibration = assignmentType === 'CALIBRATION';
      if(isCalibration && this.props.story.type === assignmentTypes.DYSLEXIA){
        await studentRecordService.saveTextResponses(this.state.activityId, this.state.textResponse);
      }
      this.handlePhraseSplits(this.props.story.storyId)
        .then(() => {
          this.cleanUpAfterAssessment(aborted);
        });
    }
  }

  // Helper function to check if a story has textset tags
  hasTextSetTags(story) {
    return story && story.tags && story.tags.some(tag => tag.endsWith('_TEXTSETS'));
  }

  async finalizeTutor(){
    try {
      endUniversalSocketSession();

      // Check if we are in a textset sequence and current story has textset tags before doing anything else
      const inTextSetSequence = this.props.forceSkill && this.props.forceSkill.startsWith('BK');
      if (inTextSetSequence && this.hasTextSetTags(this.props.story)) {
        const grade = getUserData().actualGrade;
        const activityType = assignmentTypes.TUTOR;
        const assignmentType = this.props.studentAssignment ? this.props.studentAssignment.assignmentType : null;

        this.setIsLoading(true);
        
        try {
          const preventFallback = true;
          // Wrap getStoriesByGrade in withTimeout
          const stories = await withTimeout(
            getStoriesByGrade(grade, activityType, assignmentType, this.props.selectStories, this.props.forceSkill, recommendationModes.SEQUENCE_LOCKED, preventFallback),
            HIGH_VOLUME_CALLS_TIMEOUT,
            'getStoriesByGrade timeout after 16s'
          );
          this.setIsLoading(false);

          const nextValidTextSetStory = stories && stories.length > 0 && stories.find(story => this.hasTextSetTags(story) && !!story.sequence_number && story.sequence_number !== '001');
          
          // Update manifest text set item to either IN_PROGRESS or DONE
          // to prevent assignment service from automatically closing it out due to having a completed activity
          // before the user has completed all text sets
          if (this.props.studentAssignment && this.props.studentAssignment.manifestItemId) {
            const updateInput = [{
              assignmentId: this.props.studentAssignment.assignmentId,
              manifestId: this.props.studentAssignment.manifestItemId,
              status: nextValidTextSetStory ? "IN_PROGRESS" : "DONE"
            }];
            
            try {
              // Wrap updateManifestItems in withTimeout (already has internal retry logic)
              await withTimeout(
                updateManifestItems(updateInput),
                HIGH_VOLUME_CALLS_TIMEOUT,
                'updateManifestItems timeout after 16s'
              );
            } catch (error) {
              console.error('Failed to update manifest item status:', error);
              logSessionInfo('manifest_update_error', { error: error.message });
            }
          }

          if (nextValidTextSetStory) {
            console.log('Next text set story found:', nextValidTextSetStory.storyId);
            await this.props.speech.speakWithPromise({
              textToSpeak: COPY_STRINGS.another_textset_story_speech
            });
            this.props.setNextStory(nextValidTextSetStory.storyId);
            return; // Exit early since we're transitioning to the next story
          }
          // If no valid stories returned, continue with existing logic        
        } catch (error) {
          this.setIsLoading(false);
          console.error('Error getting next BOV story:', error);
          logSessionInfo('textset_sequence_error', { error: error.message });
          // Continue with existing logic if there's an error
        }
      }

      // Check for ERSS story sequence handling
      if (this.props.studentAssignment && this.props.studentAssignment.assignmentId && this.isERSSStory(this.props.story)) {
        this.setIsLoading(true);
        try {
          // Wrap getAssignmentByIdForStudent in withTimeout
          // Fetch the current assignment
          const assignment = await withTimeout(
            getAssignmentByIdForStudent(this.props.studentAssignment.assignmentId),
            HIGH_VOLUME_CALLS_TIMEOUT,
            'getAssignmentByIdForStudent timeout after 16s'
          );

          this.setIsLoading(false);
          if (assignment && assignment.manifest) {
          // Find the current manifest item
            const currentManifestIndex = assignment.manifest.findIndex(item => item.storyId === this.props.story.storyId);
            
            if (currentManifestIndex !== -1 && currentManifestIndex < assignment.manifest.length - 1) {
            // Check if there's a next manifest item
            const nextManifestItem = assignment.manifest[currentManifestIndex + 1];
              
              if (nextManifestItem && nextManifestItem.storyId && nextManifestItem.contentTags) {
              // Check if the next manifest item has an ERSS content tag
                const hasErssTag = nextManifestItem.contentTags.some(tag => tag.toLowerCase().includes('erss'));
                
                if (hasErssTag) {
                  console.log('Next ERSS story found in manifest:', nextManifestItem.storyId);
                  await this.props.speech.speakWithPromise({
                    textToSpeak: COPY_STRINGS.another_story_speech
                  });
                  this.props.setNextStory(nextManifestItem.storyId);
                  return; // Exit early since we're transitioning to the next story
                }
              }
            }
          }
        } catch (error) {
          this.setIsLoading(false);
          console.error('Error fetching assignment for ERSS sequence:', error);
          logSessionInfo('erss_sequence_error', { error: error.message });
          // Continue with existing logic if there's an error
        }
      }
    // Capture studentAssignment state before it's cleared to avoid outdated values in status components
      const hasStudentAssignment = !!this.props.studentAssignment;
      
      this.props.resetForcedStory();
      
      // Refresh assignments after tutor completion for non-student-inbox users
      // MUST COME AFTER RESET FORCED STORY
      // This ensures that completed manifest items are filtered out and next assignments are available
      // Show a wait modal during the refresh to provide user feedback
      if (getUserData().userType === userTypes.STUDENT && !this.props.fromStudentInbox) {
        this.setIsLoading(true);
        // Wrap refreshAssignments in withTimeout
        await withTimeout(
          this.props.refreshAssignments(),
          HIGH_VOLUME_CALLS_TIMEOUT,
          'refreshAssignments timeout after 16s'
        ); 
        this.setIsLoading(false);
      }
      
      const onDoneWaiting = getUserData().isEarlyReader ? 
        () => this.displayEarlyReaderStatus(hasStudentAssignment) : 
        () => this.displayStudentStatus(false, hasStudentAssignment);
      onDoneWaiting();
      
    } catch (error) {
      this.setIsLoading(false);
      console.error('Error in finalizeTutor:', error);
      logSentryException(new Error('Tutor finalization failure'), 'Error finalizing tutor', { originalError: error?.message, originalStack: error?.stack });
      this.handleEndOfStoryErrors();
    }
  }

  handleEndOfStoryErrors () {
    if (this.props.config.assessmentMode || this.state.testTimeExpired) {
      // If we are in assessment mode or the test timer has expired, and we are from student inbox, navigate to the return URL
      if (this.props.fromStudentInbox && this.props.returnUrl) {
        window.location.href = this.props.returnUrl;
      } else {
        if (this.state.testTimeExpired) {
          this.setState({testTimeExpired: false}); // Clear it the error state as well to avoid loop
        }
        this.props.resetForcedStory();
        this.props.resetStory(); // open story picker for non-student-inbox users
      }
    } else {
      // if type is asr, call onEndASRCheck for the parent to handle.
      if (this.props.asrStoryID) {
        this.props.onEndASRCheck?.();
      } else {
        this.props.resetForcedStory();
        this.props.resetStory(); // open story picker for non-student-inbox users / tutors
      }
    }
  }

  openWaitModal(callback,aborted,useAdhoc=false){
    this.openModalAndStopListening(
      <WaitModal
        doneWaiting={useAdhoc ? isAdhocSendingComplete : isSendingComplete}
        progress = {sendingProgress}
        continue={callback.bind(this,aborted)}
        timeOut = {90000}
      />
    );
  }

  handleEndOfAssessment(abortStatus=null, skipWaitModal=false){
    if(abortStatus){
      //TODO import function and uncomment when we merge
      logSessionInfo("activity_aborted",{activityId: this.state.activityId, abortStatus: abortStatus});
    }
    this.setState({testTimeExpired: false});  //Acknowledge the flag so we don't get into a loop because of all the ovverides on time expired.
    if(this.props.speech){
      if (!this.props.shouldUseAOS) {
        // stopTime is set in onTestletEnd for AOS
        stopTime = new Date().getTime() - recordingStart;
      }
      if(!this.props.story.nonAudio){
        this.props.speech.disableRecording(true);
        this.props.speech.stopListening();
      }

      let completionPromises = [];
      //If we aborted, preserve the assignment if we have a multi-part
      if(abortStatus){
        if(this.props.bifurcatedAssignment){
          completionPromises.push(studentRecordService.markAbortedKeepingAssignment(this.state.activityId,abortStatus));
        }else{
          completionPromises.push(studentRecordService.markAborted(this.state.activityId,abortStatus));
        }
        const locale = isSpanishStory(this.props.story) ? "ES_MX" : "EN_US";
        completionPromises.push(skipActivityInManifest(this.props.studentAssignment.assignmentId,"readingComprehension",locale))
        this.props.skipNextReadingComprehension();
      } else if (!this.props.shouldUseAOS) {
        completionPromises.push(studentRecordService.markCompleted(this.state.activityId,statusType.COMPLETED));
      }

      if (this.props.amiraIsipPilotGuid) {
        completionPromises.push(AssessmentOrchestrationService.onPilotAssessmentComplete(this.props.amiraIsipPilotGuid, getUserData().userId));
      }
      
      if (this.props.spanishIsipCalibrationGuid) {
        completionPromises.push(AssessmentOrchestrationService.onSpanishIsipCalibrationComplete(this.props.spanishIsipCalibrationGuid, getUserData().userId));
      }

      Promise.all(completionPromises)
      .then(async ()=>{
        if(this.props.story.nonAudio){
          this.finalizeAssessment();
        }else{
          if (!this.props.shouldUseAOS) { // This is handled in onTestletEnd for AOS
            if (!skipWaitModal) {
              // If we've been directed to skipWaitModal, then it means we shouldn't be building the audio.
              this.sendEndOfStoryRecording();
            }

            //remove early readers after successful completion an orf assessment
            //TODO: spanish story condition will have to change when we support a spanish early reader sequence
            if(!abortStatus && this.props.orfMode && (getUserData().isEarlyReader || getUserData().isSpanishEarlyReader)){
              await clearEarlyReader(getUserData().userId,getUserData().locale);
              logSessionInfo("early_reader_cleared_post_orf", {activityId: this.state.activityId});
            }
          }

          if (skipWaitModal) {
            // Skip the wait modal for releveling since we don't build the audio
            this.finalizeAssessment(abortStatus);
          } else {
            const useAdhoc = this.props.speech.hasAudioDestination();
            this.openWaitModal(this.finalizeAssessment,abortStatus ? true : false, useAdhoc);
          }
        }
      })
      .catch(err=>{
        console.log(err);
        logSentryException(new Error('Activity completion failure'), 'Error completing activity', { originalError: err?.message, originalStack: err?.stack });
      });
    }else{
      this.clearTimingVariables();
      this.displayStudentStatus(this.state.testTimeExpired || abortStatus ? true : false);
      this.setState({testTimeExpired:false})
      if(this.props.forcedAssessment){
        // Refresh assignments after assessment completion for non-student-inbox users
        if (getUserData().userType === userTypes.STUDENT && !this.props.fromStudentInbox) {
          this.props.refreshAssignments();
        }
      }
    }
  }

  //TODO de-dup
  // note, this is for assessments aborted due to relevel or "sign out and restart" button.
  //   the "end assessment" button and bottoming out of K level both save assessments via "handleEndOfAssessment"
  handleAbortedAssessment(src=null){
    if(this.props.speech){
      let stopTime = new Date().getTime() - recordingStart;      
      if(!this.props.story.nonAudio){
        this.props.speech.disableRecording(true);
        this.props.speech.stopListening();
      }
      this.clearTimingVariables();
      return Promise.resolve(this.setState({
        testTimeExpired:false
      }));
      //TODO: leave this code in for now. Remove if we decide we never want to save aborted assessments
      /*return studentRecordService.markCompleted(this.state.activityId) //TODO mark with a different status
      .then(()=>{
        this.sendEndOfStoryRecording();

        calculatePhraseSplits(timings,this.props.story.storyId,stopTime)
        .then(splits => {
          saveAssessmentTiming(this.state.activityId,splits);
        })
        .catch(err=>{
          console.log(err);
          logSentryException(new Error('Phrase splits calculation failure'), 'Error calculating phrase splits', { originalError: err?.message, originalStack: err?.stack });
        });
        this.clearTimingVariables();
        this.setState({
          testTimeExpired:false
        });
      });*/
    }else{
      this.clearTimingVariables();
      return Promise.resolve(this.setState({
        testTimeExpired:false
      }));
    }
  }

  onPageEnd(phrases,didIntervene = false){
    const {assessmentPageNavEnabled} = getUserData();
    if(!this.state.minTimeElapsed && !assessmentPageNavEnabled){
      return;
    }
    const assignmentType = this.props.studentAssignment ? this.props.studentAssignment.assignmentType : null;
    const isCalibration = assignmentType === 'CALIBRATION';
    
    // Skip all releveling logic if doNotRelevel is set

    if(this.props.story && this.props.story.type === assignmentTypes.ASSESSMENT && !(this.props.forceStory || this.props.forceSkill) && !this.state.doNotRelevel){
      //if we are at the end of the first page or if we haven't checked for downleveling yet, check whether we need to relevel the story
      if((this.props.pageIndex == 0 ||
        !this.state.frustrationLevelChecked) && this.props.orfMode && !isEarlyReaderMode(this.state.earlyReaderMode) && !this.state.testTimeExpired){
        //If the reader less than ten words in on the first page and clicks next,
        //skip accuracy based re-level logic and go to the next page. The re-level time remains active.
        //If the reader is more than 10 words deep on the first page, we'll use the accuracy up to the
        //currentWordIndex to decide whether to re-level or not.
        if((this.props.pageIndex == 0) && (this.state.currentWordIndex < 10) && assessmentPageNavEnabled && (this.props.pageIndex < this.props.story.pages.length-1)){
          this.goToNextPage();
          return;
        }else{
          let {errors} = this.state;
          if(assessmentPageNavEnabled){
            const currentPhraseErrors = errors[this.props.pageIndex][this.state.currentPhraseIndex];
            if(currentPhraseErrors.cleanTranscript){
              errors[this.props.pageIndex][this.state.currentPhraseIndex].totalErrors = currentPhraseErrors.totalErrors.slice(0, currentPhraseErrors.cleanTranscript.length);
            }else{
              //Handle case where the student hasn't said anything
              errors[this.props.pageIndex][this.state.currentPhraseIndex].totalErrors = [true];
            }
          }
          this.setState({frustrationLevelChecked: true});

          if(!isCalibration && this.checkFrustrationLevel(errors)){
            // no need to do the rest of these calculations if we are re-leveling
            return;
          }

          //Because of the slicing above, also fire if they have < 8 words correct
          let wordsCorrect = this.getCurrentPhraseErrors().reduce((total,error)=>{
            return error ? total : total+1;
          },0);

          let studentGrade = getUserData().actualGrade;
          let storyGrade = parseInt(this.props.story.grade);

          logSessionInfo('downlevel_check', {
            src: 'onPageEnd',
            wordsCorrect,
            errors,
            currentPhraseErrors: this.getCurrentPhraseErrors(),
            studentGrade,
            storyGrade,
          });

          //downlevel if the student has not read 8 words
          //and the student has not upleveled
          if(downLevelWordsCorrectCriteriaMet(wordsCorrect, studentGrade, storyGrade, isCalibration, this.props.shouldUseAOS, this.props.story)){
            logSessionInfo('downlevel', {
              src: 'onPageEnd',
              wordsCorrect,
              errors,
              currentPhraseErrors: this.getCurrentPhraseErrors(),
              studentGrade,
              storyGrade,
            });

            if (isCalibration) {
              // If the student is in calibration mode, exit assessment instead of downlevel
              const skipWaitModal = true;
              this.handleEndOfAssessment(statusType.PREREADER, skipWaitModal);
            } else {
              this.reLevel("long_pause");
            }
            return;
          } else if (!isCalibration) {
            let {wcpm} = calculateMostRecentScores(errors, getAudioDuration());
            const locale = isSpanishStory(this.props.story) ? "es-mx" : "en-us";
            let wcpmPR = getWCPMGradePR(wcpm, this.props.story.grade, locale);

            logSessionInfo('uplevel_check', {
              src: 'onPageEnd',
              errors,
              wcpm,
              wcpmPR,
              locale,
            });

            //up level story if the student's wcpm is above 95% of the PR for the story's grade
            //and the student has not been downleveled
            // Set the uplevel grade to 13 if we are using AOS, grades don't go that high / need to ignore
            const maxUplevelGrade = this.props.shouldUseAOS ? 13 : (assignmentType === 'PROGRESS_MONITORING') ? 5 : 6;
            if(upLevelCriteriaMet(storyGrade, studentGrade, maxUplevelGrade, wcpmPR, this.props.shouldUseAOS, this.props.story)){
              logSessionInfo('uplevel', {
                src: 'onPageEnd',
                errors,
                wcpm,
                wcpmPR,
                locale,
              });
              this.reLevel("above_grade_level");
              return;
            }
          }
        }
      }
    }

    //This checks to make sure that we're actually at the end of a page before executing any logic
    //(Root cause of this bug has been fixed, but leaving this here for error handling in case another situation arises)
    let tempPhrases = this.getCurrentPage();
    // This line checks to see if the current phrase index is less than the number of phrases on the page (IOW, that we
    // aren't calling PageEnd before the actual end of the page) unless we're in assessment mode and the test timer
    // has expired.
    if((this.state.currentPhraseIndex < tempPhrases.length - 1) && !this.state.testTimeExpired){
      console.log("HIT PAGE END IN MIDDLE OF PAGE:",tempPhrases,this.state.currentPhraseIndex);
      console.log(new Error().stack);
      logSessionInfo("hit_page_end_mid_page",{ phraseCount: tempPhrases?.length, pageIndex: this.props.pageIndex, callbackAfterIntervention: !!this.state.callbackAfterIntervention });
      return;
    }

    if((this.props.pageIndex >= this.props.story.pages.length-1) || this.state.testTimeExpired){
      if (this.state.assessmentTestletId) {
        // END OF TESTLET, CHECK FOR MORE
        this.playEndOfPhraseSequence(this.onTestletEnd);
      } else {
        //END OF STORY
        this.playEndOfPhraseSequence(this.onStoryEnd);
      }
    } else {
      //END OF PAGE
      this.playEndOfPhraseSequence(this.goToNextPage);
    }
  }

  async playEndOfPhraseSequence(callback){
    if(this.props.endingSequence.length){
      // loop through the ending sequence and play each one asynchronously
      const endingSequence = [...this.props.endingSequence];
      for await (const ending of endingSequence) {
        try{
          if(ending.textToSpeak){

            const parsedInstructions = parseSkipTranslationTags(ending.textToSpeak);
            if (parsedInstructions.length > 1) {
              // We have skipTranslation tags
              await new Promise((resolve) => {
                const bilingualSequenceToSpeak = {
                  textToSpeak: parsedInstructions,
                  passThroughSpeechTags: true,
                  onEnd: resolve,
                }
                this.props.speech.speakSequence(bilingualSequenceToSpeak);
              });
            } else {
              await this.props.speech.speakWithPromise({
                textToSpeak: ending.textToSpeak,
              });
            }
          }else if(ending.url && ending.key){
            await this.props.speech.playAppSoundsWithPromise({
              url: ending.url,
              key: ending.key,
            }); // playing dynamic sounds, keep default audioTimeoutDelay
          }else if(ending.phonemeToSpeak){
            const url = findFilenames(ending.phonemeToSpeak)
            console.log('Playing phoneme for end of phrase: ', ending.phonemeToSpeak);
            await this.props.speech.playAppSoundsWithPromise({
              url,
              key: ending.phonemeToSpeak,
            }); // for phonemes, keep default audioTimeoutDelay
          }
        }catch(err){
          console.log(err);
          logSentryException(new Error('Phrase sequence playback failure'), 'Error playing end of phrase sequence', { originalError: err?.message, originalStack: err?.stack });
        }
      }
      this.props.clearEndingSequence();
    }
    callback()
  }

  phraseRespectsMinTimeElapsed(){
    if(!this.props.story || !this.props.story.items || !this.props.story.items[overallPhraseIndex]){
      return false;
    }

    return !TYPE_OF_PHRASE_TO_IGNORE_MIN_TIME_ELAPSED.includes(this.props.story.items[overallPhraseIndex].type)
  }

  goToNextPage(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PAGE_INCREMENT, page: this.props.pageIndex, });
    if(!this.state.minTimeElapsed && this.phraseRespectsMinTimeElapsed()){
      return;
    }
    
    // Tap-to-read: Clear intervention flag and timeout on page change (after guard passes)
    this.clearTapToReadInterventionFlag();
    
    this.nextPhrase(); //TODO: Make sure we're not doing this twice in this flow
    this.props.goToNextPage(); //TODO make nextPhrase call goToNextPage
  }

  //function to be called when the reader finishes reading a phrase and we are ready to move on to the next one
  // initiates the read aloud intervention if necessary, decides whether to try again or advance the phrase index
  onPhraseEnd(isRecording, phraseIndex){
    // For ASR stories, capture the currentWordIndex before onErrorsAreValid modifies it.
    // This allows us to determine the actual progress when the story ends.
    if(this.props.asrStoryID){
      this.asrWordIndexAtPhraseEnd = this.state.currentWordIndex;
    }
    
    if(!this.state.minTimeElapsed && this.phraseRespectsMinTimeElapsed() && !this.props.story.nonAudio){
      this.setState({phraseComplete: {isRecording: isRecording, phraseIndex: phraseIndex}});
      return;
    }
    
    // Prevent stale calls from previous phrases
    // If this phrase has already started ending (lastEndedPhrase has been set), ignore this call
    if (phraseIndex <= this.lastEndedPhrase) {
      console.log('ReaderManager: onPhraseEnd called for already completed phrase, skipping stale call', {
        calledPhraseIndex: phraseIndex,
        lastEndedPhrase: this.lastEndedPhrase
      });
      logSessionInfo('on_phrase_end_stale_call_prevented', {
        calledPhraseIndex: phraseIndex,
        lastEndedPhrase: this.lastEndedPhrase,
        currentOverallPhraseIndex: overallPhraseIndex,
      });
      return;
    }

    const isLastPhrase = !this.props.story?.phrases || overallPhraseIndex >= this.props.story.phrases.length - 1;
    if (this.shouldShowInterPhraseLoader() && this.props.story?.items && !isLastPhrase) {
      this.setIsLoading(true);
    }
    
    // Mark this phrase as having started the end process
    this.lastEndedPhrase = phraseIndex;

    if (this.networkMonitoringService) {
      const dump = this.networkMonitoringService.handlePhraseEnd();
      this.phraseNetworkSignals.push({
        phraseIndex: overallPhraseIndex,
        ackMs: dump?.ackMs || [],
        ackP50Ms: dump?.ackP50Ms ?? null,
        ackP95Ms: dump?.ackP95Ms ?? null,
        ackedCount: dump?.ackedCount ?? null,
      });
    }

    //Log the final transcript so we can see what the speech rec thought we got in case of errors
    console.log("Transcript: ",this.props.transcript.interim); //TODO: Remove once confident in error detection
    logSessionInfo("transcript_phrase_"+ overallPhraseIndex,timings);
    logSessionInfo("wav2vec_phonemes_"+overallPhraseIndex,wav2vecPhonemes);
    // first save the audio for this phrase
    if(this.props.speech && !this.props.story.nonAudio){
      if(!this.state.retry && process.env.STREAM){
        this.setState({ phraseEnded: true });

        this.builtRecordingMeta = this.buildRecordingMeta();

        this.props.speech.disableRecording(
          this.state.NRTRecording,
          this.builtRecordingMeta
        );
        lastRecordingStop = Date.now();
        errordelay = Date.now();
        console.log("END OF PHRASE",errordelay); //TODO: Remove once confident in error detection
      }

      this.props.speech.stopListening();
      if (isTapToReadBehavior()) {
        // TT-1004 EDM fallback plan §3 verification item: on iPad, resetTranscript() below
        // resolves to Speech.js's resetTranscript() -> resetPlacementTranscript(), which clears
        // kaldiTranscript (what getUnconstrainedTranscript() returns). Snapshot it here, before
        // the wipe, as a fallback for tier-2 scoring in onErrorsAreValid.
        this.tapToReadTranscriptSnapshot = {
          unconstrained: getUnconstrainedTranscript(),
          transcript: this.props.transcript,
        };
      }
      this.props.speech.resetTranscript();

      // TT-1110: phrase-level audio-quality metrics (percentiles/counts feeding the bad-audio
      // detectors), so thresholds can be retuned offline without re-running audio analysis.
      // getPhraseAudioMetrics(overallPhraseIndex) filters on each segment's own stamped
      // phraseIndex, which is a large improvement over relying on call timing but not an
      // absolute per-buffer guarantee -- see the module-level comment on segmentMetricsBuffer
      // in Speech.js for the actual mechanism and its residual. This call is pure telemetry,
      // guarded so a missing method here can't strand a student mid-phrase, and gated on a
      // remote kill switch (default on) since it's one extra S3 PUT per phrase boundary with no
      // other way to disable it short of a deploy.
      if (getUserData().appSettings?.audioQualityPhraseLoggingEnabled !== false) {
        logSessionInfo(`audio_quality_phrase_${overallPhraseIndex}`, this.props.speech.getPhraseAudioMetrics?.(overallPhraseIndex));
      }
      this.props.speech.clearPhraseAudioMetrics?.();
    }

    // Same tutor-only gate as the story-end persist. Assessment/ASR do not write this field.
    if (!this.props.config.assessmentMode && !this.props.asrStoryID) {
      this.persistAudioNetworkSignals();
    }

    const callback = () => {
      
      this.clearInterventionTimer();
      this.stopRelevelTimer();
      this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
      this.phraseTimeoutRef.current = null;
      
      // Clear "Next" button timer since phrase is ending
      this.clearNextButtonTimer();

      if(this.props.config.assessmentMode || !process.env.STREAM){
        // Timeout used to mimick how tutor awaits backend before moving on, to fix race condition caused by async
        //    operations introduced by AOS based assessments
        window.setTimeout(() => {
          //TODO: Separate other end of phrase logic from onErrorsAreValid so that it doesn't need to be called here
          this.onErrorsAreValidSafe();
        }, 100);
      } else if (this.state.retry) {
        // On a readback (retry), no audio was sent to the backend so no EDM
        // response will arrive. Call onErrorsAreValid immediately rather than
        // making the student wait for a response that will never come.
        window.setTimeout(() => {
          this.onErrorsAreValidSafe();
        }, 100);
      } else {
        edmTimeout = window.setTimeout(() => {
          this.onErrorsAreValidSafe();
        }, 6000);
      }
    }

    if (this.state.assessmentTestletId && this.props.story.nonAudio) {
      const phraseMetadata = this.getCurrentPhraseMetaData();
      if (this.itemTypeUsesEncodedResponse(phraseMetadata.type)) {
        AssessmentOrchestrationServiceUtils.storeTestletItemEncodedResponse(this.props.speech, this.state, this.props.story.phrases[overallPhraseIndex], phraseMetadata, this.getCurrentItemResponse(), this.props.rawStory.type, callback, this.props.rawStory);
      } else if (this.itemTypeUsesArrayResponse(phraseMetadata.type)) {
        AssessmentOrchestrationServiceUtils.storeTestletItemArrayResponse(this.props.speech, this.state, this.getExpectedArrayResponse(), phraseMetadata, overallPhraseIndex, this.props.rawStory.type, callback, this.props.rawStory);
      } else {
        AssessmentOrchestrationServiceUtils.storeTestletItemTextResponse(this.props.speech, this.state, this.getCurrentPage()[0], phraseMetadata, overallPhraseIndex, this.props.rawStory.type, callback, this.props.rawStory);
      }
      // TODO: There's a bug for audio where calling callback immediately breaks the flow.
      //   But ideally, we need to remove the prescore listening message SpeechStream.js.  We're supposed to be able to
      //   call the callback immediately after disable recording resolves.
    } else {
      callback();
    }
  }

  // Parent fetches and configures the next testlet.  if there is more, we continue on as usual.  otherwise, we end the story.
  async onTestletEnd(fromRelevel=false) {
    this.clearAssessmentStoryTimeouts();
    stopTime = new Date().getTime() - recordingStart; // Set stop time to the time the testlet ended (so we don't include the time it takes to fetch next testlet in the reading time)
    const finishedStory = JSON.parse(JSON.stringify(this.props.story));
    const rawFinishedStory = JSON.parse(JSON.stringify(this.props.rawStory));
    this.setIsLoading(true);
    const { shouldStartMidSessionTroubleshoot, audioIssueType } = this.computeAudioMetrics();

    if (shouldStartMidSessionTroubleshoot) {
      this.props.closeModal();
      this.props.speech.stopListening();

      AssessmentOrchestrationService.resetActivity({
        activityId: this.state.activityId,
        testletId: this.props.story.storyId,
      }).catch((err) => {
        console.error('Failed to reset activity:', err);
        logSessionInfo('reset_activity_error', { error: err?.message });
      });

      this.props.startMidSessionTroubleshoot(audioIssueType);
      return;
    }

    this.setState({storyLoaded: false});

    if (finishedStory.type === aosTaskTypes.assessment || (finishedStory.type === aosTaskTypes.ran && fromRelevel)) {
      await new Promise((resolve) => {
        AssessmentOrchestrationServiceUtils.triggerRelevelComplete(
          this.builtRecordingMeta || this.buildRecordingMeta(),
          this.props.speech, 
          this.state, 
          this.getCurrentPhraseMetaData(),
          finishedStory.type, 
          this.shouldUpLevel, 
          this.shouldDownLevel, 
          resolve
        );
      });
    }

    // Reset previous recording meta
    this.builtRecordingMeta = null;

    // Reset relevel changes
    this.shouldUpLevel = false;
    this.shouldDownLevel = false;

    try {
      const { assignmentId, assignmentType } = this.getAosAssignmentFieldsForTestlet();
      const result = await AssessmentOrchestrationService.getTestlet({
        assignmentId,
        assignmentType,
        studentId: getUserData().userId,
        districtId: getUserData().districtId,
        schoolId: getUserData().schoolId,
        grade: getUserData().actualGrade,
        story: this.props.rawStory,
        activityId: this.state.activityId,
        testletId: this.state.assessmentTestletId,
      });

      // Check for errors first - don't retry on permanent errors
      if (this.handleGetTestletError(result, 'in_onTestletEnd')) {
        return;
      }

      const {shouldContinue, story: newStory, testletId, activityId: newActivityId, assignmentComplete, shouldSkipBuildPreviousAudio, doNotRelevel} = result;

      this.setIsLoading(false);
      const isNewType = shouldContinue && rawFinishedStory.type !== newStory.type;

      if (shouldContinue) {
        this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.TESTLET_FETCHED, storyId: newStory.storyId, storyType: newStory.type});

        setStudentGradeLevel(newStory.grade);

        if (isNewType || fromRelevel) {
          this.props.logTimeOnStoryEnd(); // Log the time when a type ends, this will also be called in onStoryEnd for the final testlet
          this.props.logTimeOnStoryStart();//Log the time when a new type starts

          logSessionInfo("on_story_end", {
            placement_logs: JSON.parse(JSON.stringify(timings)),
            utterance_logs: getUtteranceLogs()
          });

          if (this.state.assessmentTestletId && !rawFinishedStory.nonAudio) {
            if (!fromRelevel) {
              if (!shouldSkipBuildPreviousAudio) {
                this.sendEndOfTestletRecording();
              }

              if (this.props.orfMode && (getUserData().isEarlyReader || getUserData().isSpanishEarlyReader)){
                clearEarlyReader(getUserData().userId,getUserData().locale);
                logSessionInfo("early_reader_cleared_post_orf", {activityId: this.state.activityId});
              }
            }
          }

          if (!rawFinishedStory.nonAudio && !fromRelevel && !shouldSkipBuildPreviousAudio) {
            await new Promise((resolve) => {
              const useAdhoc = this.props.speech.hasAudioDestination(); 
              this.openWaitModal(resolve, undefined, useAdhoc); // Resolves when all built audio is acknowledged over the socket, in place for slow networks
            });
          }
          await this.handlePhraseSplits(null, rawFinishedStory, inProgressTimingSlices, true);
          this.clearTimingVariables();
        } else {
          inProgressTimingSlices = await this.handlePhraseSplits(null, rawFinishedStory, inProgressTimingSlices, false);
          this.resetInProgressTimingSessionVariables();
        }

        // Reset any adhoc audio destination after openWaitModal and before any new testlet starts
        this.props.speech.clearAudioDestination();

        const callback = () => {
          // Track testlet type changes for isFirstAssessmentItemOfType
          const stateUpdate = {assessmentTestletId: testletId, activityId: newActivityId, doNotRelevel: doNotRelevel};
          if (isNewType) {
            stateUpdate.isFirstAssessmentItemOfType = true;
          }
          
          this.setState(stateUpdate, () => {
            setSessionActivityId(newActivityId, this.props.config.assessmentMode);
            this.props.speech.updateActivityId(newActivityId, () => {
              this.updateAssessmentStory(newStory);
              const spanishPlacementLikeCalibration =
                this.props.spanishIsipCalibrationGuid || this.shouldUseNewSpanishPlacementManagerInCurrentSession();
              const isSoundActivity = newStory.type === aosTaskTypes.beginningLetterSound || newStory.type === aosTaskTypes.letterSound;
              if (isNewType || fromRelevel) {
                // Spanish sound activities should not use spanish placement - it should use Kaldi Phons instead
                this.props.speech.initializeSpeechSession(newActivityId,
                  spanishPlacementLikeCalibration && !isSoundActivity ? 'es-mx' : 'en-us',
                  false,
                  spanishPlacementLikeCalibration && !isSoundActivity ? true : false, // useSpanishPlacement
                  spanishPlacementLikeCalibration && isSoundActivity ? true : false, // useKaldiPhons
                );
              }
            });
          });
        }

        if (newStory.type === aosTaskTypes.assessment) {
          // Play intro modal so we get ORF specific instructions and the 3,2,1 modal
          const isNotInitialTestlet = true;
          this.openIntroModal(callback, newStory.type, undefined, isNotInitialTestlet, fromRelevel);
        } else {
          // Otherwise, go right into task
          callback();
        }
      } else {
        this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.NO_SUBSEQUENT_TESTLET});
        this.props.speech.setForceAOS(false, () => {
          this.handlePhraseSplits(null, rawFinishedStory, inProgressTimingSlices, true)
            .then(() => {
              if (!fromRelevel) {
                if (!shouldSkipBuildPreviousAudio) {
                  this.sendEndOfTestletRecording();
                }

                if (this.props.orfMode && (getUserData().isEarlyReader || getUserData().isSpanishEarlyReader)){
                  clearEarlyReader(getUserData().userId,getUserData().locale);
                  logSessionInfo("early_reader_cleared_post_orf", {activityId: this.state.activityId});
                }
              }
              this.setState({aosAssignmentComplete: assignmentComplete}, () => {
                const skipWaitModal = fromRelevel || shouldSkipBuildPreviousAudio;
                this.onStoryEnd(skipWaitModal);
              });
            });
        });
      }
    } catch (err) {
      console.error("Error getting testlet.", err)
      logSentryException(new Error('Testlet fetch failure'), 'Error getting testlet.', { originalError: err?.message, originalStack: err?.stack });
      this.onStoryFetchFailure();
    }
  }

  updateDelays(){
    lastDelay = (Date.now()-errordelay)/1000;
    phraseDelays.push(lastDelay);
    let sum = 0;
    for(let i=0;i<phraseDelays.length;i++){
      sum += phraseDelays[i];
    }
    averageDelay = sum/phraseDelays.length;

    //console.log("ROUND TRIP TOOK ",lastDelay," SECONDS"); //TODO: Remove once confident in error detection

  }

  updateFrameTime(inASROutput){
    if(!this.props.story || !this.props.story.phrases) return;
    let frames = calculateFrameTime(this.props.story.phrases[overallPhraseIndex],inASROutput);
    frames.overallPhraseIndex = overallPhraseIndex;
    this.setState({frameTimes: frames});
  }

  onDetectionEnd(detectionResults) {
    this.setState({
      detections: detectionResults
    })
  }

  /**
   * For ASR check stories, override errors to all false when EDM times out.
   * This ensures the accuracy check is based on backend analysis, not client-side errors.
   * 
   * @param {Array} errors - The current errors array
   * @returns {Array} - The overridden errors array (all false) or original if not ASR story
   */
  overrideErrorsForASRTimeout(errors) {
    if(this.props.asrStoryID && errors.length > 0){
      logSessionInfo('asr_edm_timeout_override', {originalErrors: errors});
      return errors.map(() => false);
    }
    return errors;
  }

  /**
   * Fire-and-forget-safe wrapper for onErrorsAreValid. onErrorsAreValid became async
   * (TT-1283 awaits the next-phrase graph prep), and its callers — the EDM callback
   * registered with startEDMSession and the end-of-phrase setTimeout sites — do not await
   * it, so a rejection would surface as an unhandled rejection rather than the synchronous
   * timer exception Sentry used to catch. Route any rejection to Sentry explicitly, the
   * same way the handleEndOfPhraseInterventions chain inside onErrorsAreValid already is.
   */
  onErrorsAreValidSafe(newErrors, confidenceLevels, phraseInterventionWeights, interventionMetadata) {
    return Promise.resolve(
      this.onErrorsAreValid(newErrors, confidenceLevels, phraseInterventionWeights, interventionMetadata),
    ).catch((err) => {
      logSentryException(
        err instanceof Error ? err : new Error('onErrorsAreValid rejected'),
        'onErrorsAreValid rejected',
        { originalError: err?.message, originalStack: err?.stack },
      );
    });
  }

  /**
   * Re-entrancy guard for the end-of-phrase state machine (TT-1283). onErrorsAreValid is
   * now async (it awaits the next-phrase graph prep), opening a multi-second window in
   * which a second invocation could interleave — the three timer-driven call sites pass no
   * newErrors, so the top guard in the impl does not stop them. Before this was synchronous
   * and interleaving was impossible. An in-flight latch keeps end-of-phrase processing
   * single-flight without depending on the call sites staying mutually exclusive.
   */
  async onErrorsAreValid(newErrors, confidenceLevels, phraseInterventionWeights, interventionMetadata) {
    if (this._endOfPhraseInFlight) {
      logSessionInfo('on_errors_are_valid_reentrant_skipped', { phraseIndex: overallPhraseIndex });
      return undefined;
    }
    this._endOfPhraseInFlight = true;
    try {
      return await this._onErrorsAreValidImpl(newErrors, confidenceLevels, phraseInterventionWeights, interventionMetadata);
    } finally {
      this._endOfPhraseInFlight = false;
    }
  }

  async _onErrorsAreValidImpl(newErrors,confidenceLevels,phraseInterventionWeights,interventionMetadata) {    
    if((!this.state.endOfPhrase || handledErrors) && newErrors && !this.props.asrStoryID){
      console.warn("GOT RESULTS IN MIDDLE OF PHRASE",this.state.endOfPhrase,handledErrors,newErrors);
      let logString = "errors_mid_page_phrase_"+ (overallPhraseIndex-1);
      logSessionInfo(logString,{endOfPhrase: this.state.endOfPhrase,handled: handledErrors,newErrors: newErrors, confidenceLevels: confidenceLevels});
      return;
    }

    if(newErrors && overallPhraseIndex >= newErrors.length){
      console.warn("ERRORS FROM PREVIOUS PHRASE",newErrors.length);
      logSessionInfo("errors_from_previous_phrase_"+newErrors.length,{errors: newErrors,currentPhrase: overallPhraseIndex});
      return;
    }

    if(edmTimeout){
      window.clearTimeout(edmTimeout);
      edmTimeout = null;
    } 

    handledErrors = true;
    this.updateDelays();
    let clientErrors = this.getCurrentPhraseErrors();
    let currentErrors=[];
    let gotErrorsFromBackend = false;
    let overAllErrors = null;
    // TT-1004 EDM fallback plan: which tap-mode fallback tier resolved this phrase's errors
    // when there's no EDM response, and the clean transcript its scoring call produced.
    // Both stay null outside tap mode. Set below; read by the telemetry and by the
    // final-resolution debug log near setCurrentPhraseErrors.
    let tapFallbackTier = null;
    let tapFallbackCleanTranscript = null;
    let tapFallbackTranscriptSource = null;

    // Store prediction confidences keyed by overallPhraseIndex so the write
    // aligns with the read at predictionConfidences[overallPhraseIndex].
    // Skip on retry (readback) — readbacks re-enter onPhraseEnd and arm a
    // fresh edmTimeout whose fire would silently push a zero array, shifting
    // every subsequent phrase's confidence data by one slot.
    if (!this.state.retry) {
      let confidence = confidenceLevels ? confidenceLevels : Array(clientErrors.length).fill(0);
      if (confidence.length !== clientErrors.length) {
        logSessionInfo('prediction_confidences_length_mismatch', {
          overallPhraseIndex,
          confidenceLength: confidence.length,
          clientErrorsLength: clientErrors.length,
        });
      }
      predictionConfidences[overallPhraseIndex] = confidence;
    }

    //Replicate the behavior of inference service for tutors. We mark in progress at the end of every phrase
    // so that we can derive session time for abandoned activities
    if(!this.props.config.assessmentMode){
      // The status heartbeat itself still fires for every non-assessment session (tutor AND the
      // ASR-check/mic-check path) to derive session time for abandoned activities — unchanged.
      //
      // TT-1370 Partial Story Credit: phrase progress rides this heartbeat, but ONLY for real
      // tutor stories (writesPartialStoryCredit). The ASR-check path (asrStoryID) also runs with
      // assessmentMode === false but terminates via markArchived, not scoreTutoring, so it would
      // never converge to N/N and would look like an abandoned tutor story to a query keyed on
      // these columns; it therefore sends the fields as undefined (omitted, columns left null).
      //   numerator   = overallPhraseIndex + 1. overallPhraseIndex is incremented in nextPhrase()
      //                 AFTER this end-of-phrase hook, so here it is the 0-based index of the
      //                 phrase just read; +1 makes "phrases read" literally true and makes the
      //                 last heartbeat converge on the terminal scoreTutoring write (N/N) instead
      //                 of trailing it by one.
      //   denominator = getStoryPhraseCount(story) — chapter-0's phrase count, the same value the
      //                 app's end-of-story check reads (story.phrases.length), shape-safe across
      //                 the raw/transformed story shapes. Not clamped to the numerator: a
      //                 multi-chapter story can briefly report phrasesRead > phraseCount, which
      //                 reporting tolerates until the true whole-story count is wired up.
      // The terminal scoreTutoring write below sets phrasesRead === phraseCount on completion.
      const isTutorStory = this.writesPartialStoryCredit();
      const phrasesRead = isTutorStory ? overallPhraseIndex + 1 : undefined;
      const phraseCount = isTutorStory ? getStoryPhraseCount(this.props.story) : undefined;
      // activeTime (GT-327) goes on every heartbeat, like sessionTime goes on every saveSessionTime.
      studentRecordService.markInprogress(this.state.activityId, phrasesRead, phraseCount, engagementClock.read())
        .catch((error) => {
          console.error('Error marking activity in progress:', error);
          logSessionInfo('error_marking_activity_in_progress', {
            error: error?.message || error,
            activityId: this.state.activityId
          });
        });
    }

    // split out the words so that we can check whether or not any of them are phonemes. For now,
    //  we don't want to use the end of phrase EDM for phrases that contain phonemes when we have
    //  phoneme placement enabled because EDM does not support phoneme listening and will mess up
    //  our errors array
    let phrases = this.getCurrentPage();
    let phrase = phrases[this.state.currentPhraseIndex];
    let words = cleanAndSplit(phrase);

    if(newErrors) {
      logSessionInfo("edm_errors_phrase_"+ overallPhraseIndex,newErrors);
      currentErrors = newErrors[overallPhraseIndex];

      if(currentErrors){
        gotErrorsFromBackend = true;

        // Cheat and ignore the last word from the backend if it is an error (in case the audio was cut off and EDM didn't have a chance)
        // avoid doing this for tap-to-read mode because clientErrors are always set to false for all words
        if(clientErrors.length && clientErrors.length === currentErrors.length){
          if(!isEarlyReaderMode(this.state.earlyReaderMode) && !isTapToReadBehavior()){
            if(currentErrors[clientErrors.length-1] === true){
              currentErrors[clientErrors.length-1] = clientErrors[clientErrors.length-1];
            }
          }
        }else if(!this.props.asrStoryID){
          // In cursor-free mode a student can deliberately end a phrase early -- via the Next button
          // (this.phraseEndedViaNextButton) or the inactivity timer (this.waitingForInactivityModalDismissal)
          // -- before the client word-tracker fills every slot, so a client array shorter than EDM's
          // full-length one is expected by design and must NOT raise the Sentry alarm. A phrase that ends
          // naturally (the student read every word) sets neither flag, so a zero/length mismatch there is a
          // real defect and still alarms, exactly as before (TT-1251).
          const endedEarly = this.phraseEndedViaNextButton || this.waitingForInactivityModalDismissal;
          if(isCursorFreeBehavior() && endedEarly){
            logSessionInfo("cursor_free_partial_errors_at_phrase_end",{
              endReason: this.phraseEndedViaNextButton ? "next_button" : "inactivity_timer",
              clientErrorsLength: clientErrors.length,
              edmErrorsLength: currentErrors.length,
              overallPhraseIndex
            });
          }else{
            console.log('Error array of length 0: ',this.state.errors,overallPhraseIndex);
            logSessionInfo("zero_length_errors",{errors: this.state.errors,overallPhraseIndex});
            Sentry.captureMessage("Zero Length Errors");
          }
        }
      }else{
        currentErrors=this.getCurrentPhraseErrors();
        // Override errors for ASR check stories when EDM times out
        currentErrors = this.overrideErrorsForASRTimeout(currentErrors);
      }

    }else{
      currentErrors=this.getCurrentPhraseErrors();
      // Override errors for ASR check stories when EDM times out
      currentErrors = this.overrideErrorsForASRTimeout(currentErrors);
    }

    // Track if the phrase is all phonemes, because we don't want to flag these phrases regardless of edm returning or not
    let phraseIsAllPhonemes = true;
        // Override all phonemes from placement manager.  EDM does not support phonemes, and they would be incorrect if we used what EDM says.
    for(let i = 0; i < words.length; i++){
      const word = words[i];
      if(isPhoneme(word)){
        currentErrors[i] = clientErrors[i];
      } else {
        phraseIsAllPhonemes = false;
      }
    };

    let errorsForInterventions = JSON.parse(JSON.stringify(currentErrors));
    let closeErrors = [];

    //Don't change app state on a retry (IOW if this is a readback)
    if(!this.state.retry){
      overallPosition += words.length;

      //Calculate placement timings at the end of the phrase
      if(!this.state.testTimeExpired){
        let timingObject = {
          position: overallPosition,
          word: words[words.length-1],
          time: this.getPlacementTime(),
          overallPhraseIndex
        }
        timings.push(timingObject);
      }

      if(!this.props.config.assessmentMode){
        // TT-1004 EDM fallback plan: tap mode, no EDM response -- tier 2 (client transcript
        // survived) or tier 3 (no/empty transcript). `false` = correct, `true` = misread.
        // Self-contained scoring call, run ONLY for tap-mode phrases with no EDM response, so
        // the pre-existing close-errors scoring block further down stays untouched. Same
        // arguments as that call, plus the pre-reset snapshot fallback: resetTranscript() in
        // onPhraseEnd wipes kaldiTranscript on iPad before this seam runs.
        let tapFallbackErrors = null;
        if(!gotErrorsFromBackend && isTapToReadBehavior()){
          const tapUseSpanishFuzzyMatch = isSpanishStory(this.props.story) && this.shouldUseNewSpanishPlacementManagerInCurrentSession();
          const tapEdmThreshold = tapUseSpanishFuzzyMatch ? Math.max(this.state.matchThreshold, SPANISH_FUZZY_MATCH_THRESHOLD) : this.state.matchThreshold;
          const tapEdmNlpOptions = tapUseSpanishFuzzyMatch ? { stripDiacritics: true } : {};
          // Source chain: the kaldi/unconstrained transcript is server-produced and arrives
          // with/after the EDM response, so it never exists for offline phrases (verified in
          // live testing: empty at snapshot time even online). The speech-provider transcript
          // accumulated DURING the phrase (props.transcript, snapshotted before the phrase-end
          // reset) is the evidence that actually survives a network drop.
          const liveUnconstrainedTranscript = getUnconstrainedTranscript();
          const tapSnapshot = this.tapToReadTranscriptSnapshot;
          const tapSnapshotSpeechTranscript = (tapSnapshot && tapSnapshot.transcript)
            ? (tapSnapshot.transcript.interim || tapSnapshot.transcript.final || '')
            : '';
          let tapTranscriptText = '';
          if (liveUnconstrainedTranscript) {
            tapFallbackTranscriptSource = 'kaldi_live';
            tapTranscriptText = liveUnconstrainedTranscript;
          } else if (tapSnapshot && tapSnapshot.unconstrained) {
            tapFallbackTranscriptSource = 'kaldi_snapshot';
            tapTranscriptText = tapSnapshot.unconstrained;
          } else if (tapSnapshotSpeechTranscript) {
            tapFallbackTranscriptSource = 'speech_transcript_snapshot';
            tapTranscriptText = tapSnapshotSpeechTranscript;
          } else {
            tapFallbackTranscriptSource = 'none';
          }
          const tapScoredTranscript = scoreTranscript(phrase,{interim: tapTranscriptText}, this.state.currentWordIndex, tapEdmThreshold,
          this.props.config.numMatchWords,this.props.config.matchWindow, this.props.config.assessmentMode, tapEdmNlpOptions);
          tapFallbackCleanTranscript = tapScoredTranscript.cleanTranscript;
          if(tapFallbackCleanTranscript && tapFallbackCleanTranscript.length > 0){
            tapFallbackTier = 'client_transcript';
            // totalErrors is sliced to transcript length (NLP.js:370); pad the rest with
            // `false` (assume correct) -- product decision 2026-07-16: words beyond the
            // transcript's reach carry no evidence either way, and the student is not
            // penalized for missing evidence (same policy as tier 3).
            tapFallbackErrors = tapScoredTranscript.totalErrors.slice(0, words.length);
            for(let i=tapFallbackErrors.length; i<words.length; i++){
              tapFallbackErrors[i] = false;
            }
          }else{
            tapFallbackTier = 'no_evidence';
            // Tap-to-read tier 3 -- no EDM response and no client transcript for this
            // phrase. Product decision 2026-07-16: send all `false` (assume correct), the
            // same value the pre-existing non-tap no-EDM path writes -- the student is not
            // penalized for missing evidence. The phrase is still flagged for review (the
            // existing !gotErrorsFromBackend path) and the
            // tap_to_read_errors_source_phrase_N telemetry records the tier per phrase.
            tapFallbackErrors = words.map(() => false);
          }
        }

        // If we got errors from the backend, we need to exclude stop words from the potential errors for interventions.
        // If we got no errors from the backend: non-tap/assessment modes assume the student got
        // everything correct so we don't intervene (unchanged); tap mode uses the tiered
        // fallback decided above. errorsForInterventions stays all-false either way.
        for(let i=0; i<words.length; i++){
          if(gotErrorsFromBackend){
            errorsForInterventions[i] = this.finalizeError(words[i],currentErrors[i]);
          }else if(isTapToReadBehavior()){
            errorsForInterventions[i] = false;
            if(!isPhoneme(words[i])){
              // Phoneme words keep the client (tapped) value the phoneme-override loop above
              // already assigned -- EDM doesn't support phoneme listening, and neither does
              // this fallback.
              currentErrors[i] = tapFallbackErrors[i];
            }
          }else{
            errorsForInterventions[i]=false;
            currentErrors[i] = false; //If we got no answer from EDM, assume student got everything right.
          }
        }

        // CLIENT OVERRIDES - set errors based on existing interventions
        // Do this after setting errorsForInterventions, so we don't override EDM with word level interventions
        // for purposes of selecting phrase level interventions.
        // TT-1279: skip indices marked as suppressed interventions (stop word, < 3 chars, first word of
        // story). Those words were diverted to skipWord without delivering a real intervention, so a correct
        // read should keep EDM's score instead of being forced to an error. Real mid-phrase interventions
        // are not in the suppressed set, so they still override EDM as before.
        const suppressedInterventions = this.state.storySuppressedInterventions?.[overallPhraseIndex];
        this.state.storyInterventions[overallPhraseIndex].forEach((intervened,index)=>{
          let override = intervened && !suppressedInterventions?.[index];
          if(override){
            currentErrors[index] = true;
          }
        });

        if(!gotErrorsFromBackend && isTapToReadBehavior()){
          // Permanent telemetry (not removed with the temporary debug logging above) so the
          // scoring team can evaluate the tier-3 "assumed silent" policy. errorCount reflects
          // currentErrors after client overrides, i.e. the count that's actually submitted.
          logSessionInfo("tap_to_read_errors_source_phrase_"+overallPhraseIndex, {
            tier: tapFallbackTier,
            transcriptSource: tapFallbackTranscriptSource,
            transcriptLength: tapFallbackCleanTranscript ? tapFallbackCleanTranscript.length : 0,
            errorCount: currentErrors.filter(Boolean).length,
          });
        }
      }

      if(!gotErrorsFromBackend && !this.props.config.assessmentMode && !phraseIsAllPhonemes){
        // Flag the current phrase for review when EDM doesn't respond
        studentRecordService.updateFlaggedPhrase(this.state.activityId, overallPhraseIndex, true)
          .catch((error) => {
            console.error('Error flagging phrase for review:', error);
            logSessionInfo('error_flagging_phrase', {
              error: error?.message || error,
              activityId: this.state.activityId,
              phraseIndex: overallPhraseIndex
            });
          });
        console.log("No errors from backend. Using",JSON.stringify(currentErrors));
        logSessionInfo("no_errors_from_backend_phrase_"+overallPhraseIndex,{errors: currentErrors});
      } else if (phrasesWithAutoProgressedWords[overallPhraseIndex]) {
        // Flag the current phrase for review if we auto-progressed any words
        studentRecordService.updateFlaggedPhrase(this.state.activityId, overallPhraseIndex, true)
          .catch((error) => {
            console.error('Error flagging auto-progressed phrase:', error);
            logSessionInfo('error_flagging_phrase', {
              error: error?.message || error,
              activityId: this.state.activityId,
              phraseIndex: overallPhraseIndex
            });
          });
      }

      //Get the transcript from the Google EDM and align it so we can get close errors independantly of placement manager.
      const useSpanishFuzzyMatch = isSpanishStory(this.props.story) && this.shouldUseNewSpanishPlacementManagerInCurrentSession();
      const edmThreshold = useSpanishFuzzyMatch ? Math.max(this.state.matchThreshold, SPANISH_FUZZY_MATCH_THRESHOLD) : this.state.matchThreshold;
      const edmNlpOptions = useSpanishFuzzyMatch ? { stripDiacritics: true } : {};
      let transcript = scoreTranscript(phrase,{interim: getUnconstrainedTranscript()}, this.state.currentWordIndex, edmThreshold,
      this.props.config.numMatchWords,this.props.config.matchWindow, this.props.config.assessmentMode, edmNlpOptions).cleanTranscript;
      logSessionInfo("unconstrained_transcript_phrase_"+overallPhraseIndex,transcript);

      if(words){
        currentErrors.map((error,index)=>{
          if(error){
            let utteredWord = (transcript && transcript[index]) ? transcript[index] : null;
            let desiredWord = (words && words[index]) ? words[index] : null;
            if((utteredWord && desiredWord) && (utteredWord !== desiredWord)){
              let closeError = {
                index: index,
                utteredWord: utteredWord,
                desiredWord: desiredWord,
              };
              closeErrors.push(closeError);
            }
          }
        });
      }

      overAllErrors = this.setCurrentPhraseErrors(currentErrors,true);
      let errorCount = this.state.errorCount;
      let currentErrorCount = 0;

      let studentPauseTime = this.getStudentPauseTime();

      for(let i = 0; i < currentErrors.length; i++){
        if(currentErrors[i]){
          currentErrorCount += 1;
        }
      }

      //Save the errors for this phrase
      errorCount[overallPhraseIndex] = currentErrorCount;

      this.setState({
        errorCount: errorCount,
        pauseLength: studentPauseTime,
        isFinal: true,
        savedPhraseErrors: currentErrors,
      });
      
      // EDM ALL-TRUE DETECTION FOR NEXT BUTTON (TT-1007)
      // When a cursor-free OR tap-to-read student clicks Next and EDM returns all errors (all words wrong),
      // trigger a retry using the existing tryAgain() flow with recording enabled.
      // This gives the student a chance to re-read the phrase with EDM processing the retry audio.
      // Reuses existing cursor-free logic for parity.
      // Normal flow proceeds if any transcript was captured (gotErrorsFromBackend guards this).
      if (this.phraseEndedViaNextButton && (isTapToReadBehavior() || isCursorFreeBehavior())) {
        // Check if ALL words are marked as errors (EDM returned all TRUE)
        const allWordsAreErrors = currentErrors.length > 0 && currentErrors.every(error => error === true);
        
        if (allWordsAreErrors) {
          const mode = isTapToReadBehavior() ? 'tap-to-read' : 'cursor-free';
          // Log the retry trigger
          logSessionInfo(`next_button_edm_all_true_retry_${mode}_phrase_${overallPhraseIndex}`, {
            phraseIndex: overallPhraseIndex,
            errorCount: currentErrors.length,
            phraseLength: words.length
          });
          
          // Clear the Next button timer before retry
          this.clearNextButtonTimer();
          
          // Match read intervention flow exactly:
          // 1. Decrement lastEndedPhrase to allow phrase retry
          this.lastEndedPhrase = this.lastEndedPhrase - 1;
          
          // 2. Clear loading overlay
          this.setIsLoading(false);
          
          // 3. Speak intervention lead-in (e.g., "Let's try that again")
          speakInterventionLeadIn(this.props.speech, interventionType.read);
          
          // 4. Read phrase aloud, THEN trigger retry (same as read intervention)
          this.readAloudWithCallback(this.tryAgain.bind(this));
          
          // Early return to prevent intervention selection
          return;
        }
      }
    }else if(this.state.savedPhraseErrors){
      overAllErrors = this.setCurrentPhraseErrors(this.state.savedPhraseErrors,true);
    }

    // TT-1283: capture the audio-duration denominator BEFORE the await below. getAudioDuration
    // is a live, activity-cumulative counter (totalBytesSent/32), so reading it after the
    // up-to-LM_GRAPH_REPRIME_BUDGET_MS wait could fold in audio flushed during the gap and
    // deflate the wcpm that feeds intervention selection and relevel.
    const audioDurationAtPhraseEnd = getAudioDuration();

    // TT-1283: with end-of-phrase timers paused and no Next button live, re-download the
    // NEXT phrase's biased LM graph if it is missing (a weak network usually recovers
    // mid-read) and decide whether that phrase decodes locally or routes to server Kaldi.
    // Awaited here — before onPageEnd / handleEndOfPhraseInterventions — so the decision is
    // latched before the next phrase can start. On the missing-graph path this inserts up
    // to the re-download budget before intervention selection; server ASR is the escape
    // hatch when the budget expires.
    await this._prepareNextPhraseBiasedGraph();

    // This function is now async (the await above), so the reader can unmount mid-wait
    // (student exits). Everything below reads live component/module state and calls
    // setState/onPageEnd, so bail if we were torn down during the wait.
    if (!this._isMounted) {
      return;
    }

    // check track of most recent WPM and accuracy
    const mostRecentScores = calculateMostRecentScores(overAllErrors, audioDurationAtPhraseEnd);
    if((this.state.currentPhraseIndex >= phrases.length - 1) || this.state.testTimeExpired){
      // END OF PAGE.
      // Do any end of phrase interventions and then hit end of page when they're done
      const sessionInfo = {cursorPosition: this.state.currentWordIndex, phraseLength: words.length, timeStamp: Date.now(),}
      // Always call onPageEnd if test time has expired.
      if(this.state.testTimeExpired){
        logSessionInfo("assessment_time_expired_page_end", sessionInfo);
        this.onPageEnd(phrases);
      }else if(this.props.config.assessmentMode){
        logSessionInfo("assessment_cursor_page_end", sessionInfo);
        // If page nav is enabled, defer calling onPageEnd to onNextPageClick because we don't want to automatically advance the page.
        this.onPageEnd(phrases);
      }else{
        if(this.state.earlyReaderMode && this.state.earlyReaderMode.wordList){
          logSessionInfo("early_reader_word_list_page_end", sessionInfo);
        }
        let callbackAfterIntervention = (currentPhrases, didIntervene=false) => {
          this.onPageEnd(currentPhrases, didIntervene);
          this.setState({
            callbackAfterIntervention: null,
            interveningAtEndOfPage: false,
          });
        }
        this.setState({
          callbackAfterIntervention: !this.state.testTimeExpired ? callbackAfterIntervention.bind(this,phrases,true) : null,
          interveningAtEndOfPage: !this.state.testTimeExpired,
        }, () =>{
          this.handleEndOfPhraseInterventions(
            mostRecentScores,
            closeErrors,
            errorsForInterventions,
            phraseInterventionWeights,
            interventionMetadata,
          ).then(didIntervene => {
            if((didIntervene) && (this.state.testTimeExpired == false)){
              logSessionInfo("delayed_page_end",{phraseIndex: overallPhraseIndex, newErrors: newErrors});
            }else{
              let delayedPageEnd = ((phrases)=>{
                // Don't advance page if waiting for inactivity modal dismissal
                if (!this.waitingForInactivityModalDismissal) {
                  callbackAfterIntervention(phrases);
                }
              }).bind(this,phrases);
              this.delayedPageEndTimeoutRef.current = window.setTimeout(delayedPageEnd,1500);
            }
          }).catch(err => {
            console.error("Error in handleEndOfPhraseInterventions promise chain:", err);
            logSentryException(new Error('Phrase interventions chain failure'), 'Error in handleEndOfPhraseInterventions promise chain', { originalError: err?.message, originalStack: err?.stack });
          });
        });
      }
    }else{
      //END OF PHRASE (not end of page)
      this.handleEndOfPhraseInterventions(
        mostRecentScores,
        closeErrors,
        errorsForInterventions,
        phraseInterventionWeights,
        interventionMetadata,
      ).then((intervened)=>{
        if(!intervened && !this.waitingForInactivityModalDismissal){
          this.abortIntervention();
        }else{
          logSessionInfo("delayed_phrase_end",{phraseIndex: overallPhraseIndex, newErrors: newErrors});
        }
      });
    }
  }

  /**
   * Gets the amount of time to wait before doing an intervention in the middle of a phrase.
   * 
   * Pause time is based on student's WCPM (Words Correct Per Minute):
   * - WCPM unavailable: 7 seconds (default/longest)
   * - WCPM < 30: 7 seconds
   * - WCPM 30-50: 5.5 seconds
   * - WCPM 50-80: 4.5 seconds
   * - WCPM > 80: 3.5 seconds
   *
   * Spanish pilot overrides (applied after standard calculation):
   * - WCPM unavailable or < 50: 7 seconds
   * - WCPM >= 50: 6 seconds
   * 
   * @returns {number} Pause time in milliseconds
   */
  getStudentPauseTime(){
    if(this.props.config.assessmentMode){
      return 4000;  //Always 4 seconds for anything that pops up during assessment
    }

    let studentPauseTime;

    const interventionParams = this.getInterventionSelectionV2Params();
    const interventionWCPM = interventionParams.prev_equatedwcpm;
    
    if (!interventionWCPM || interventionWCPM < 30) {
      studentPauseTime = 7000; // 7 seconds
    } else if (interventionWCPM < 50) {
      studentPauseTime = 5500; // 5.5 seconds
    } else if (interventionWCPM < 80) {
      studentPauseTime = 4500; // 4.5 seconds
    } else {
      studentPauseTime = 3500; // 3.5 seconds
    }

    // New Spanish PM sessions need more time: 7s for < 50 WCPM, 6s for >= 50 WCPM
    if (this.shouldUseNewSpanishPlacementManagerInCurrentSession()) {
      studentPauseTime = (!interventionWCPM || interventionWCPM < 50) ? 7000 : 6000;
    }

    // For early readers, crank out the pause time by 2 seconds. TODO: tune this.
    if(isEarlyReaderMode(this.state.earlyReaderMode)){
      studentPauseTime += 2000;
    }
    return studentPauseTime;
  }

  // returns true if phoneme placement is enabled and also the current word is a phoneme
  shouldListenForPhonemes(word=null){
    const currentWord = word || this.getCurrentWord(this.state.currentWordIndex);
    return this.props.speech.getPhonemePlacementEnabled() && isPhoneme(currentWord);
  }

  async handleEndOfPhraseInterventions(
    mostRecentScores,
    closeErrors,
    currentErrors,
    phraseInterventionWeights,
    interventionMetadata,
  ){
    // If we're waiting for inactivity modal dismissal, enable the button and return early
    // We'll trigger re-read intervention when the modal is dismissed, not now
    if (this.waitingForInactivityModalDismissal) {
      this.enableInactivityModalButton();
      return Promise.resolve(false);
    }

    let errorsInPhrase = this.getWordErrors(currentErrors);
    let currentErrorCount = errorsInPhrase.length;
    let didIntervene = false;

    //If interventions are disabled, just return
    if(!this.props.config.enableInterventions || (this.state.retry && !getIsInReadWithMeMode())  || this.disableInterventionsForPhrase){
      return Promise.resolve(didIntervene);
    }
    // Handle interaction scenario override
    const phraseMetadata = this.getCurrentPhraseMetaData();
    if (phraseMetadata && phraseMetadata.type === 'interactive') {
      await this.launchInteraction();
      this.props.closeModal();
      await new Promise((resolve) => {
        setTimeout(() => { resolve() }, 200);
      });
      moveOnWithoutSpeaking(
        this.openWordInterventionModal, // callback
        true, // endOfPhrase
      );
      return (Promise.resolve(true));
    }
    let currentPhraseLength = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length;
    let skips = this.getCurrentPhraseScore().skips;
    
    return selectPhraseIntervention({
      currentErrorCount: currentErrorCount,
      errorsInPhrase: errorsInPhrase,
      mostRecentScores: mostRecentScores,
      currentPhraseLength: currentPhraseLength,
      closeErrors: closeErrors,
      skips: skips,
      frameTimes: this.state.frameTimes,
      forceIntervention: this.props.forceIntervention,
      interventionBias: this.props.interventionBias,
      phraseMetaData: this.getCurrentPhraseMetaData(),
      predictionConfidences: predictionConfidences[overallPhraseIndex],
      phraseInterventionWeights,
      interventionMetadata,
      story: this.props.story,
    }).then(async (phraseIntervention)=>{
      console.log('interior phrase', [phraseIntervention,this.state.lastWordInterventionIndex, (currentPhraseLength-1)] );
      phraseIntervention.word = this.getCurrentWord(phraseIntervention.index, true);

      this.setState({
          lastWordError: phraseIntervention.word,
          lastWordIndex: phraseIntervention.index
        },
      )

      // This is where we do the hack to not intervene if we already did on the last word
      // TODO consider how to make this cleaner. One approach (which Pete disagrees with) would be
      // to consolidate intervention history and state across interventionSelection and ReaderManager,
      // probably by creating a class to represent state and more fully embracing OOP

      //Do it this way so we can log situations where preflight fails
      let validIntervention = true;
      if(preflightIntervention(phraseIntervention.word,phraseIntervention) === false){
        console.log("FAILED PREFLIGHT:",phraseIntervention.word,phraseIntervention);
        logSessionInfo("failed_preflight",{ word: phraseIntervention.word, interventionType: phraseIntervention?.type, hasMetadata: !!phraseIntervention?.metadata, hasCloseError: !!phraseIntervention?.closeError });
        validIntervention = false;
      }

      if(!validIntervention ||
        (((this.state.lastWordInterventionIndex === (currentPhraseLength-1)) && !isEarlyReaderMode(this.state.earlyReaderMode)) ||
        (alreadyIntervened(phraseIntervention.word) == true))){
        if(phraseIntervention.type !== interventionType.repeatsentence && phraseIntervention.type !== interventionType.initiateReadWithMe && phraseIntervention.type !== interventionType.readwithme && phraseIntervention.type !== interventionType.endReadWithMe) {
          phraseIntervention = {
            word: "OverrideLastWord",
            type: interventionType.none,
          };
        }
      }

      if(phraseIntervention.scope !== scopeType.phrase && phraseIntervention.word && phraseIntervention.type !== interventionType.none){
        try{
          let success = await this.launchWordIntervention(phraseIntervention.word,mostRecentScores,true,phraseIntervention);
          didIntervene = success;
          console.log("LAUNCH RETURNED",didIntervene);
        }catch(err){
          console.log("ERROR EXECUTING PHRASE INTERVENTION:",err);
          logSessionInfo(err.name + " " + err.message,{error: err.stack});
          logSentryException(new Error('Phrase intervention execution failure'), 'Error executing phrase intervention', { originalError: err?.message, originalStack: err?.stack });
          didIntervene = false;
        }
      } else if (phraseIntervention.type === interventionType.comprehension || phraseIntervention.type === interventionType.prediction){
        try{
          phraseIntervention.word = !phraseIntervention.word ? `${phraseIntervention.type}_NO_ERRORS` : phraseIntervention.word;
          let success = await this.launchWordIntervention(phraseIntervention.word,mostRecentScores,true,phraseIntervention); //TODO: consolidate these calls and rename launchWordIntervention to make it scope agnostic (launch modal intervention  maybe)
          didIntervene = success;
          console.log("LAUNCH RETURNED",didIntervene);
        }catch(err){
          console.log("ERROR EXECUTING PHRASE INTERVENTION:",err);
          logSessionInfo(err.name + " " + err.message,{error: err.stack});
          logSentryException(new Error('Phrase intervention execution failure'), 'Error executing phrase intervention', { originalError: err?.message, originalStack: err?.stack });
          didIntervene = false;
        }
      } else if(phraseIntervention.word) {
        didIntervene = this.triggerEndOfPhraseInterventions(phraseIntervention.type,currentErrorCount,phraseIntervention.word,phraseIntervention.index);
      } else {
        didIntervene = false;
      }

      onPhraseInterventionSelected(phraseIntervention);
      return Promise.resolve(didIntervene);
    })
    .catch(err => {
      console.log("ERROR IN END OF PHRASE:",err);
      logSessionInfo(err.name + " " + err.message,{error: err.stack});
      logSentryException(new Error('End of phrase handling failure'), 'Error in end of phrase', { originalError: err?.message, originalStack: err?.stack });
      return Promise.resolve(false);
    });
  }

  displayStudentStatus(timed = false, hasStudentAssignment = null){
    this.setIsLoading(true);
    let activityId = this.props.config.assessmentMode ? null : this.state.activityId;

    getStudentMetrics(activityId, true).then(resp =>{
      this.setIsLoading(false);
      this.props.speech.stopListening();

      if (resp.currentWCPM) {
        setUserData("WCPM", resp.currentWCPM);
        setUserData("interventionSelectionWCPMScore", resp.currentWCPM);
      }

      if (resp.currentARMScore) {
        setUserData("interventionSelectionARMScore", resp.currentARMScore);
      }

      let currentMetrics=resp.currentWCPM ?
      {wcpm: resp.currentWCPM, accuracy: resp.currentAccuracy} :
      {wcpm: this.state.wcpm, accuracy: this.state.accuracy};

      //If we didn't get current metrics, log this fact to the backend
      if(!resp.currentWCPM || !resp.currentAccuracy){
        resp.currentWCPM = this.state.wcpm;
        resp.currentAccuracy = this.state.accuracy;
        logSessionInfo('metrics_activity_was_not_scored',resp);
      }

      let ssType = studentStatusTypes.STORY;
      if(timed){
        ssType = studentStatusTypes.TIMED;
      } else if(this.props.config.assessmentMode){
        if(this.props.orfMode){
          ssType = studentStatusTypes.ASSESSMENT;
        } else {
          ssType = studentStatusTypes.GENERIC;
        }
      }

      // Use the passed hasStudentAssignment if provided, otherwise fall back to checking the prop
      const studentAssignmentValue = hasStudentAssignment !== null ? hasStudentAssignment : !!this.props.studentAssignment;

      this.openModalAndStopListening(
        <StudentStatus
          currentMetrics={currentMetrics}
          historicMetrics={resp}
          speech={this.props.speech}
          history={this.props.history}
          type={ssType}
          showStats={!this.props.config.assessmentMode}
          redirect={!this.props.config.assessmentMode}
          returnUrl={this.props.returnUrl}
          resetStory={this.props.resetStory}
          hasStudentAssignment={studentAssignmentValue}
        />
      );
    }).catch(err => {
      console.warn("ERROR IN DISPLAY STUDENT STATUS:",err);
      logSessionInfo('error_displaying_student_status',{error: err, errMessage: err.message});
      // Go to Story picker if studentMetrics call fails
      this.props.resetStory();
    }).finally(() => {
      this.setIsLoading(false);
    });
  }

  displayEarlyReaderStatus(hasStudentAssignment = null){
    // Use the passed hasStudentAssignment if provided, otherwise fall back to checking the prop
    const studentAssignmentValue = hasStudentAssignment !== null ? hasStudentAssignment : !!this.props.studentAssignment;
    
    this.openModalAndStopListening(
      <EarlyReaderStatus
        speech={this.props.speech}
        history={this.props.history}
        returnUrl={this.props.returnUrl}
        resetStory={this.props.resetStory}
        hasStudentAssignment={studentAssignmentValue}
      />
    );
  }

  onSubmitQuiz(results){
    logComprehensionQuizMetrics(results, this.props.questions);
    this.props.closeModal();
    if(!isSendingComplete()){
      this.openWaitModal(this.finalizeTutor);
    }else{
      this.finalizeTutor();
    }
  }

  sendEndOfStoryRecording(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.SEND_RECORDING });
    if(this.props.speech){
      this.props.speech.disableRecording();
      this.props.speech.stopListening();
      let recordingProps ={
        storyId: this.props.story.storyId,
        storyVersion: this.props.story.version || "1",
        version: this.props.story.version || "1",
        activityType: this.props.story.type,
        activityId: this.state.activityId,
        studentId: getUserData().userId,
        flagPhrase: getIsInReadWithMeMode(),
      };

      if (this.state.assessmentTestletId) {
        recordingProps = {
          ...recordingProps,
          testletId: this.state.assessmentTestletId,
          itemId: this.getCurrentPhraseMetaData().itemId,
          gradeLevel: getUserData().actualGrade,
        };
      }

      if (this.props.speech.hasAudioDestination()) {
        this.props.speech.buildAdhocRecording(this.state.activityId,recordingProps);
      } else {
        buildSessionAudio(this.state.activityId,recordingProps);
      }
      logSessionInfo("glitch_metrics",this.props.speech.silentSegments());
    }
  }

  sendEndOfTestletRecording(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.SEND_TESTLET_RECORDING });
    if(this.props.speech){
      this.props.speech.disableRecording();
      this.props.speech.stopListening();
      let recordingProps ={
        storyId: this.props.story.storyId,
        storyVersion: this.props.story.version || "1",
        version: this.props.story.version || "1",
        activityType: this.props.story.type,
        activityId: this.state.activityId,
        studentId: getUserData().userId,
        testletId: this.state.assessmentTestletId,
        itemId: this.getCurrentPhraseMetaData().itemId,
        gradeLevel: getUserData().actualGrade,
      };

      if (this.props.speech.hasAudioDestination()) {
        this.props.speech.buildAdhocRecording(this.state.activityId,recordingProps);
      } else {
        buildSessionAudio(this.state.activityId,recordingProps);
      }
      logSessionInfo("glitch_metrics",this.props.speech.silentSegments());
    }
  }

  updateScoring(){
    const { storyErrors, accuracy, wcpm } = calculateMostRecentScores(this.state.errors, getAudioDuration());
    this.setState({wcpm,accuracy});
    return { storyErrors, accuracy, wcpm }
  }

  computeAudioMetrics(){
    const userData = getUserData();
    const activityAudioMetrics = this.props.speech.getActivityAudioMetrics();
    // TT-1110: this file's own thresholds aren't visible to Speech.js, so merge them into
    // the same activeThresholds object -- the whole point is a self-describing payload that
    // doesn't require knowing which constants produced it from a separate source read.
    activityAudioMetrics.activeThresholds = {
      ...activityAudioMetrics.activeThresholds,
      lowVolumeCheckThreshold: LOW_VOLUME_CHECK_THRESHOLD,
      strictLowVolumeCheckThreshold: STRICT_LOW_VOLUME_CHECK_THRESHOLD,
      badClippedSegmentsActivityThreshold: BAD_CLIPPED_SEGMENTS_ACTIVITY_THRESHOLD,
    };
    console.info('Activity audio metrics:', activityAudioMetrics);

    const {
      lowRmsSegmentCount, totalSegmentCount, staticSegmentCountByType, badClippedSegments,
    } = activityAudioMetrics;

    const activityType = this.props.story?.type;
    const percentageRequirement = activityType && STRICT_LOW_VOLUME_CHECK_ACTIVITY_TYPES.includes(activityType) ? STRICT_LOW_VOLUME_CHECK_THRESHOLD : LOW_VOLUME_CHECK_THRESHOLD;

    let isLowVolume = false;
    let isStaticLowBand = false;
    let isStaticBroadband = false;
    let isClipped = false;

    if (percentageRequirement && totalSegmentCount) {
      if(lowRmsSegmentCount >= percentageRequirement * totalSegmentCount){
        console.warn("Activity low volume detected", { lowRmsSegmentCount, totalSegmentCount });
        isLowVolume = true;
      }
      if(staticSegmentCountByType?.lowBand >= percentageRequirement * totalSegmentCount){
        console.warn("Activity static low band detected", { staticSegmentCountByType, totalSegmentCount });
        isStaticLowBand = true;
      }
      if(staticSegmentCountByType?.broadband >= percentageRequirement * totalSegmentCount){
        console.warn("Activity static broadband detected", { staticSegmentCountByType, totalSegmentCount });
        isStaticBroadband = true;
      }
    }

    if(badClippedSegments >= BAD_CLIPPED_SEGMENTS_ACTIVITY_THRESHOLD) {
      console.warn("Activity clipped detected", { badClippedSegments });
      isClipped = true;
    }

    if (this.props.initialUrlParams?.forceClippedAudio === 'true') {
      isClipped = true;
    }
    if (this.props.initialUrlParams?.forceStaticAudio === 'true') {
      isStaticLowBand = true;
    }
    if (this.props.initialUrlParams?.forceLowAudio === 'true') {
      isLowVolume = true;
    }

    const audioIssueDetectionResult = processPotentialAudioIssues({
      isLowVolume,
      isStaticLowBand,
      isStaticBroadband,
      isClipped,
      timings,
      story: this.props.story,
      userTheta: userData.THETA,
      activityAudioMetrics,
      forceAllUnks: this.props.initialUrlParams?.forceAllUnks === 'true',
    });

    const configLicenseAudioIssueTroubleshootEnabled = userData.appSettings?.midAssessmentAudioIssueTroubleshootEnabled === true;
    const districtExplicitlyDisabled = userData.midAssessmentAudioIssueTroubleshootEnabled === false;
    const districtLicenseAudioIssueTroubleshootEnabled = userData.midAssessmentAudioIssueTroubleshootEnabled === true;
    const audioIssueTroubleshootEnabled = !districtExplicitlyDisabled &&
      (configLicenseAudioIssueTroubleshootEnabled || districtLicenseAudioIssueTroubleshootEnabled);
    const suppressMidSessionTroubleshoot = this.props.initialUrlParams?.suppressMidSessionTroubleshoot === 'true';
    const shouldStartMidSessionTroubleshoot = audioIssueDetectionResult.triggered &&
      audioIssueTroubleshootEnabled &&
      !!this.props.startMidSessionTroubleshoot &&
      !suppressMidSessionTroubleshoot;

    // Determine audio issue type for troubleshoot modal.
    // Uses optional chaining as defensive null-safety if conditionMetadata is ever undefined.
    const metadata = audioIssueDetectionResult.conditionMetadata;
    const audioIssueType = {
      isClipped: metadata?.isClipped ?? false,
      deviceIssue: (metadata?.isLowVolume || metadata?.isStaticLowBand || metadata?.isStaticBroadband) ?? false,
    };

    return {
      ...audioIssueDetectionResult,
      shouldStartMidSessionTroubleshoot,
      audioIssueType,
      isLowVolume,
    };
  }

  resetAudioNetworkSignalsForActivity() {
    const leftover = this._audioNetworkSignalsDirty ? this._audioNetworkSignalsPending : null;
    this.phraseNetworkSignals = [];
    this._clippingP90ByPhrase = new Map();
    this._audioNetworkSignalsFingerprint = null;
    this._audioNetworkSignalsDirty = false;
    this._audioNetworkSignalsPending = null;
    this.networkMonitoringService?.resetForNewActivity?.();
    // Keep a dirty snapshot from the previous activity so an in-flight save
    // still flushes story-end data onto the old id, not the new one.
    if (leftover) {
      this._audioNetworkSignalsFlushAfterSave = leftover;
      if (!this._audioNetworkSignalsSaving) {
        this._flushLeftoverAudioNetworkSignals();
      }
    }
  }

  persistAudioNetworkSignals({ fullRefresh = false } = {}) {
    if (getUserData().appSettings?.audioNetworkSignalsPersistEnabled === false) {
      return;
    }
    const activityId = this.state.activityId;
    if (!activityId || !this.props.speech) {
      return;
    }
    const prepared = this._prepareAudioNetworkSignalsWrite(activityId, fullRefresh);
    if (!prepared) {
      return;
    }
    if (this._audioNetworkSignalsSaving) {
      this._audioNetworkSignalsDirty = true;
      this._audioNetworkSignalsPending = prepared;
      return;
    }
    this._writeAudioNetworkSignals(prepared);
  }

  _prepareAudioNetworkSignalsWrite(activityId, fullRefresh) {
    const payload = this._buildAudioNetworkSignalsPayload(fullRefresh);
    if (!payload) {
      return null;
    }
    const fingerprint = audioNetworkSignalsFingerprint(payload);
    if (
      fingerprint === this._audioNetworkSignalsFingerprint ||
      fingerprint === this._audioNetworkSignalsInFlightFingerprint ||
      fingerprint === this._audioNetworkSignalsPending?.fingerprint
    ) {
      return null;
    }
    return { activityId, payload, fingerprint };
  }

  _buildAudioNetworkSignalsPayload(fullRefresh) {
    if (!this._clippingP90ByPhrase) {
      this._clippingP90ByPhrase = new Map();
    }
    if (fullRefresh) {
      const rows = this.props.speech.getPhraseClippingP90s?.() || [];
      this._clippingP90ByPhrase = new Map(rows.map((row) => [row.phraseIndex, row]));
    } else {
      const last = this.phraseNetworkSignals?.[this.phraseNetworkSignals.length - 1];
      if (Number.isFinite(last?.phraseIndex)) {
        const row = this.props.speech.getPhraseClippingP90?.(last.phraseIndex);
        if (row) {
          this._clippingP90ByPhrase.set(last.phraseIndex, row);
        }
      }
    }
    const activityMetrics = fullRefresh
      ? (this.props.speech.getActivityAudioMetrics?.() || {})
      : (this.props.speech.getAudioNetworkActivityFields?.() || {});
    return buildAudioNetworkSignals({
      audioRuleVersion: activityMetrics.audioRuleVersion,
      isLowVolume: this.activityIsLowVolume(activityMetrics),
      flatlineMaxRunSec: activityMetrics.flatlineMaxRunSec,
      badCount: this.networkMonitoringService?.badNetworkCount,
      monitoringActive: !!this.networkMonitoringService?.monitoringArmedThisActivity,
      phrases: mergePhraseSignals(
        [...this._clippingP90ByPhrase.values()],
        this.phraseNetworkSignals || [],
      ),
    });
  }

  _writeAudioNetworkSignals({ activityId, payload, fingerprint }) {
    this._audioNetworkSignalsSaving = true;
    this._audioNetworkSignalsInFlightFingerprint = fingerprint;
    withTimeout(
      studentRecordService.saveAudioNetworkSignals(activityId, payload),
      LOW_VOLUME_CALLS_TIMEOUT,
      'saveAudioNetworkSignals timeout after 10s'
    ).then(() => {
      this._audioNetworkSignalsFingerprint = fingerprint;
    }).catch((error) => {
      console.error('Error saving audioNetworkSignals:', error);
      logSessionInfo('error_saving_audio_network_signals', {
        error: graphQLErrorMessage(error),
        activityId,
      });
    }).finally(() => {
      this._audioNetworkSignalsSaving = false;
      this._audioNetworkSignalsInFlightFingerprint = null;
      if (this._audioNetworkSignalsFlushAfterSave) {
        this._flushLeftoverAudioNetworkSignals();
        return;
      }
      if (this._audioNetworkSignalsDirty) {
        this._audioNetworkSignalsDirty = false;
        const pending = this._audioNetworkSignalsPending;
        this._audioNetworkSignalsPending = null;
        if (pending) {
          this._writeAudioNetworkSignals(pending);
        } else {
          this.persistAudioNetworkSignals();
        }
      }
    });
  }

  _flushLeftoverAudioNetworkSignals() {
    const leftover = this._audioNetworkSignalsFlushAfterSave;
    this._audioNetworkSignalsFlushAfterSave = null;
    if (!leftover) {
      return;
    }
    if (getUserData().appSettings?.audioNetworkSignalsPersistEnabled === false) {
      return;
    }
    this._writeAudioNetworkSignals(leftover);
  }

  activityIsLowVolume(activityMetrics) {
    if (this.props.initialUrlParams?.forceLowAudio === 'true') {
      return true;
    }
    const { lowRmsSegmentCount, totalSegmentCount } = activityMetrics || {};
    const activityType = this.props.story?.type;
    const percentageRequirement = activityType && STRICT_LOW_VOLUME_CHECK_ACTIVITY_TYPES.includes(activityType)
      ? STRICT_LOW_VOLUME_CHECK_THRESHOLD
      : LOW_VOLUME_CHECK_THRESHOLD;
    return Boolean(
      percentageRequirement &&
      totalSegmentCount &&
      lowRmsSegmentCount >= percentageRequirement * totalSegmentCount
    );
  }

  /**
   * Stashes this activity's live audio + network signals (TT-991) onto userData so the NEXT
   * tutor activity in the same session classifies against them. The same-session half of the
   * seam described in priorActivitySignals.js; the other half is API.saveUserData reading
   * TT-1256's persisted payload off the previous tutor activity at login.
   *
   * The audio metrics are re-read rather than threaded out of computeAudioMetrics():
   * getActivityAudioMetrics() is a pure read of cumulative counters and does not reset them, so
   * re-reading costs one extra pass and leaves computeAudioMetrics' return shape -- which the
   * assessment path also destructures -- untouched. The master gate is repeated here, though
   * the callee gates too, so a gated-off onStoryEnd never even reaches that re-read.
   *
   * Its own try/catch on purpose: onStoryEnd's outer catch would swallow a throw here only by
   * abandoning scoring, IES and the status screen. Fails closed to "no signal stashed".
   *
   * Only the two high-precision audio debug params -- ?forceDeadSilenceAudio and
   * ?forcePervasiveClippingAudio -- substitute a synthetic payload HERE, at the point the stash is
   * built, and the substitution is logged (cursor_bad_signal_audio_forced). Those are exactly the
   * params that can reach a mode and that isBadSignalForcedSession marks write-suppressed, so
   * "fabricates the stash" and "is a forced session" stay the same set. ?forceLowAudio,
   * ?forceStaticAudio and ?forceClippedAudio belong to audio-issue detection, cannot reach a
   * bad-signal mode, and are NOT substituted -- replacing the real signal for them would silently
   * mask a genuinely bad prior activity from the next activity's decision (a false negative). The
   * real counters are left exactly as they are either way, so computeAudioMetrics above and the
   * mid-session troubleshoot path keep seeing the audio that actually happened; only what the
   * next activity classifies against changes.
   */
  stashLiveActivitySignals(story) {
    if (!isBadSignalCursorEnabled() || this.props.asrStoryID || story?.type !== assignmentTypes.TUTOR) {
      return;
    }

    try {
      // Only dead silence / pervasive clipping fabricate: the two mode-reaching, forced-session
      // params (see the docblock above and cursor/signalThresholds.isBadSignalForcedSession).
      const fabricateForcedAudio = FORCE_BAD_SIGNAL_AUDIO?.deadSilence === true
        || FORCE_BAD_SIGNAL_AUDIO?.pervasiveClipping === true;
      // Null-tolerant: an activity abandoned mid-phrase can reach here with no audio metrics
      // and no monitoring service at all.
      const audioMetrics = fabricateForcedAudio
        ? buildForcedAudioMetrics(FORCE_BAD_SIGNAL_AUDIO)
        : (this.props.speech?.getActivityAudioMetrics?.() ?? null);
      // Per-phrase send->ack rows go in too, not just the episode count: TT-1257's deferral is
      // waiting on send->ack p50/p95 from production, and the live path is the ONLY one that
      // produces a signal for the 2nd+ activity of a session, so leaving them out would have
      // withheld roughly half the rows from the measurement that unblocks it. Logged, never
      // classified -- no rule reads them.
      const networkHealth = this.networkMonitoringService
        ? {
          badCount: this.networkMonitoringService.badNetworkCount,
          // Same expression TT-1256's own persist path uses (see monitoringActive above), so the
          // live and stored halves of one activity cannot disagree about whether monitoring ran.
          // Without it a live badCount of 0 stays ambiguous between "never went bad" and "never
          // monitored", which is exactly the TODO(TT-1257) the stored path already closed.
          monitoringActive: !!this.networkMonitoringService.monitoringArmedThisActivity,
          phrases: this.phraseNetworkSignals,
        }
        : null;

      if (fabricateForcedAudio) {
        // Loud on purpose: nothing downstream can tell a fabricated signal from a measured one.
        logSessionInfo('cursor_bad_signal_audio_forced', { ...FORCE_BAD_SIGNAL_AUDIO, audioMetrics });
      }

      recordActivitySignalsForNextActivity(audioMetrics, networkHealth);
    } catch (error) {
      // What makes the docblock's "fails closed" true. recordActivitySignalsForNextActivity is the
      // last statement in the try and the only writer of this field, so a throw above it would
      // otherwise leave the PREVIOUS activity's stash standing and the next activity would
      // classify against an activity two back. Both outcomes are sticky with no automatic exit, so
      // stale-by-one is a worse input than unknown -- and while dark it would log a decision row
      // attributed to the wrong activity. Cleared directly rather than through
      // recordActivitySignalsForNextActivity: this path must not depend on the module that threw.
      setUserData('priorActivitySignals', null);
      // userData.activityId, the same field the decision row's identity uses, so the two join.
      logSessionInfo('cursor_bad_signal_stash_failed', {
        error: error?.message || error,
        activityId: getUserData()?.activityId ?? null,
      });
    }
  }

  /**
   * Whether the current activity is a real tutor reading story that should carry TT-1370
   * partial-story-credit progress (phrasesRead / phraseCount).
   *
   * Excludes two non-tutor sessions that also run with assessmentMode === false:
   *  - assessments (assessmentMode), which terminate via handleEndOfAssessment; and
   *  - the ASR-check / Ready Module mic-check path (truthy asrStoryID), which terminates via
   *    markArchived, NOT scoreTutoring. Because those never hit the terminal N/N write, writing
   *    phrase progress for them would leave a non-converging pair that looks exactly like an
   *    abandoned tutor story to any query keyed on these columns.
   *
   * Matches the isTutor definition used elsewhere (story.type === TUTOR && !asrStoryID). Both the
   * per-phrase heartbeat and the terminal scoreTutoring write gate on this so the two stay
   * symmetric: an activity carries these columns iff it can actually earn partial story credit.
   */
  writesPartialStoryCredit(){
    return !this.props.config.assessmentMode
      && !this.props.asrStoryID
      && this.props.story?.type === assignmentTypes.TUTOR;
  }

  async onStoryEnd(skipWaitModal=false){
    try {
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_END });
      this.props.logTimeOnStoryEnd();//Log the time when the story ends
      logSessionInfo("on_story_end", {
        placement_logs: JSON.parse(JSON.stringify(timings)),
        utterance_logs: getUtteranceLogs()
      });
      clearUtteranceLogs();
      if (this.networkMonitoringService) {
        // badNetworkCount is per-activity (resetForNewActivity). Dashboards
        // built on the old session-lifetime meaning will step-change at deploy.
        logSessionInfo("activity_network_health", {
          badCount: this.networkMonitoringService.badNetworkCount,
          activityId: this.state.activityId
        });
      }

      // TT-1344: final story-milestone closing the tutor abandon-rate funnel (see
      // logStoryMilestone for tutor-only / mic-check gating and date pinning).
      this.logStoryMilestone('story_ended.json');

      if(this.props.config.assessmentMode || this.state.testTimeExpired){
        this.handleEndOfAssessment(null, skipWaitModal);
      }else if(this.props.asrStoryID){
        this.updateScoring();
        this.clearTimingVariables();
        this.sendEndOfStoryRecording();
        endEDMSession();
        
        // Determine the display status based on how far the student progressed in the ASR story.
        // Use the captured word index from before onErrorsAreValid modified it.
        let displayStatus;
        const firstPhrase = this.props.story.pages[0][0];
        const firstPhraseLength = cleanAndSplit(firstPhrase).length;
        const wordIndex = this.asrWordIndexAtPhraseEnd !== undefined ? this.asrWordIndexAtPhraseEnd : this.state.currentWordIndex;
        
        if (wordIndex === 0) {
          displayStatus = statusType.NOT_STARTED;
        } else if (wordIndex < firstPhraseLength) {
          displayStatus = statusType.IN_PROGRESS;
        } else {
          displayStatus = statusType.COMPLETED;
        }
        // Fail gracefully if markArchived fails and proceed with the rest of the story end logic for ASR stories
        withTimeout(
          studentRecordService.markArchived(this.state.activityId, displayStatus),
          LOW_VOLUME_CALLS_TIMEOUT,
          'markArchived timeout after 10s'
        ).catch((error) => {
          console.error('Error marking activity as archived:', error);
          logSessionInfo('error_marking_activity_as_archived', {error: error.message, activityId: this.state.activityId});
        });
        
        if(this.props.onEndASRCheck){
          this.props.onEndASRCheck()
        }
      }else{
        this.computeAudioMetrics();
        this.persistAudioNetworkSignals({ fullRefresh: true });

        // TT-991: runs in onStoryEnd's synchronous prefix (nothing above it awaits), so the
        // stash is committed before any later selectStory can read it.
        this.stashLiveActivitySignals(this.props.story);

        //For tutors, calculate metrics to use as a fallback if the backend doesn't score in time for the Status Screen
        const { storyErrors } = this.updateScoring();
        
        // TT-1370 Partial Story Credit: a completed tutor story carries phrasesRead === phraseCount,
        // so send both equal to the chapter's phrase count on this terminal write. Gated on
        // writesPartialStoryCredit() (kept symmetric with the heartbeat); undefined for a non-tutor
        // story so scoreTutoring omits the fields rather than writing a spurious N/N.
        const completedPhraseCount = this.writesPartialStoryCredit() ? getStoryPhraseCount(this.props.story) : undefined;
        // Wrap scoreTutoring in withTimeout
        withTimeout(
          studentRecordService.scoreTutoring(this.state.activityId,storyErrors,getAudioDuration(),this.state.storyInterventions,completedPhraseCount,completedPhraseCount),
          HIGH_VOLUME_CALLS_TIMEOUT,
          'scoreTutoring timeout after 16s'
        ).catch((error) => {
          console.error('Error scoring tutoring:', error);
          logSessionInfo('error_scoring_tutoring', {error: error.message, activityId: this.state.activityId});
        });
        
        let storySkips = [];
        this.state.errors.forEach((page)=>{
          page.forEach((phrase)=>{
            storySkips.push(phrase.skips);
          });
        });

        if(getUserData().iesEnabled) {
          // Setup base data object
          const body = {
            activityId: this.state.activityId,
            iesEnabled: getUserData().iesEnabled,
            audioDuration: getAudioDuration(),
            storySkips: storySkips,
            storyId: this.props.story.storyId,
            storyVersion: this.props.story.version || "1",
            activityType: this.props.story.type,
            storyTitle: this.props.story.title,
            storyPhrases: this.props.story.phrases,
          }

          // Fetch parent portal access key
          try {
            const iesAccessKey = await withTimeout(
              getAccessKeyByStudentId(getUserData().userId),
              LOW_VOLUME_CALLS_TIMEOUT,
              'getAccessKeyByStudentId timeout after 10s'
            );

            // If it exists, attach it
            if (iesAccessKey) {
              const {parentEmail, parentPhone} = iesAccessKey;
              if (parentEmail) {
                body.email = parentEmail;
              } else if (parentPhone) {
                body.email = `${parentPhone}@amira.com`;
              }
            }
          } catch (e) {
            console.log(`[IES] Error getting access key: ${e}`);
            logSessionInfo('error_getting_ies_access_key', {error: e.message, userId: getUserData().userId});
          }

          sendMessageToSqs(SEGMENT_EVENTS.story_completed, body);
        }

        // Use getUserData().activityId instead of this.state.activityId — see STARTED call above.
        const completedActivityId = getUserData().activityId;
        if(this.isEarlyReader() && completedActivityId){
          // Local try / catch block for updateErssStatus to avoid blocking the story end logic as its independent
          withTimeout(
            updateErssStatus(getUserData().userId,completedActivityId,this.props.story.tags,'COMPLETED',this.props.story.storyId),
            LOW_VOLUME_CALLS_TIMEOUT,
            'updateErssStatus timeout after 10s'
          ).catch((error) => {
            console.error('Error updating ERSS status:', error);
            logSessionInfo('error_updating_erss_status', {error: error.message, activityId: completedActivityId, status: 'COMPLETED'});
          });
        }

        logSessionInfo("scored_tutor",{errors: storyErrors});
        logSessionInfo("skips",storySkips);
        this.clearTimingVariables();
        this.sendEndOfStoryRecording();
        endEDMSession();

        if(getUserData().startingEarlyReaderSequence){
          clearEarlyReaderSequenceStart(getUserData().locale);
        }

        //If we have questions to display to the student, do it here
        //Otherwise, skip to the end of story modal.
        if(Array.isArray(this.props.questions) && this.props.questions.length > 0){
          //NOTE this isn't how we do it anymore, this is for backward compatibility
          let modalContent = (
            <Quiz
              speech={this.props.speech}
              questions={this.props.questions}
              readQuestionDefault={true}
              feedbackModeDefault={true}
              onSubmit={this.onSubmitQuiz}
              sendMessage={this.props.sendMessage.bind(this)}
            />
          );
          this.openModalAndStopListening(
            modalContent,
            {
              delayedCloseButton: true,
              close: () => {
                this.props.speech.abortSpeech(this.onSubmitQuiz.bind(this));
              }
            }
          );
        }else{
          this.openWaitModal(this.finalizeTutor);
        }
      }
      this.setState({storyInProgress: false, storyEnded: true});
      
    } catch (error) {
      console.error('Error in onStoryEnd:', error, 'activityId:', this.state.activityId);
      logSessionInfo('story_end_error', {
        error: error.message,
        stack: error.stack,
        timestamp: Date.now(),
        activityId: this.state.activityId
      });
      logSentryException(new Error('Story completion failure'), 'Story completion error', { originalError: error?.message, originalStack: error?.stack });
      // Try to recover gracefully
      this.setState({storyInProgress: false, storyEnded: true});
      this.handleEndOfStoryErrors();
    }
  }

  triggerEndOfPhraseInterventions(type,currentErrorCount,lastWordError,lastWordIndex){
    this.lastEndedPhrase = this.lastEndedPhrase - 1; // Decrement the last ended phrase to the previous phrase since we are redoing the current one
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.INTERVENTION_ON_PHRASE });
    switch(type){
      case interventionType.read:
        this.setIsLoading(false);
        speakInterventionLeadIn(this.props.speech, interventionType.read);
        this.readAloudWithCallback(this.tryAgain.bind(this));
        return true;
        break;
      case interventionType.clap:
        this.setIsLoading(false);
        let wordToUse = "";
        wordToUse = lastWordError.replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()""?!]/g, "");
        this.playRepeatAfterMe(wordToUse,lastWordIndex);
        return true;
        break;
      case interventionType.toofast:
        this.setIsLoading(false);
        // if this is the last phrase of the story, skip this intervention
        // TODO: consider whether this logic should be encapulated within interventionSelection
        if(this.state.currentPhraseIndex === (this.getCurrentPage().length - 1) && this.props.pageIndex == this.props.story.pages.length - 1) {
          return false;
        }
        let props = {};
        props.text = getTooFastPhrases();
        props.callback = (
          function(event){
            this.cleanUpAfterIntervention();
          }
        ).bind(this);

        this.props.sendMessage(props);
        return true;
        break;
      case interventionType.repeatsentence:
        this.setIsLoading(false);
        speakInterventionLeadIn(this.props.speech, interventionType.repeatsentence,lastWordError.replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()""?!]/g, ""));
        this.readAloudWithCallback(() => {
          this.props.speech.speak({textToSpeak: getKeepReading(getStudentReadingLevel), onEnd: this.cleanUpAfterIntervention.bind(this)});
        });
        return true;
      case interventionType.readwithme:
        this.setIsLoading(false);
        this.readWithMe();
        return true;
      case interventionType.initiateReadWithMe:
        this.setIsLoading(false);
        // Don't read with me if this is last phrase
        if (this.props.story && this.props.story.phrases && overallPhraseIndex < this.props.story.phrases.length - 1) {
          this.initiateReadWithMeMode();
          return true;
        } else {
          console.log("Attempted to do initiateReadWithMe, but since this is the last phrase of story, we will skip");
          return false;
        }
      case interventionType.endReadWithMe:
        this.setIsLoading(false);
        // Don't read with me if this is last phrase
        if (this.props.story && this.props.story.phrases && overallPhraseIndex < this.props.story.phrases.length - 1) {
          this.endReadWithMeMode();
          return true;
        } else {
          console.log("Attempted to do endReadWithMe, but since this is the last phrase of story, we will skip");
          return false;
        }
      default:
        return false;
    }
  }

  /**
   * Advance the reader after a pre-modal intervention skip (the chosen intervention
   * bailed before its modal opened because assets/metadata were missing).
   *
   * At end-of-phrase, advancing via skipWord re-enters onPhraseEnd, which the
   * stale-call guard blocks, so onPageEnd never fires and the reader freezes with no
   * results screen (TT-1277 soundSeeker, TT-1284 vocabularyWithPictures, and the
   * earlier syllable-audio case). Use cleanUpAfterIntervention instead
   * (-> callbackAfterIntervention / nextPhrase, which re-arms listening), mirroring the
   * normal intervention-complete path. Off end-of-phrase, skipWord is the correct advance.
   *
   * All three pre-modal skip sites in launchWordIntervention route through here so a new
   * asset-missing branch can't reintroduce the freeze.
   */
  advanceAfterPreModalSkip(endOfPhrase, fromUNKFallback = false){
    if(endOfPhrase){
      this.cleanUpAfterIntervention();
    } else {
      this.skipWord(false, true, false, fromUNKFallback);
    }
  }

  //This method is called after the end of phrase interventions
  // and handles a lot of the housekeeping for cleaning up the intervention
  // state and getting ready for the next phrase (or page)
  cleanUpAfterIntervention(){
    // Tap-to-read: Clear intervention flag BEFORE early return so word-level interventions are covered
    this.clearTapToReadInterventionFlag();
    
    if(!this.state.endOfPhrase){
      return;
    }

    isWordInterventionInProcess = false;

    //Clean up state related to running the clap intervention
    this.setState({
      repeateAfterMeInterventionInProcess: false,
      interventionWordIndex: -1,
      interventionWord: null,
    });
    
    if(this.state.callbackAfterIntervention){
      this.state.callbackAfterIntervention();
    } else {
      this.nextPhrase();
    }
  }

  getClapInterventionComponent(){
    let wordMetadata = this.props.currentWordMetadata;

    if (
      this.props.currentPhraseWordMetadata &&
      this.state.interventionWordIndex > -1
    ) {
      wordMetadata = this.props.currentPhraseWordMetadata[this.state.interventionWordIndex];
    }

    return(
      <RepeatAfterMe
        coachIsReady={this.props.coachIsReady}
        speech={this.props.speech}
        sendMessage={this.props.sendMessage}
        setSpeech={this.props.setSpeech}
        setTranscript={this.props.setTranscript}
        wordToPractice={this.state.interventionWord}
        wordMetadata={wordMetadata}
        stopIntervention={() => {
          if (this.state.endOfPhrase) {
            this.cleanUpAfterIntervention();
          } else {
            this.onInterventionEnd();
          }
        }}
        openModal={this.openModal}
        closeModal={this.props.closeModal}
        readingLevel={getStudentReadingLevel()}
      />
    );
  }

  // Handles grid based responses (Like VisualAttention task)
  setArrayResponse(response, final=false){
    this.startPhraseTimeout(); // start clears the timeout

    let arrayResponse = response ? (response.response || response) : []; 

    let currentResponses = this.state.textResponse; //TODO change this to `textResponses`
    let currentPageResponses = currentResponses[this.props.pageIndex] || [];
    currentPageResponses[this.state.currentPhraseIndex] = JSON.stringify(arrayResponse);
    currentResponses[this.props.pageIndex] = currentPageResponses;

    const expectedText = this.getExpectedArrayResponse();
    let currentErrors = this.state.simpleErrors;
    let currentPageErrors = currentErrors[this.props.pageIndex] || [];
    currentPageErrors[this.state.currentPhraseIndex] = expectedText.length !== arrayResponse.length || expectedText.some((value, index) => value !== arrayResponse[index]);
    currentErrors[this.props.pageIndex] = currentPageErrors;

    this.setState({
      textResponse: currentResponses,
      simpleErrors: currentErrors,
    }, () => {
      if(final){
        this.onPhraseTimeout();
      }
    });
  }

  // Page coordinates, matching every write. Formative testlets put more than one item on a
  // page, where the story-wide overallPhraseIndex the legacy helper uses reads a neighbour.
  getCurrentItemResponse(){
    const page = this.state.textResponse?.[this.props.pageIndex];
    const response = page?.[this.state.currentPhraseIndex];
    return typeof response === 'string' && response !== '' ? response : null;
  }

  setEncodedResponse(keys, final=false){
    this.startPhraseTimeout(); // start clears the timeout

    const encoded = keys || NO_RESPONSE;

    let currentResponses = this.state.textResponse;
    let currentPageResponses = currentResponses[this.props.pageIndex] || [];
    currentPageResponses[this.state.currentPhraseIndex] = encoded;
    currentResponses[this.props.pageIndex] = currentPageResponses;

    this.setState({
      textResponse: currentResponses,
    }, () => {
      if(final){
        this.onPhraseTimeout();
      }
    });
  }

  setTextResponse(response, final=false){
    //every time we update the textresponse, reset the phrase timeout so that we don't time out while the kid is typing
    // NOTE: if we ever start calling setTextResponse for any other reason than input from the child, separate these concerns
    this.startPhraseTimeout(); // start clears the timeout

    response = response || " ";
    // Handle both string responses and object responses with a response property
    let textResponse = (typeof response === 'object' && response.response !== undefined) ? response.response : response;
    let currentResponses = this.state.textResponse; //TODO change this to `textResponses`
    let currentPageResponses = currentResponses[this.props.pageIndex] || [];
    currentPageResponses[this.state.currentPhraseIndex] = textResponse;
    currentResponses[this.props.pageIndex] = currentPageResponses;

    let currentWord = this.getCurrentWord();
    let currentPhrase = this.getCurrentPage()[this.state.currentPhraseIndex];

    // Position-padded comparison for local error highlighting only — keeps word
    // boundaries aligned so punctuation differences don't cascade. Not sent to AOS.
    let cleanResponse = textResponse.replace(/[^a-zA-Z ]/g, "_");
    let cleanCurrentPhrase = currentPhrase.replace(/[^a-zA-Z ]/g, "_");

    let currentErrors = this.state.simpleErrors;
    let currentPageErrors = currentErrors[this.props.pageIndex] || [];
    currentPageErrors[this.state.currentPhraseIndex] = ((currentWord.toLowerCase() != cleanResponse.toLowerCase()) && (cleanCurrentPhrase.toLowerCase() != cleanResponse.toLowerCase()));
    currentErrors[this.props.pageIndex] = currentPageErrors;

    this.setState({
      textResponse: currentResponses,
      simpleErrors: currentErrors,
    }, () => {
      if(final){
        this.onPhraseTimeout();
      }
    });
  }

  setPlacement(index){
    let currentErrors = this.getCurrentPhraseErrors();
    if (currentErrors.length - 1 > index){
      this.props.speech.stopListening();
      this.props.speech.resetTranscript();
      this.props.speech.startListening("setPlacement");
      currentErrors = currentErrors.slice(0, index);
    } else {
      // add errors for skipped words
      let numSkipped = index - currentErrors.length;
      for(let i = 0; i < numSkipped; i++){
        currentErrors.push(true);
      }
    }
    this.setCurrentPhraseErrors(currentErrors);
    // TODO set pause time if this method is ever used again
    this.setState({
      lastProgress: defaultLastProgress,
      currentWordIndex: index,
    });
  }

  setMatchThreshold(event){
    this.setState({
      matchThreshold: event.target.value,
    });
  }

  setPauseLength(event){
    this.setState({
      pauseLength: event.target.value,
    });
  }

  setGiveUpLength(event){
    this.setState({
      giveUpLength: event.target.value,
    });
  }

  isNextPhraseVideo(){
    return this.props.story && this.props.story.items && this.props.story.items[overallPhraseIndex + 1] && this.props.story.items[overallPhraseIndex + 1].type == "video";
  }

  getTestControls(){
    if(this.state.mounted && this.props.isTest){
      return(
        <div className="testControls">
          <div className="displayTranscript"><span className="label">Transcript: </span><span className = "transcript">{this.props.transcript.interim}</span></div>
          <div className="testControlForm">
            <span className="label">Match Threshold: </span>
            <span className="input">
              <input type="text" name="matchThreshold" value={this.state.matchThreshold} onChange={this.setMatchThreshold}/>
            </span>
            <span className="label">Modal Intervention Timeout: </span>
            <span className="input">
              <input type="text" name="modalTimeout" value={this.state.pauseLength} onChange={this.setPauseLength}/>
            </span>
            <span className="label">Simple Intervention Timeout: </span>
            <span className="input">
              <input type="text" name="simpleTimeout" value={this.state.giveUpLength} onChange={this.setGiveUpLength}/>
            </span>
          </div>
        </div>
      );
    }
  }

  getEndAssessmentButton(){
    if(this.props.config.assessmentMode && this.props.story && this.props.orfMode){
      return (
        <div className="endAssessmentButton" {...doNotUseAccessibleStaticElementInteractions({onClick: () => this.handleEndOfAssessment(statusType.ABORTED)})}>
          <div className="iconContainer"><img className="endIcon" src={end_assessment_image} alt="" /></div>
          <div className="buttonText">{COPY_STRINGS.end_assessment}</div>
        </div>
      );
    } else {
      return null;
    }
  }

  setPageNavRestrictedTimeout(){
    this.state.pageNavRestrictedTimeout && window.clearTimeout(this.state.pageNavRestrictedTimeout);
    return (this.props.story && this.props.orfMode && this.props.config.assessmentMode && getUserData().assessmentPageNavEnabled)
      ? window.setTimeout(this.onPageNavRestrictedTimeout.bind(this), 65000) : null;
  }

  onPageNavRestrictedTimeout(){
    logSessionInfo("assessment_page_nav_restricted_timeout_expired", {
      cursorPosition: this.state.currentWordIndex,
      phraseLength: cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length,
      timeStamp: Date.now(),
    });

    window.clearTimeout(this.state.pageNavRestrictedTimeout);
    this.setState({
      pageNavRestrictedTimeout: null,
      pageNavEnabled: true
    });
  }

  onNextPageClick() {
    const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    let phraseErrors = this.getCurrentPhraseErrors();
    //unless they're at the end of a phrase, ignore clicks for 5 seconds after
    //a registerd click to handle users mashing the next button.
    if((phraseErrors.length === cleanPhrase.length && !this.state.pageNavTriggered)
      || !this.state.pageNavLastClick || moment().diff(this.state.pageNavLastClick, 'seconds') >=5){
      this.setState({pageNavLastClick: moment()});

      logSessionInfo("assessment_next_page_clicked", {cursorPosition: this.state.currentWordIndex, phraseLength: cleanPhrase.length, timeStamp: Date.now(),});
      this.setState({pageNavTriggered: true});

      if(phraseErrors.length < cleanPhrase.length){ //reader didn't finish the current page
        this.props.speech.stopListening();

        //pad the errors array to account for the remaining words skipped by the reader
        const paddingErrors = Array(cleanPhrase.length - phraseErrors.length).fill(true);
        phraseErrors = phraseErrors.concat(paddingErrors);
        for(let i=0; i<cleanPhrase.length; i++){
          phraseErrors[i] = this.finalizeError(cleanPhrase[i],phraseErrors[i]);
        }
        this.setCurrentPhraseErrors(phraseErrors);

        if(!this.state.endOfPhrase){
          this.handlePotentialEndOfPhrase();
        }
      }

      const immutablePhraseIndex = Number(overallPhraseIndex);
      this.onPhraseEnd(this.props.speech.isRecording(), immutablePhraseIndex);
    }
  }

  checkPageNavEnabled(){
    const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    let phraseErrors = this.getCurrentPhraseErrors();
    if(phraseErrors.length >= (cleanPhrase.length-5)){
      this.setState({pageNavEnabled: true})
    }
  }

  getRepeatInstructions(){
    let phraseMetaData = this.getCurrentPhraseMetaData();
    if(this.props.skipIntros) return "Skipping Instructions";

    const intro = phraseMetaData.introductions;
    if (
      !this.state.afterIntroVerbalRepeat &&
      intro &&
      intro.repeatable &&
      intro.verbalIntroductions
    ) {
      if (intro.repeatVariation != null && String(intro.repeatVariation).trim() !== '') {
        return intro.repeatVariation;
      }
      const isFirstSession = (this.props.activityIndex || 0) < 2;
      const verbalIntro = isFirstSession ? intro.verbalIntroductions.full : intro.verbalIntroductions.short;
      if (verbalIntro != null && String(verbalIntro).trim() !== '') {
        return verbalIntro;
      }
    }

    if(phraseMetaData.instructions
        && phraseMetaData.instructions.verbalInstructions
        && phraseMetaData.instructions.repeatable){
      const { repeatVariation, verbalInstructions } = phraseMetaData.instructions;
      if (repeatVariation != null && String(repeatVariation).trim() !== '') {
        return repeatVariation;
      }
      const type = phraseMetaData.type;
      if (
        hasStructuredInstructionsForItemType(type)
        && phraseMetaData.writtenInstructions != null
        && String(phraseMetaData.writtenInstructions).trim() !== ''
      ) {
        return phraseMetaData.writtenInstructions;
      }
      return verbalInstructions;
    } else {
      return null;
    }
  }

  getListeningStatusEnabled(){
    const story = this.props.story ? this.props.story : {};
    //TODO: Remove tutor condition when listening indicator is added to assessments (AE-4531)
    return !story.nonAudio
  }

  shouldDisablePictures(){
    let isEarlyReader = isEarlyReaderStory(this.props.story);
    return (this.props.story && (this.props.story.type === "tutor") && (
      (isEarlyReader && !getUserData().sorConfig.enableERPictures) ||
      (!isEarlyReader && !getUserData().sorConfig.enablePracticePictures)
    ));
  }

  handleNetworkStatusChange(oldStatus, newStatus, isAdministrative = false) {
    const isTutor = this.props.story && this.props.story.type == assignmentTypes.TUTOR && !this.props.asrStoryID;
    const handled = shouldHandleNetworkStatusChange({
      isTutor,
      isListening: this.props.speech.isListening,
      newStatus,
      isTapToRead: isTapToReadBehavior(),
      isLocalAsr: isLocalAsrPlacementRouteActive(),
    });

    if (!handled) {
      return;
    }

    if (newStatus === NetworkStatus.Bad) {
      const {
        WCPM,
      } = getUserData();

      const userSpecificReadRateMs = (60 / WCPM) * 1000;

      this.networkMonitoringService.logAnalytics("bad_network_auto_progress_state", {
        userSpecificReadRateMs
      });

      // How quickly we should auto-progress cursor when in bad network state
      const intervalTime = Math.min(Math.max(500, userSpecificReadRateMs), 2400); // WCPM based read rate, with 500ms min and 2400ms max

      badNetworkInterval = setInterval(() => {
        // If we are not yet at the end of the phrase, call skipWord to advance to the next word
        if (!this.state.endOfPhrase) {
          phrasesWithAutoProgressedWords[overallPhraseIndex] = true;

          this.skipWord(
            false, // sayWord
            true, // force
            true, // noError
          );
        }
      }, intervalTime);

      // Wait to enter pauseFromBadNetwork state until we have auto-progressed through 3 words, with a min time of 3000ms and max time of 5000ms
      const badNetworkPauseReadingTimeoutMs = Math.min(Math.max(intervalTime * 3, 3000), 5000);

      badNetworkPauseReadingTimeout = setTimeout(() => {
        if (badNetworkInterval) {
          window.clearInterval(badNetworkInterval);
          badNetworkInterval = undefined;
        }

        this.pauseFromBadNetwork();

        badNetworkPauseReadingTimeout = undefined;
      }, badNetworkPauseReadingTimeoutMs);
    } else {
      // We just entered normal network state

      const shouldRunRecoveryActions = shouldRunNetworkRecoveryActions({
        isListening: this.props.speech.isListening,
        isAdministrative,
      });

      if (badNetworkInterval) {
        if (shouldRunRecoveryActions) {
          this.resumeFromBadNetworkAutoProgress();
        } else {
          window.clearInterval(badNetworkInterval);
          badNetworkInterval = undefined;
        }
      }

      if (badNetworkPauseReadingTimeout) {
        window.clearTimeout(badNetworkPauseReadingTimeout);
        badNetworkPauseReadingTimeout = undefined;
      }

      if (badNetworkRetryPauseTimeout) {
        window.clearTimeout(badNetworkRetryPauseTimeout);
        badNetworkRetryPauseTimeout = undefined;
      }

      if (badNetworkCriticalTimeout) {
        window.clearTimeout(badNetworkCriticalTimeout);
        badNetworkCriticalTimeout = undefined;
      }

      // Cancel the delayed re-startListening scheduled in pauseFromBadNetwork.
      // If recovery lands before it fires (e.g. in-flight acks drain the queue
      // during the pause's not-listening window), letting it fire would restart
      // listening and arm a spurious retry modal ~10s later, after we recovered.
      if (badNetworkPauseListeningTimeout) {
        window.clearTimeout(badNetworkPauseListeningTimeout);
        badNetworkPauseListeningTimeout = undefined;
      }

      // Truth table lives in resolvePausedNormalAction (unit-tested). Resume runs
      // the full recovery (restores phrase timers + mic) for any evidence-based
      // Normal while paused, including the not-listening window; Clear only for an
      // administrative Normal, where another flow already owns the mic.
      switch (resolvePausedNormalAction({
        pausedFromBadNetwork: this.state.pausedFromBadNetwork,
        isAdministrative,
      })) {
        case PausedNormalAction.Resume:
          this.resumeFromBadNetworkPause();
          break;
        case PausedNormalAction.Clear:
          this.setState({ pausedFromBadNetwork: false });
          this.props.closeModal();
          break;
        default:
          break;
      }

      badNetworkNeedsCriticalResponse = false;
    }
  }

  resumeFromBadNetworkAutoProgress() {
    if (badNetworkInterval) {
      window.clearInterval(badNetworkInterval);
      badNetworkInterval = undefined;
    }

    if (!this.state.endOfPhrase) {
      this.props.speech.stopListening("resumeFromBadNetworkAutoProgress", {
        onFinishCallback: () => {
          this.props.speech.startListening();
        }
      });
    }

    this.networkMonitoringService.logAnalytics("bad_network_resume_from_auto_progress_state");
  }

  pauseFromBadNetwork(skipSpeech = false) {
    this.setState({ pausedFromBadNetwork: true }, () => {
      this.openModal(
        <ErrorModal
          type={getErrorModalTypes().PAUSED_FROM_BAD_NETWORK}
          speech={this.props.speech}
          skipSpeech={skipSpeech}
          returnUrl={this.props.returnUrl}
        />,
        { logName: "bad_network_pause_state" }
      );

      this.state.noAudioTimer && window.clearTimeout(this.state.noAudioTimer);
      this.pausePhrase();
      this.props.speech.stopListening("pauseFromBadNetwork");

      // Stay in bad network pause state for at least 5 seconds before listening for good network again. 1 second if we are skipping speech
      badNetworkPauseListeningTimeout = setTimeout(() => {
        badNetworkPauseListeningTimeout = undefined;
        // Start listening to monitor speech queue for return to normal network, but skipCallback so we don't trigger cursor movement in the background
        this.props.speech.startListening(
          "pauseFromBadNetwork", // source
          null, // transcriptRequest, default is null
          true, // skipCallback
        )

        const pauseFailedTimeoutMs = 10000;

        if (!badNetworkNeedsCriticalResponse) {
          // First show normal retry UI
          badNetworkRetryPauseTimeout = setTimeout(() => {
            this.handleRetryBadNetworkPauseState();
            badNetworkRetryPauseTimeout = undefined;
          }, pauseFailedTimeoutMs);
        } else {
          // Then show critical UI if we pass through this code path again
          badNetworkCriticalTimeout = setTimeout(() => {
            this.handleBadNetworkCriticalState();
            badNetworkCriticalTimeout = undefined;
          }, pauseFailedTimeoutMs);
        }
      }, skipSpeech ? 1000 : 5000);
    });

    this.networkMonitoringService.logAnalytics("bad_network_pause_state");
  }

  resumeFromBadNetworkPause() {
    const handleContinueFromBadNetworkPause = () => {
      this.props.closeModal(() => {
        this.props.speech.abortSpeech(() => {
          this.setState({ pausedFromBadNetwork: false }, () => {
            // If there is no pending intervention to launch, resume the normal reading experience (restart the timers we cancelled)
            this.resumePhrase();
            const noAudioTimer = window.setTimeout(this.getPauseCheck(this.state.lastProgress, this.onLongPauseDetected, "resumeFromBadNetworkPause").bind(this), 60000);
            this.setState({noAudioTimer});
            this.props.speech.startListening();
            this.networkMonitoringService.logAnalytics("bad_network_continue_pressed");
          });
        });
      });
    }

    this.props.speech.stopListening("resumeFromBadNetworkPause", {
      onFinishCallback: () => {
        this.networkMonitoringService.setAudioMonitoringActive(false);
        this.props.speech.speak({
          textToSpeak: COPY_STRINGS.resume_from_bad_network_speech,
        });
        this.openModal(
          <ErrorModal
            type={getErrorModalTypes().RESUME_FROM_BAD_NETWORK}
            speech={this.props.speech}
            continue={handleContinueFromBadNetworkPause}
            returnUrl={this.props.returnUrl}
          />,
          { logName: "bad_network_resume_state" }
        );
      }
    });

    this.networkMonitoringService.logAnalytics("bad_network_resume_from_bad_network_pause_state");
  }

  handleRetryBadNetworkPauseState() {
    badNetworkNeedsCriticalResponse = true;
    const handleContinueFromRetryModal = () => {
      this.props.speech.abortSpeech(() => {
        this.networkMonitoringService.logAnalytics("bad_network_try_again_from_retry_modal");
        this.pauseFromBadNetwork(
          true // skipSpeech
        );
      });
    }

    this.props.speech.stopListening("badNetworkCritical", {
      onFinishCallback: () => {
        this.openModal(
          <RetryNetworkReconnectModal
            speech={this.props.speech}
            continue={handleContinueFromRetryModal}
          />,
          { logName: "bad_network_retry_state"}
        );
      }
    });
  }

  handleBadNetworkCriticalState() {
    const handleContinueFromCriticalNetwork = () => {
      this.props.speech.abortSpeech(() => {
        this.networkMonitoringService.logAnalytics("bad_network_try_again_from_critical_pressed");
        this.pauseFromBadNetwork(
          true // skipSpeech
        );
      });
    }

    this.props.speech.stopListening("badNetworkCritical", {
      onFinishCallback: () => {
        this.props.speech.speak({
          textToSpeak: getCopyByGradeband(COPY_STRINGS, 'critical_network_speech'),
        });
        this.openModal(
          <CriticalNetworkModal
            speech={this.props.speech}
            continue={handleContinueFromCriticalNetwork}
          />,
          { logName: "bad_network_critical_state"}
        );
      }
    });

    this.networkMonitoringService.logAnalytics("bad_network_critical_state");
  }

  buildRecordingMeta() {
    let transcript = this.props.transcript.interim;
    if(this.props.transcript.interim){
      transcript = unidecode(this.props.transcript.interim);
    }
    const phraseScore = this.getCurrentPhraseScore();
    const { wcpm } = calculateMostRecentScores(this.state.errors, getAudioDuration());
    
    return {
      transcript: transcript,
      skips: phraseScore.skips,
      confidence: phraseScore.confidence,
      wcpm: wcpm,
      intervention_data: this.getInterventionSelectionV2Params(),
      user_data: this.getUserDataParams(),
    };
  }

  /**
   * Logs cursor-free mode status to activity bucket.
   * Call this after setSessionActivityId to ensure logging goes to correct S3 bucket.
   *
   * gradeBandBypass separates the students who earned cursor-free through the normal
   * ramp from the upper grades placed there directly by TT-1238, so the usage this
   * event is monitored for can be read per population. It comes from the orchestrator's
   * own predicate rather than a grade comparison here, so the log cannot drift from
   * the decision.
   */
  logCursorFreeModeStatus(story) {
    const userData = getUserData();
    const metrics = userData.studentMetrics || { storiesRead: 0, testsTaken: 0 };
    
    if (isCursorFreeBehavior() && story) {
      logSessionInfo('cursor_free_mode_enabled', {
        studentWcpm: userData.WCPM,
        ftueCompleted: hasCursorBehaviorFTUECompleted(CURSOR_BEHAVIOR.CURSOR_FREE),
        isEarlyReader: userData.isEarlyReader || userData.isSpanishEarlyReader,
        storiesRead: metrics.storiesRead,
        testsTaken: metrics.testsTaken,
        actualGrade: userData.actualGrade,
        gradeBandBypass: isCursorFreeGradeBandExempt(userData),
      });
    }
  }

  /**
   * Logs tap-to-read mode status to activity bucket.
   * Call this after setSessionActivityId to ensure logging goes to correct S3 bucket.
   */
  logTapToReadModeStatus(story) {
    const userData = getUserData();
    if (isTapToReadBehavior({ isERSS: this.isERSSStory(story) }) && story) {
      // Compute resolved license value (matches CursorOrchestrator logic)
      const districtTapToReadFlag = userData.enableTapToReadTutor;
      const appSettingsTapToReadFlag = userData.appSettings?.enableTapToReadTutor;
      logSessionInfo('tap_to_read_mode_enabled', {
        studentWcpm: userData.WCPM,
        enableTapToReadTutor_district: districtTapToReadFlag,
        enableTapToReadTutor_appSettings: appSettingsTapToReadFlag,
      });
    }
  }

  // GT-326: writes a bad-signal placement decided at story fetch to SIS, naming this launch's
  // activity as the first one read in the mode. Here rather than at the decision because the
  // activity does not exist until createActivity returns, which both launch paths have just done.
  // Tutor-only, like the decision log, so a placement left pending by a failed tutor launch is never
  // stamped with an assessment or ASR-check activity -- and never with an ERSS story, which keeps
  // the cursor whatever the branch decided and so is not read in the mode.
  persistBadSignalPlacementForStory(story, activityId) {
    if (this.props.asrStoryID || !story || story.type !== assignmentTypes.TUTOR || this.isERSSStory(story)) {
      return;
    }
    persistBadSignalPlacement(activityId);
  }

  /**
   * Logs the bad-signal cursor decision (TT-991) to activity bucket.
   * Call this after setSessionActivityId to ensure logging goes to correct S3 bucket.
   *
   * Fires for every tutor activity, not only when the branch changed something: an event gated
   * on a positive outcome could not tell "signals arrived and classified clean" apart from
   * "signals never arrived", which is the distinction TT-1256/TT-1230/TT-1257 need to close out.
   *
   * This event IS the dark launch's deliverable, so it carries the WHOLE decision: who the row is
   * about, every value each step read, and what came out. Three fields are the point, and they are
   * only separable here — `badSignalBehavior` is the mode the branch chose, `behavior` is the mode
   * the student actually got, and `logOnly` says whether the two were allowed to be the same. In a
   * dark-launched district they disagree by design, and that gap is the measurement: "who would
   * have been sent to cursor-free" is not recoverable from `behavior` alone.
   *
   * `badSignalDecisionSource` answers the second question: 'new' is a student the branch put in a
   * mode off this activity's signals, 'session' is the 2nd+ activity of this page load re-reading
   * the same answer, 'latched' is a stored badSignalAltCursorMode from an earlier LIVE rollout (a dark launch writes none).
   * Counting students in a mode without it double-counts every activity they read.
   *
   * SHAPE: one object per stage — `identity`, `gate`, `steps` (one group per decision step, in the
   * order they ran), `finalDecision`. Grouped rather than flat because the payload is now wide
   * enough that a flat row cannot say which step a value belonged to, and the step is half the
   * meaning: `audio` under `thresholds` is a boundary, `audio` under `priorActivitySignals` is a
   * measurement. A group is ABSENT when its step did not run.
   *
   * THE STEPS ARE TAKEN FROM THE DECISION, NOT RE-READ HERE. CursorOrchestrator records what it
   * actually read; re-deriving it in this method would be a second read of config that can move
   * between activities, and a log that disagrees with the decision it describes is worse than none.
   * That also means no gate-reason field: every gate in resolveBadSignalBehavior is a comparison
   * over values in this payload, so the reason is recoverable from the row, and a second copy of
   * the gate chain written for the log is how the two drift apart.
   */
  logCursorBadSignalDecision(story) {
    if (!isBadSignalCursorEnabled() || this.props.asrStoryID || !story || story.type !== assignmentTypes.TUTOR) {
      return;
    }

    const userData = getUserData();
    const decision = getBadSignalDecision();
    const isERSS = this.isERSSStory(story);

    logSessionInfo('cursor_bad_signal_decision', {
      // Who the row is about. activityId duplicates the S3 key's own folder on purpose, so a row
      // stays self-describing once these are extracted and joined against the student record.
      identity: {
        studentId: userData.userId ?? null,
        activityId: userData.activityId ?? null,
        sessionId: userData.sessionId ?? null,
        districtId: userData.districtId ?? null,
        schoolId: userData.schoolId ?? null,
        storyId: story.storyId ?? story.id ?? null,
        actualGrade: userData.actualGrade ?? null,
      },

      // Which switch opened the branch, whether it was allowed to act, and whether it ran at all.
      // badSignalCursorEnabled mirrors the gate's own precedence -- district license field first,
      // appSettings (district 9999999) as the fallback -- so the row reports the switch that
      // actually opened the branch once districts are enabled at the district level, not just the
      // appSettings copy. notEvaluatedReason names the upstream gate that answered when the branch
      // never ran, so a decisionEvaluated:false row is diagnosable instead of an unexplained hole.
      gate: {
        logOnly: isBadSignalLogOnly(),
        badSignalCursorEnabled: (userData.badSignalCursorEnabled ?? userData.appSettings?.badSignalCursorEnabled) === true,
        decisionEvaluated: Boolean(decision),
        notEvaluatedReason: decision ? null : getBadSignalNotEvaluatedReason(),
      },

      // priorActivitySignals -> thresholds -> classification -> recall -> policy, in that order.
      // null when the branch never ran; a step that did not run has no group.
      steps: decision?.steps ?? null,

      // The throw the branch swallowed to keep the story launching, or null. Without it a failed
      // branch logs decisionEvaluated:true with null steps, null behavior and null
      // notEvaluatedReason -- a row that reads as "ran, had no opinion, for no stated reason",
      // with the cause only in a console.warn nobody collects. Same hole notEvaluatedReason
      // closes for the gates above the branch, on the one path that most needs it.
      decisionError: decision?.error ?? null,

      // What came out, next to the mode the student actually got. In a dark-launched district
      // those two disagree by design, and that gap is the measurement.
      finalDecision: {
        badSignalBehavior: decision?.behavior ?? null,
        badSignalDecisionSource: decision?.source ?? null,
        appliedBehavior: getCursorBehavior({ isERSS }),
        isERSS,
      },
    });
  }

  // Handler called when FTUE completes
  onTutorFTUEComplete() {
    // Note: TutorFTUE component handles marking completion internally
    // (markCursorBehaviorFTUEComplete with CURSOR_BEHAVIOR.CURSOR_FREE or CURSOR_BEHAVIOR.TAP_TO_READ).
    clearShouldShowCursorBehaviorFTUE();

    // Clear the FTUE display
    this.setState({ showingTutorFTUE: false });
    
    // Continue with the stored callback (launchAssignedActivity or launchSelfAssignedActivity)
    if (this.ftueCallback) {
      this.ftueCallback();
      this.ftueCallback = null; // Clear the callback after execution
    }
  }

  render() {
    // Final fallback: Don't render anything if component has been unmounted
    if (!this._isMounted) {
      return null;
    }
    
    const shouldHaveNextPageButton = this.props.story && this.props.orfMode && this.props.config.assessmentMode && getUserData().assessmentPageNavEnabled && this.state.storyLoaded
    
    // Cursor-free mode: derive story context from props at render time -- render runs
    // before componentDidUpdate, so the orchestrator's pushed context can be one story
    // behind on prop-driven story swaps
    const isCursorFree = isCursorFreeBehavior({ isERSS: this.isERSSStory(this.props.story) });
    
    const studentReaderContainerClasses = cx({
      studentReaderContainer: true,
      hidden: !this.state.displayContainer,
      // Only hide the reader during normal pre-checks ASR test (not mid-session tests)
      // Mid-session tests need to show the reader so user can read the test text
      asrCheckReadingActivity: this.isAsrCheckPath
    })

    return (
      <div className={studentReaderContainerClasses}>
        {this.state.isLoading && !isWordInterventionInProcess && !this.state.repeateAfterMeInterventionInProcess && !this.state.showingTutorFTUE && (
          <div className="readerLoadingOverlay">
            <div className="readerLoadingModal">
              <div className="loadingWrapper"><Loading noFill={true}/></div>
              {this.state.lmGraphProgress !== null && (
                <div className="lmGraphProgress">
                  <div className="lmGraphProgressLabel">
                    <span>{`${Math.round(this.state.lmGraphProgress * 100)}%`}</span>
                  </div>
                  <div className="lmGraphProgressTrack">
                    <div className="lmGraphProgressFill" style={{ width: `${Math.round(this.state.lmGraphProgress * 100)}%` }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <ReaderManagerEvents {...{
          readingMode: this.props.config.assessmentMode ? READING_MODES.ASSESSMENT : READING_MODES.TUTOR,
          currentStoryId: this.props.storyId || this.props.asrStoryID,
          currentStory: this.props.story,
          currentStoryLoaded: this.state.storyLoaded,
          currentPhrase: this.state.currentPhraseIndex,
          currentWordsCorrect: this.calculateWordsCorrect(),
          currentWord: this.state.currentWordIndex,
          currentAccuracy: this.state.accuracy,
          storyStarted: this.state.storyStarted,
          storyInProgress: this.state.storyInProgress,
          minTimeElapsed: this.state.minTimeElapsed,
          storyEnded: this.state.storyEnded,
          phraseEnded: this.state.phraseEnded,
          detections: this.state.detections,
          didSaySomething: this.state.didSaySomething,
          earlyReaderMode: getEarlyReaderMode(this.props.story)}}/>
        <Reader
          author={this.props.author}
          phrases={this.getCurrentPage()}
          phraseMetaData={this.getCurrentPhraseMetaData()}
          assessmentMode={this.props.config.assessmentMode}
          phraseWordStylingEnabled={!(this.props.orfMode && this.props.config.assessmentMode && getUserData().assessmentPageNavEnabled)}
          isCursorFree={isCursorFree}
          isTapToRead={isTapToReadBehavior({ isERSS: this.isERSSStory(this.props.story) })}
          onWordTapped={this.onWordTapped}
          repeatInstructions={this.getRepeatInstructions()}
          isNextPhraseVideo={this.isNextPhraseVideo()}
          storyLength={get(this.props, "story.pages.length") || 0}
          storyTitle={this.props.title}
          storyBrand={this.props.brand}
          story={this.props.story}
          isFinal={this.state.isFinal && (this.state.endOfPhrase)}
          scores={this.state.stylingErrors}
          modalOpen={!!this.props.modal}
          endOfPhrase={this.state.endOfPhrase}
          currentWordIndex={this.state.currentWordIndex}
          currentPhraseIndex={this.state.currentPhraseIndex}
          interventionWordIndex={this.state.interventionWordIndex}
          pageIndex={this.props.pageIndex} //TODO: make these arrays one level deeper instead
          setPlacement={this.setPlacement}
          config={this.props.config}
          readyToRead={true}  //###Need to figure out when to trigger this after the "let's read together"
          speech={this.props.speech}
          startPhrase={this.phraseStartCallback}
          nonAudioStartPhrase={this.nonAudioPhraseStartCallback}
          pausePhrase={this.pausePhrase}
          resumePhrase={this.resumePhrase}
          phraseTimeout={this.onPhraseTimeout}
          isListening={this.props.speech.isListening}
          waitingForAsrConnection={this.props.speech.waitingForAsrConnection && this.shouldWaitForAsrConnection()}
          setTextResponse={this.setTextResponse.bind(this)}
          setEncodedResponse={this.setEncodedResponse.bind(this)}
          setArrayResponse={this.setArrayResponse.bind(this)}
          onInstructionEnd={this.resetPhraseTimeout}
          onInstructionStart={this.clearPhraseTimeout}
          sendMessage={this.props.sendMessage}
          onSubmitQuiz={this.onSubmitQuiz}
          listeningStatusEnabled={this.getListeningStatusEnabled()}
          listeningStatusVisible={!this.props.modal && !this.state.repeateAfterMeInterventionInProcess}
          skipIntros={this.props.skipIntros}
          activityIndex={this.props.activityIndex}
          disablePictures={this.shouldDisablePictures()}
          shouldHaveNextPageButton={shouldHaveNextPageButton}
          onNextPageClick={this.onNextPageClick}
          pageNavEnabled={this.state.pageNavEnabled}
          transcript={this.props.transcript}
          isEarlyReader={this.isEarlyReader}
          paused={this.state.paused}
          showNextButton={this.state.showNextButton}
          onNextButtonClick={this.onNextButtonClick}
          handleDefaultPauseDetected={this.handleDefaultPauseDetected}
          doneHandlingPause={this.doneHandlingPause}
          advanceOneWord={this.advanceOneWord}
          setDisableInterventionsForPhrase = {this.setDisableInterventionsForPhrase}
          setAllowFirstWordSkipOnPause = {this.setAllowFirstWordSkipOnPause}
          skipWord = {this.skipWord}
          triggerWordIntervention = {this.calculateScoresAndLaunchWordIntervention}
          screenContentOverride={this.state.readerScreenContentOverride}
          isFirstAssessmentItemOfType={this.state.isFirstAssessmentItemOfType}
          setRecordingProps={() => this.props.speech.setRecordingProps(this.getRecordingProps())}
          shouldUseAOS={this.props.shouldUseAOS}
          configuredToExtendAssessmentTimeout={this.configuredToExtendAssessmentTimeout()}
          assessmentTimeoutExtensionMultiplier={this.getAssessmentTimeoutExtensionMultiplier()}
          onVerbalIntroductionsComplete={() => this.setState({ afterIntroVerbalRepeat: true })}
          showingTutorFTUE={this.state.showingTutorFTUE}
          tutorFTUEComponent={this.state.showingTutorFTUE ? (
            <TutorFTUE
              type={this.tutorFTUEMode}
              speech={this.props.speech}
              onComplete={this.onTutorFTUEComplete}
              variant={getCursorBehaviorFTUEVariant()}
            />
          ) : null}
        />
        {this.getTestControls()}
        {this.state.repeateAfterMeInterventionInProcess &&
          this.getClapInterventionComponent()
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  endingSequence: state.readerManager.contextStates.endingSequence,
});

const mapDispatchToProps = (dispatch) => ({
  clearEndingSequence: (payload) => dispatch(clearEndingSequence(payload)),
  logReaderManagerEvents: (payload) => dispatch(logReaderManagerEvents(payload)),
  updateContextStates: (contextStates) => dispatch(updateContextStates(contextStates)),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withCurrentStoryWordMetadata(ReaderManager)));
